/* eslint-disable */
import { MetricDataTypeEnum } from '@waterly/utils-isomorphic';
import { CanBeAveraged } from '@waterly/utils-isomorphic';
import { TSDataPointValueType } from '@waterly/utils-isomorphic';
import { SystemTypeEnum } from '@waterly/utils-isomorphic';
import { ConstantDataType } from '@waterly/utils-isomorphic';
import { ConstantScope } from '@waterly/utils-isomorphic';
import { OrganizationDateFormat } from '@waterly/utils-isomorphic';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: number;
  /** A country code as defined by ISO 3166-1 alpha-2 */
  CountryCode: string;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: string;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: string;
  /** A Date encoded as a String in ISO format.  e.g., \`2017-03-02\` */
  DateType: string;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: string;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: Record<string, unknown>;
  /** A field whose value is a valid decimal degrees latitude number (53.471): https://en.wikipedia.org/wiki/Latitude */
  Latitude: number;
  LocalTime: string;
  /** A field whose value is a valid decimal degrees longitude number (53.471): https://en.wikipedia.org/wiki/Longitude */
  Longitude: number;
  /** Mime Type. Example: 'image/png' or 'application/pdf' */
  MimeType: string;
  /** A field whose value exists in the standard IANA Time Zone Database: https://www.iana.org/time-zones */
  TimeZone: string;
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: number;
  /** A Timestamp encoded as a String in ISO8601 format, e.g., \`2010-03-17T13:33:02.123Z\` */
  TimestampType: string;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: string;
};

export type ActiveMetricStats = {
  __typename?: 'ActiveMetricStats';
  metricCalculationCount: Scalars['Int'];
  metricCount: Scalars['Int'];
  metricDataWaterlyConnectCount: Scalars['Int'];
};

export type ActiveMetricStatsInput = {
  fromDate: Scalars['DateTime'];
  organizationId: Scalars['Int'];
  toDate: Scalars['DateTime'];
};

export type ActiveUserDetailsInput = {
  fromDate: Scalars['DateTime'];
  organizationId: Scalars['Int'];
  toDate: Scalars['DateTime'];
};

export type ActiveUserStats = {
  __typename?: 'ActiveUserStats';
  activeUserCount: Scalars['Int'];
  userCount: Scalars['Int'];
  users: Array<UserStats>;
};

export type ActivitySchedule = {
  __typename?: 'ActivitySchedule';
  activityScheduleTypeId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  defaultAssignee?: Maybe<UserNest>;
  defaultAssigneeId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exDates?: Maybe<Array<Scalars['DateTime']>>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBeforeUnit?: Maybe<DurationUnit>;
  notBeforeValue?: Maybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  rDates?: Maybe<Array<Scalars['DateTime']>>;
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetBeforeUnit?: Maybe<DurationUnit>;
  targetBeforeValue?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ActivityScheduleAddInput = {
  activityScheduleTypeId?: InputMaybe<Scalars['UUID']>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type ActivityScheduleCancelInput = {
  endDate: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export type ActivityScheduleUpdateInput = {
  activityScheduleTypeId?: InputMaybe<Scalars['String']>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired?: InputMaybe<Scalars['Boolean']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  rrule?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ActivityScheduleWithCount = {
  __typename?: 'ActivityScheduleWithCount';
  count: Scalars['Int'];
  items: Array<ActivitySchedule>;
};

export type ActivitySchedulesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ActivitySchedulesWhere>;
};

export type ActivitySchedulesWhere = {
  activityScheduleTypeId?: InputMaybe<Scalars['String']>;
  defaultAssigneeId?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  siteId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AddEdgeDeviceNestInput = {
  deviceName: Scalars['String'];
  deviceType: EdgeDeviceTypeNest;
  organizationId: Scalars['Int'];
};

export type AddLicenseInput = {
  authority: Scalars['String'];
  licenseLabel: Scalars['String'];
  licenseNumber: Scalars['String'];
  userId: Scalars['Int'];
};

export type AddPhoneNumberInput = {
  country: Scalars['CountryCode'];
  phoneNumber: Scalars['String'];
  userId: Scalars['Int'];
};

export type AddSsoUserToSystemGroupInput = {
  role: SystemGroupRoleEnum;
  ssoUserId: Scalars['String'];
  systemGroupId: Scalars['Int'];
};

export type AddSampleSiteUploadInput = {
  sampleSiteId: Scalars['UUID'];
  uploadId: Scalars['UUID'];
};

export type AddScheduledItemUploadInput = {
  scheduledItemId: Scalars['UUID'];
  uploadId: Scalars['UUID'];
};

export type AddSiteFlexMetricsToFolderInput = {
  folderId?: InputMaybe<Scalars['UUID']>;
  metricIds: Array<Scalars['Int']>;
  siteId: Scalars['Int'];
};

export type AddSiteInput = {
  emoji?: InputMaybe<Scalars['String']>;
  flex?: InputMaybe<Scalars['Boolean']>;
  isEntry?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Latitude']>;
  longitude?: InputMaybe<Scalars['Longitude']>;
  name: Scalars['String'];
  /** NPDES Permit Number - National permists searchable at https://www.epa.gov/npdes-permits */
  npdesPermitNumber?: InputMaybe<Scalars['String']>;
  siteType?: InputMaybe<SiteTypeEnum>;
  systemId: Scalars['Int'];
};

export type AddSsoUserToSystemTypeInput = {
  role: SystemRoleType;
  ssoUserId: Scalars['String'];
  systemId: Scalars['Int'];
};

export type AddSystemFavoriteInput = {
  id: Scalars['Int'];
};

export type AddSystemGroupInput = {
  name: Scalars['String'];
  parentSystemGroupId: Scalars['Int'];
};

export type AddTagMappingInput = {
  edgeDeviceId: Scalars['Int'];
  metricId: Scalars['Int'];
  tagName: Scalars['String'];
};

export type AddTrendInput = {
  isGlobal?: Scalars['Boolean'];
  keynameFilters?: InputMaybe<Array<Scalars['String']>>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['String'];
  systemId?: InputMaybe<Scalars['Int']>;
  systemType?: InputMaybe<SystemTypeEnum>;
};

export type AddUserToSystemGroupInput = {
  email: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
};

export type AddUserToSystemInput = {
  role: SystemRoleType;
  systemId: Scalars['Int'];
  userEmail: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  label?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  purpose: AddressPurpose;
  recipientName?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export enum AddressPurpose {
  Billing = 'BILLING',
  Both = 'BOTH',
  Shipping = 'SHIPPING'
}

export type AdjacentEntryIntervalInput = {
  date: Scalars['Date'];
  direction: NavigationDirection;
  siteId: Scalars['Int'];
  time: Scalars['String'];
};

export type AdminStats = {
  __typename?: 'AdminStats';
  numberOfMetrics: Scalars['Int'];
  numberOfSites: Scalars['Int'];
  numberOfStates: Scalars['Int'];
  numberOfSystems: Scalars['Int'];
  numberOfUsers: Scalars['Int'];
};

export type Analyte = {
  __typename?: 'Analyte';
  analyteType: AnalyteType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type AnalyteGroup = {
  __typename?: 'AnalyteGroup';
  analytes: Array<Analyte>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type AnalyteGroupCreateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AnalyteGroupUpdateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type AnalyteGroupsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnalyteGroupsWhere>;
};

export type AnalyteGroupsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AnalyteGroupsWithCount = {
  __typename?: 'AnalyteGroupsWithCount';
  count: Scalars['Int'];
  items: Array<AnalyteGroup>;
};

export enum AnalyteType {
  Field = 'FIELD',
  Lab = 'LAB'
}

export type AnalytesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnalytesWhere>;
};

export type AnalytesWhere = {
  analyteType?: InputMaybe<AnalyteType>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['UUID']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type AnalytesWithCount = {
  __typename?: 'AnalytesWithCount';
  count: Scalars['Int'];
  items: Array<Analyte>;
};

export enum AnalyticsReportRunMode {
  DbConfig = 'DbConfig',
  RepoConfig = 'RepoConfig'
}

export enum ApiTokenCapabilityPreset {
  Export = 'EXPORT',
  Ingestion = 'INGESTION',
  ReadOnly = 'READ_ONLY',
  Superadmin = 'SUPERADMIN'
}

export type ApiTokenNest = {
  __typename?: 'ApiTokenNest';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['Int'];
  lastUsedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  realm: Scalars['String'];
  revokedAt?: Maybe<Scalars['DateTime']>;
  scopes: Array<ApiTokenScope>;
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export enum ApiTokenScope {
  AdminAll = 'AdminAll',
  DataModelRead = 'DataModelRead',
  DataPointsRead = 'DataPointsRead',
  DataPointsWrite = 'DataPointsWrite',
  ExportsRead = 'ExportsRead',
  ExportsWrite = 'ExportsWrite',
  OrganizationRead = 'OrganizationRead',
  ReportsRead = 'ReportsRead'
}

export type ApiTokensByOrganizationInput = {
  organizationId: Scalars['Int'];
};

export type ArchiveConstantDefinitionInput = {
  id: Scalars['Int'];
};

export type ArchiveConstantValueInput = {
  id: Scalars['Int'];
};

export type ArchiveReportDistributionListInput = {
  id: Scalars['UUID'];
};

export type ArchiveReportingReportGroupInput = {
  id: Scalars['Int'];
};

export type ArchiveSampleScheduleInput = {
  id: Scalars['UUID'];
};

export type ArchiveSampleSiteUploadInput = {
  sampleSiteId: Scalars['UUID'];
};

export type ArchiveScheduledItemCommentInput = {
  id: Scalars['UUID'];
};

export type ArchiveScheduledItemUploadInput = {
  scheduledItemId: Scalars['UUID'];
};

export type ArchiveScheduledItemsInput = {
  ids: Array<Scalars['UUID']>;
};

export type ArchiveUploadInput = {
  id: Scalars['UUID'];
};

export enum AssetsEntityType {
  Asset = 'Asset',
  Facility = 'Facility',
  System = 'System'
}

export type AuditEventFindOneInput = {
  where?: InputMaybe<AuditEventsWhere>;
};

export type AuditEventNest = {
  __typename?: 'AuditEventNest';
  activitySchedule?: Maybe<ActivitySchedule>;
  appliedAtWithTimeZone?: Maybe<Scalars['DateTime']>;
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  event: Scalars['JSON'];
  id: Scalars['ID'];
  itemId?: Maybe<Scalars['String']>;
  itemType?: Maybe<AuditItemType>;
  metric?: Maybe<MetricNest>;
  metricId?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId?: Maybe<Scalars['Int']>;
  rolledBackAt?: Maybe<Scalars['DateTime']>;
  scheduledItem?: Maybe<ScheduledItem>;
  site?: Maybe<SiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  system?: Maybe<SystemNest>;
  systemId?: Maybe<Scalars['Int']>;
  timestamp: Scalars['Timestamp'];
  type: AuditEventType;
  user: UserNest;
  userId: Scalars['Int'];
  version: AuditEventVersion;
};

export type AuditEventSubscriptionInput = {
  organizationId: Scalars['Int'];
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  types?: InputMaybe<Array<AuditEventType>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum AuditEventType {
  ActivityScheduleArchivedEvent = 'ActivityScheduleArchivedEvent',
  ActivityScheduleChangedEvent = 'ActivityScheduleChangedEvent',
  ActivityScheduleCreatedEvent = 'ActivityScheduleCreatedEvent',
  AddressArchivedEvent = 'AddressArchivedEvent',
  AddressChangedEvent = 'AddressChangedEvent',
  AddressCreatedEvent = 'AddressCreatedEvent',
  ComponentArchivedEvent = 'ComponentArchivedEvent',
  ComponentChangedEvent = 'ComponentChangedEvent',
  ComponentCreatedEvent = 'ComponentCreatedEvent',
  ConstantDefinitionArchivedEvent = 'ConstantDefinitionArchivedEvent',
  ConstantDefinitionChangedEvent = 'ConstantDefinitionChangedEvent',
  ConstantDefinitionCreatedEvent = 'ConstantDefinitionCreatedEvent',
  ConstantRecalculationSubmittedEvent = 'ConstantRecalculationSubmittedEvent',
  ConstantValueArchivedEvent = 'ConstantValueArchivedEvent',
  ConstantValueChangedEvent = 'ConstantValueChangedEvent',
  ConstantValueCreatedEvent = 'ConstantValueCreatedEvent',
  DataEntryCompletionArchivedEvent = 'DataEntryCompletionArchivedEvent',
  DataEntryCompletionChangedEvent = 'DataEntryCompletionChangedEvent',
  DataEntryCompletionCreatedEvent = 'DataEntryCompletionCreatedEvent',
  DataPointChangedEvent = 'DataPointChangedEvent',
  DataPointChangedOnKeyMetricEvent = 'DataPointChangedOnKeyMetricEvent',
  EnterpriseReportArchivedEvent = 'EnterpriseReportArchivedEvent',
  EnterpriseReportChangedEvent = 'EnterpriseReportChangedEvent',
  EnterpriseReportCreatedEvent = 'EnterpriseReportCreatedEvent',
  EnterpriseReportShareLinkArchivedEvent = 'EnterpriseReportShareLinkArchivedEvent',
  EnterpriseReportShareLinkChangedEvent = 'EnterpriseReportShareLinkChangedEvent',
  EnterpriseReportShareLinkCreatedEvent = 'EnterpriseReportShareLinkCreatedEvent',
  FolderArchivedEvent = 'FolderArchivedEvent',
  FolderChangedEvent = 'FolderChangedEvent',
  FolderCreatedEvent = 'FolderCreatedEvent',
  IntervalArchivedEvent = 'IntervalArchivedEvent',
  IntervalChangedEvent = 'IntervalChangedEvent',
  IntervalCreatedEvent = 'IntervalCreatedEvent',
  LabImportBatchArchivedEvent = 'LabImportBatchArchivedEvent',
  LabImportBatchChangedEvent = 'LabImportBatchChangedEvent',
  LabImportBatchCreatedEvent = 'LabImportBatchCreatedEvent',
  LabImportProfileArchivedEvent = 'LabImportProfileArchivedEvent',
  LabImportProfileChangedEvent = 'LabImportProfileChangedEvent',
  LabImportProfileCreatedEvent = 'LabImportProfileCreatedEvent',
  LogBookEntryArchivedEvent = 'LogBookEntryArchivedEvent',
  LogBookEntryChangedEvent = 'LogBookEntryChangedEvent',
  LogBookEntryCreatedEvent = 'LogBookEntryCreatedEvent',
  MetricArchivedEvent = 'MetricArchivedEvent',
  MetricChangedEvent = 'MetricChangedEvent',
  MetricCreatedEvent = 'MetricCreatedEvent',
  OrganizationChangedEvent = 'OrganizationChangedEvent',
  OrganizationCreatedEvent = 'OrganizationCreatedEvent',
  PermitArchivedEvent = 'PermitArchivedEvent',
  PermitChangedEvent = 'PermitChangedEvent',
  PermitCreatedEvent = 'PermitCreatedEvent',
  PhraseArchivedEvent = 'PhraseArchivedEvent',
  PhraseChangedEvent = 'PhraseChangedEvent',
  PhraseCreatedEvent = 'PhraseCreatedEvent',
  ProcessArchivedEvent = 'ProcessArchivedEvent',
  ProcessChangedEvent = 'ProcessChangedEvent',
  ProcessCreatedEvent = 'ProcessCreatedEvent',
  ReportChangedEvent = 'ReportChangedEvent',
  ReportDefinitionArchivedEvent = 'ReportDefinitionArchivedEvent',
  ReportDefinitionChangedEvent = 'ReportDefinitionChangedEvent',
  ReportDefinitionCreatedEvent = 'ReportDefinitionCreatedEvent',
  ReportSnapshotArchivedEvent = 'ReportSnapshotArchivedEvent',
  ReportSnapshotChangedEvent = 'ReportSnapshotChangedEvent',
  ReportSnapshotCreatedEvent = 'ReportSnapshotCreatedEvent',
  ReportTemplateChangedEvent = 'ReportTemplateChangedEvent',
  ReportTemplateCreatedEvent = 'ReportTemplateCreatedEvent',
  RollbackEvent = 'RollbackEvent',
  SampleScheduleArchivedEvent = 'SampleScheduleArchivedEvent',
  SampleScheduleChangedEvent = 'SampleScheduleChangedEvent',
  SampleScheduleCreatedEvent = 'SampleScheduleCreatedEvent',
  ScheduledItemArchivedEvent = 'ScheduledItemArchivedEvent',
  ScheduledItemChangedEvent = 'ScheduledItemChangedEvent',
  ScheduledItemCommentArchivedEvent = 'ScheduledItemCommentArchivedEvent',
  ScheduledItemCommentChangedEvent = 'ScheduledItemCommentChangedEvent',
  ScheduledItemCommentCreatedEvent = 'ScheduledItemCommentCreatedEvent',
  ScheduledItemCreatedEvent = 'ScheduledItemCreatedEvent',
  SiteArchivedEvent = 'SiteArchivedEvent',
  SiteChangedEvent = 'SiteChangedEvent',
  SiteCreatedEvent = 'SiteCreatedEvent',
  SiteFlexMetricArchivedEvent = 'SiteFlexMetricArchivedEvent',
  SiteFlexMetricChangedEvent = 'SiteFlexMetricChangedEvent',
  SiteFlexMetricCreatedEvent = 'SiteFlexMetricCreatedEvent',
  SystemArchivedEvent = 'SystemArchivedEvent',
  SystemChangedEvent = 'SystemChangedEvent',
  SystemCreatedEvent = 'SystemCreatedEvent',
  TagMappingArchivedEvent = 'TagMappingArchivedEvent',
  TagMappingCreatedEvent = 'TagMappingCreatedEvent',
  TrendArchivedEvent = 'TrendArchivedEvent',
  TrendChangedEvent = 'TrendChangedEvent',
  TrendCreatedEvent = 'TrendCreatedEvent',
  UserAddedToSystemEvent = 'UserAddedToSystemEvent',
  UserAddedToSystemGroupEvent = 'UserAddedToSystemGroupEvent',
  UserChangedEvent = 'UserChangedEvent',
  UserCreatedEvent = 'UserCreatedEvent',
  UserLicenseArchivedEvent = 'UserLicenseArchivedEvent',
  UserLicenseChangedEvent = 'UserLicenseChangedEvent',
  UserLicenseCreatedEvent = 'UserLicenseCreatedEvent',
  UserPermissionToSystemChangedEvent = 'UserPermissionToSystemChangedEvent',
  UserPermissionToSystemGroupChangedEvent = 'UserPermissionToSystemGroupChangedEvent',
  UserPhoneNumberArchivedEvent = 'UserPhoneNumberArchivedEvent',
  UserPhoneNumberChangedEvent = 'UserPhoneNumberChangedEvent',
  UserPhoneNumberCreatedEvent = 'UserPhoneNumberCreatedEvent',
  UserRemovedFromSystemEvent = 'UserRemovedFromSystemEvent',
  UserRemovedFromSystemGroupEvent = 'UserRemovedFromSystemGroupEvent'
}

export enum AuditEventVersion {
  V1 = 'v1',
  V2 = 'v2'
}

export type AuditEventWithCount = {
  __typename?: 'AuditEventWithCount';
  count: Scalars['Int'];
  items: Array<AuditEventNest>;
};

export type AuditEventsByItemTypeAndItemId = {
  itemId: Scalars['String'];
  itemType: AuditItemType;
  orgId: Scalars['Int'];
};

export type AuditEventsByMetricIdInput = {
  endDate: Scalars['DateTime'];
  hideNonValueUpdates?: InputMaybe<Scalars['Boolean']>;
  metricId: Scalars['Int'];
  skip: Scalars['Int'];
  startDate: Scalars['DateTime'];
  systemId: Scalars['Int'];
  take: Scalars['Int'];
};

export type AuditEventsByScheduledItemIdInput = {
  id: Scalars['UUID'];
  systemId: Scalars['Int'];
};

export type AuditEventsInput = {
  componentIds?: InputMaybe<Array<Scalars['Int']>>;
  direction?: InputMaybe<OrderDirectionsNest>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  hideNonValueUpdates?: InputMaybe<Scalars['Boolean']>;
  includeWaterlyConnectEvents?: InputMaybe<Scalars['Boolean']>;
  itemIds?: InputMaybe<Array<Scalars['String']>>;
  itemTypes?: InputMaybe<Array<AuditItemType>>;
  lastAuditEventId?: InputMaybe<Scalars['String']>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  organizationId: Scalars['Int'];
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  skip: Scalars['Int'];
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  take?: InputMaybe<Scalars['Int']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<AuditEventType>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type AuditEventsWhere = {
  componentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  itemId?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<AuditItemType>;
  metricId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<AuditEventType>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum AuditItemType {
  ActivitySchedule = 'ACTIVITY_SCHEDULE',
  Address = 'ADDRESS',
  Component = 'COMPONENT',
  ConstantDefinition = 'CONSTANT_DEFINITION',
  ConstantValue = 'CONSTANT_VALUE',
  DataEntryCompletion = 'DATA_ENTRY_COMPLETION',
  DataPoint = 'DATA_POINT',
  EnterpriseReport = 'ENTERPRISE_REPORT',
  EnterpriseReportShareLink = 'ENTERPRISE_REPORT_SHARE_LINK',
  Folder = 'FOLDER',
  Interval = 'INTERVAL',
  LabImportBatch = 'LAB_IMPORT_BATCH',
  LabImportProfile = 'LAB_IMPORT_PROFILE',
  LogBookEntry = 'LOG_BOOK_ENTRY',
  Metric = 'METRIC',
  Organization = 'ORGANIZATION',
  Permit = 'PERMIT',
  Phrase = 'PHRASE',
  Process = 'PROCESS',
  ReportDefinition = 'REPORT_DEFINITION',
  ReportSnapshot = 'REPORT_SNAPSHOT',
  ReportTemplate = 'REPORT_TEMPLATE',
  Rollback = 'ROLLBACK',
  SampleSchedule = 'SAMPLE_SCHEDULE',
  ScheduledItem = 'SCHEDULED_ITEM',
  ScheduledItemComment = 'SCHEDULED_ITEM_COMMENT',
  Site = 'SITE',
  SiteFlexMetric = 'SITE_FLEX_METRIC',
  System = 'SYSTEM',
  TagMapping = 'TAG_MAPPING',
  Trend = 'TREND',
  User = 'USER',
  UserLicense = 'USER_LICENSE',
  UserPermission = 'USER_PERMISSION',
  UserPhoneNumber = 'USER_PHONE_NUMBER'
}

export type BaseFolder = {
  __typename?: 'BaseFolder';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  default: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type BaseSchedule = {
  __typename?: 'BaseSchedule';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  defaultAssignee?: Maybe<UserNest>;
  defaultAssigneeId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exDates?: Maybe<Array<Scalars['DateTime']>>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBeforeUnit?: Maybe<DurationUnit>;
  notBeforeValue?: Maybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  rDates?: Maybe<Array<Scalars['DateTime']>>;
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetBeforeUnit?: Maybe<DurationUnit>;
  targetBeforeValue?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum BulkMetricEditorBooleanFilter {
  False = 'False',
  True = 'True'
}

export enum BulkMetricEditorColumn {
  CalculationName = 'CalculationName',
  ComponentKeyname = 'ComponentKeyname',
  ComponentName = 'ComponentName',
  CopyPreviousValueEnabled = 'CopyPreviousValueEnabled',
  DataPointCommentPolicy = 'DataPointCommentPolicy',
  DataType = 'DataType',
  Expression = 'Expression',
  HasIntervals = 'HasIntervals',
  HideFromDataEntry = 'HideFromDataEntry',
  Interpolated = 'Interpolated',
  IsLockedByWaterly = 'IsLockedByWaterly',
  IsReportComments = 'IsReportComments',
  Keyname = 'Keyname',
  Limits = 'Limits',
  MetricId = 'MetricId',
  MetricRangeType = 'MetricRangeType',
  Name = 'Name',
  NotificationEnabled = 'NotificationEnabled',
  Order = 'Order',
  OrganizationName = 'OrganizationName',
  Precision = 'Precision',
  ProcessKeyname = 'ProcessKeyname',
  ProcessName = 'ProcessName',
  RangeMax = 'RangeMax',
  RangeMin = 'RangeMin',
  ReportAggregations = 'ReportAggregations',
  Required = 'Required',
  SiteName = 'SiteName',
  SiteType = 'SiteType',
  SystemName = 'SystemName',
  SystemType = 'SystemType',
  Units = 'Units'
}

export type BulkMetricEditorCompositeFilterInput = {
  presence?: InputMaybe<BulkMetricEditorCompositePresenceFilter>;
};

export enum BulkMetricEditorCompositePresenceFilter {
  Configured = 'Configured',
  NotConfigured = 'NotConfigured'
}

export enum BulkMetricEditorCsvExportStatus {
  Ready = 'Ready',
  TooLarge = 'TooLarge'
}

export type BulkMetricEditorEntityFilterOption = {
  __typename?: 'BulkMetricEditorEntityFilterOption';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BulkMetricEditorEntityMultiselectFilterInput = {
  ids: Array<Scalars['Int']>;
  includeNullValues?: InputMaybe<Scalars['Boolean']>;
};

export type BulkMetricEditorFilterOptions = {
  __typename?: 'BulkMetricEditorFilterOptions';
  calculationNames: Array<Scalars['String']>;
  componentKeynames: Array<Scalars['String']>;
  components: Array<BulkMetricEditorEntityFilterOption>;
  copyPreviousValueEnabled: Array<Scalars['Boolean']>;
  dataPointCommentPolicies: Array<DataPointCommentPolicy>;
  dataTypes: Array<MetricDataTypeEnum>;
  expressions: Array<Scalars['String']>;
  hasIntervals: Array<Scalars['Boolean']>;
  hideFromDataEntry: Array<Scalars['Boolean']>;
  interpolated: Array<Scalars['Boolean']>;
  isLockedByWaterly: Array<Scalars['Boolean']>;
  isReportComments: Array<Scalars['Boolean']>;
  keynames: Array<Scalars['String']>;
  limits: Array<BulkMetricEditorCompositePresenceFilter>;
  metricRangeTypes: Array<MetricRangeType>;
  notificationEnabled: Array<Scalars['Boolean']>;
  organizations: Array<BulkMetricEditorEntityFilterOption>;
  processKeynames: Array<Scalars['String']>;
  processes: Array<BulkMetricEditorEntityFilterOption>;
  reportAggregations: Array<BulkMetricEditorCompositePresenceFilter>;
  required: Array<Scalars['Boolean']>;
  siteTypes: Array<Scalars['String']>;
  sites: Array<BulkMetricEditorEntityFilterOption>;
  systemTypes: Array<Scalars['String']>;
  systems: Array<BulkMetricEditorEntityFilterOption>;
  units: Array<Scalars['String']>;
};

export type BulkMetricEditorLimitsSummary = {
  __typename?: 'BulkMetricEditorLimitsSummary';
  belowReportingLimitValue?: Maybe<Scalars['Float']>;
  configured: Scalars['Boolean'];
  detectionLimit?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  treatBelowReportingLimitAsPercent: Scalars['Boolean'];
};

export type BulkMetricEditorMetricRangeTypeFilterInput = {
  includeNullValues?: InputMaybe<Scalars['Boolean']>;
  values: Array<MetricRangeType>;
};

export type BulkMetricEditorMetrics = {
  __typename?: 'BulkMetricEditorMetrics';
  filteredCount: Scalars['Int'];
  items: Array<BulkMetricEditorRow>;
  totalCount: Scalars['Int'];
};

export type BulkMetricEditorMetricsCsvExport = {
  __typename?: 'BulkMetricEditorMetricsCsvExport';
  contentType: Scalars['String'];
  csv?: Maybe<Scalars['String']>;
  downloadUrl?: Maybe<Scalars['String']>;
  filename: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  rowCount: Scalars['Int'];
  status: BulkMetricEditorCsvExportStatus;
};

export type BulkMetricEditorMetricsCsvExportInput = {
  columnsToInclude: Array<BulkMetricEditorColumn>;
  filter?: InputMaybe<BulkMetricEditorMetricsFilterInput>;
  orderBy?: InputMaybe<Array<BulkMetricEditorOrderByInput>>;
};

export type BulkMetricEditorMetricsFilterInput = {
  calculationName?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  componentKeynames?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  components?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  copyPreviousValueEnabled?: InputMaybe<BulkMetricEditorBooleanFilter>;
  dataPointCommentPolicies?: InputMaybe<Array<DataPointCommentPolicy>>;
  dataTypes?: InputMaybe<Array<MetricDataTypeEnum>>;
  decimalPlaces?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  expression?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  globalSearch?: InputMaybe<Scalars['String']>;
  hasIntervals?: InputMaybe<BulkMetricEditorBooleanFilter>;
  hideFromDataEntry?: InputMaybe<BulkMetricEditorBooleanFilter>;
  interpolated?: InputMaybe<BulkMetricEditorBooleanFilter>;
  isLockedByWaterly?: InputMaybe<BulkMetricEditorBooleanFilter>;
  isReportComments?: InputMaybe<BulkMetricEditorBooleanFilter>;
  keyname?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  limits?: InputMaybe<BulkMetricEditorCompositeFilterInput>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  metricName?: InputMaybe<BulkMetricEditorStringFuzzySearchInput>;
  metricRangeTypes?: InputMaybe<BulkMetricEditorMetricRangeTypeFilterInput>;
  notificationEnabled?: InputMaybe<BulkMetricEditorBooleanFilter>;
  order?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  organizations?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  processKeynames?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  processes?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  rangeMax?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  rangeMin?: InputMaybe<BulkMetricEditorNumberRangeFilterInput>;
  reportAggregations?: InputMaybe<BulkMetricEditorCompositeFilterInput>;
  required?: InputMaybe<BulkMetricEditorBooleanFilter>;
  siteTypes?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  sites?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  systemTypes?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
  systems?: InputMaybe<BulkMetricEditorEntityMultiselectFilterInput>;
  units?: InputMaybe<BulkMetricEditorMultiselectFilterInput>;
};

export type BulkMetricEditorMetricsInput = {
  filter?: InputMaybe<BulkMetricEditorMetricsFilterInput>;
  orderBy?: InputMaybe<Array<BulkMetricEditorOrderByInput>>;
  page: BulkMetricEditorPageInput;
};

export type BulkMetricEditorMultiselectFilterInput = {
  includeNullValues?: InputMaybe<Scalars['Boolean']>;
  values: Array<Scalars['String']>;
};

export type BulkMetricEditorNumberRangeFilterInput = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type BulkMetricEditorOrderByInput = {
  direction: OrderDirectionsNest;
  field: BulkMetricEditorColumn;
};

export type BulkMetricEditorPageInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type BulkMetricEditorReportAggregationSummary = {
  __typename?: 'BulkMetricEditorReportAggregationSummary';
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  configured: Scalars['Boolean'];
};

export type BulkMetricEditorRow = {
  __typename?: 'BulkMetricEditorRow';
  calculationName?: Maybe<Scalars['String']>;
  componentKeyname?: Maybe<Scalars['String']>;
  componentName?: Maybe<Scalars['String']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  expression?: Maybe<Scalars['String']>;
  hasIntervals: Scalars['Boolean'];
  hideFromDataEntry: Scalars['Boolean'];
  interpolated: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  keyname?: Maybe<Scalars['String']>;
  limits: BulkMetricEditorLimitsSummary;
  metricId: Scalars['Int'];
  metricRangeType?: Maybe<MetricRangeType>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  organizationName: Scalars['String'];
  precision?: Maybe<Scalars['Int']>;
  processKeyname?: Maybe<Scalars['String']>;
  processName: Scalars['String'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportAggregations: BulkMetricEditorReportAggregationSummary;
  required: Scalars['Boolean'];
  siteId: Scalars['Int'];
  siteName: Scalars['String'];
  siteType: Scalars['String'];
  systemId: Scalars['Int'];
  systemName: Scalars['String'];
  systemType: Scalars['String'];
  units?: Maybe<Scalars['String']>;
};

export type BulkMetricEditorStringFuzzySearchInput = {
  searchValue: Scalars['String'];
};

export type CalcClusterDebug = {
  __typename?: 'CalcClusterDebug';
  clusterId: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  logStats: CalcClusterDebugLogStats;
  metricId: Scalars['Int'];
  metrics: Array<MetricWithSpcIntervalsUnit>;
  systems: Array<SystemNest>;
  updatedAt: Scalars['DateTime'];
};


export type CalcClusterDebugMetricsArgs = {
  input: CalcClusterDebugInputs;
};

export type CalcClusterDebugInputs = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: CalcClusterDebugWhere;
};

export type CalcClusterDebugLog = {
  __typename?: 'CalcClusterDebugLog';
  appliedAt: Scalars['DateTime'];
  calcClusterDebugId: Scalars['UUID'];
  clusterId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  measuredAt: Scalars['DateTime'];
  metricId: Scalars['Int'];
  oldValue?: Maybe<Scalars['String']>;
  site: SiteNest;
  transactionId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['String']>;
};

export type CalcClusterDebugLogStats = {
  __typename?: 'CalcClusterDebugLogStats';
  avgLogsPerTransaction: Scalars['Float'];
  lastLoggedAt?: Maybe<Scalars['DateTime']>;
  logCount: Scalars['Int'];
  maxLogsPerTransaction: Scalars['Int'];
  transactionCount: Scalars['Int'];
};

export type CalcClusterDebugLogsInput = {
  includeIntervalMetrics?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: CalcClusterDebugLogsWhere;
};

export type CalcClusterDebugLogsWhere = {
  clusterId?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  metricId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  transactionId?: InputMaybe<Scalars['UUID']>;
};

export type CalcClusterDebugUpdateInput = {
  clusterId: Scalars['String'];
  enabled: Scalars['Boolean'];
  metricId: Scalars['Int'];
};

export type CalcClusterDebugWhere = {
  clusterId?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type CalcClusterDebugsWithCount = {
  __typename?: 'CalcClusterDebugsWithCount';
  count: Scalars['Int'];
  items: Array<CalcClusterDebug>;
};

export type CalcTree = {
  __typename?: 'CalcTree';
  dot: Scalars['String'];
  /** Uses the metric id as the unique key */
  id: Scalars['String'];
};

export type CalculatedMetric = {
  __typename?: 'CalculatedMetric';
  calculatedMetricId: Scalars['Int'];
  sourceMetricId: Scalars['Int'];
};

export { CanBeAveraged };

export type CancelSampleScheduleInput = {
  endDate: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export type CloneComponentsInput = {
  cloneQuantity: Scalars['Int'];
  sourceComponentIds: Array<Scalars['Int']>;
  targetProcessId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneMetricsInput = {
  cloneQuantity: Scalars['Int'];
  sourceMetricIds: Array<Scalars['Int']>;
  targetComponentId?: InputMaybe<Scalars['Int']>;
  targetProcessId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneProcessesInput = {
  cloneQuantity: Scalars['Int'];
  sourceProcessIds: Array<Scalars['Int']>;
  targetSiteId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneSitesInput = {
  cloneQuantity: Scalars['Int'];
  flexSiteCloningMethod?: InputMaybe<FlexSiteCloningMethod>;
  sourceSiteIds: Array<Scalars['Int']>;
  targetSystemId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
  withIntervals: Scalars['Boolean'];
};

export type CloneSystemInput = {
  cloneDescendants?: InputMaybe<Scalars['Boolean']>;
  cloneIntervals: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  sourceSystemId: Scalars['Int'];
  targetSystemGroupId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
};

export type CloneSystemWithSelectedDescendantsInput = {
  cloneIntervals: Scalars['Boolean'];
  cloneQuantity: Scalars['Int'];
  restoreDeleted: Scalars['Boolean'];
  sourceComponentIds: Array<Scalars['Int']>;
  sourceMetricIds: Array<Scalars['Int']>;
  sourceProcessIds: Array<Scalars['Int']>;
  sourceSiteIds: Array<Scalars['Int']>;
  sourceSystemId: Scalars['Int'];
  targetSystemGroupId: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
};

export type CloneToTargetInput = {
  cloneIntervals: Scalars['Boolean'];
  cloneQuantity: Scalars['Int'];
  restoreDeleted: Scalars['Boolean'];
  sourceComponentIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceProcessIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceSiteIds?: InputMaybe<Array<Scalars['Int']>>;
  targetIds: Array<Scalars['Int']>;
  targetLevel: SspcmLevel;
  withDeleted: Scalars['Boolean'];
};

export type ClonedComponentPayload = {
  __typename?: 'ClonedComponentPayload';
  component: ComponentNest;
  metrics: Array<MetricNest>;
};

export type ClonedProcessPayload = {
  __typename?: 'ClonedProcessPayload';
  components: Array<ComponentNest>;
  metrics: Array<MetricNest>;
  process: ProcessNest;
};

export enum ColumnAggregation {
  ArithmeticMean = 'ARITHMETIC_MEAN',
  Count = 'COUNT',
  GeometricMean = 'GEOMETRIC_MEAN',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export enum ColumnCalculation {
  ArithmeticMean = 'ARITHMETIC_MEAN',
  Count = 'COUNT',
  GeometricMean = 'GEOMETRIC_MEAN',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export type ColumnGroup = {
  __typename?: 'ColumnGroup';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  reportDefinitionId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ColumnGroupItem = {
  __typename?: 'ColumnGroupItem';
  aggregation?: Maybe<ColumnAggregation>;
  calculationType?: Maybe<ColumnCalculation>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  intervalId?: Maybe<Scalars['Int']>;
  metricId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sourceMetrics: Array<MetricNest>;
  type: ColumnGroupItemType;
  updatedAt: Scalars['DateTime'];
};

export enum ColumnGroupItemType {
  Calculated = 'CALCULATED',
  Metric = 'METRIC',
  PageBreak = 'PAGE_BREAK'
}

export type ColumnGroupItemWithMetric = {
  __typename?: 'ColumnGroupItemWithMetric';
  aggregation?: Maybe<ColumnAggregation>;
  calculationType?: Maybe<ColumnCalculation>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  intervalId?: Maybe<Scalars['Int']>;
  metric?: Maybe<MetricNest>;
  metricId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sourceMetrics: Array<MetricNest>;
  type: ColumnGroupItemType;
  updatedAt: Scalars['DateTime'];
};

export type ColumnGroupWithItems = {
  __typename?: 'ColumnGroupWithItems';
  columnGroupItems?: Maybe<Array<ColumnGroupItemWithMetric>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  reportDefinitionId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ColumnGroupsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: ColumnGroupsWhere;
};

export type ColumnGroupsWhere = {
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['UUID']>;
  reportDefinitionId: Scalars['Int'];
};

export type ColumnGroupsWithItemsInput = {
  reportDefinitionId: Scalars['Int'];
};

export type CommitDirtyDataPointsInput = {
  dirtyDataPoints: Array<MetricDataPointInput>;
  siteId: Scalars['Int'];
  subscriptionClientId: Scalars['String'];
};

export type CommitLabImportBatchInput = {
  batchId: Scalars['UUID'];
  expectedValidatedAt: Scalars['DateTime'];
};

export type ComponentCreateInput = {
  internalKeyname?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  processId: Scalars['Int'];
};

export type ComponentNest = {
  __typename?: 'ComponentNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  processId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ComponentType = {
  __typename?: 'ComponentType';
  deletedAt?: Maybe<Scalars['TimestampType']>;
  enabledForReport?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  process: ProcessType;
  site: SiteType;
  system: SystemType;
};


export type ComponentTypeEnabledForReportArgs = {
  reportDefinitionId?: InputMaybe<Scalars['Int']>;
};


export type ComponentTypeMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentUpdateInput = {
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type ComponentWithMetrics = {
  __typename?: 'ComponentWithMetrics';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricWithRelatedMetrics>;
  name: Scalars['String'];
  order: Scalars['Int'];
  processId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ComponentsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ComponentsWhere>;
};

export type ComponentsWhere = {
  id?: InputMaybe<Scalars['Int']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
};

export { ConstantDataType };

export type ConstantDefinition = {
  __typename?: 'ConstantDefinition';
  createdAt: Scalars['DateTime'];
  dataType: ConstantDataType;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  keyname: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  precision?: Maybe<Scalars['Int']>;
  scope: ConstantScope;
  systemId?: Maybe<Scalars['Int']>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  usedByMetricCount: Scalars['Int'];
  values: Array<ConstantValue>;
};

export type ConstantDefinitionsInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type ConstantImpactedMetric = {
  __typename?: 'ConstantImpactedMetric';
  metricId: Scalars['Int'];
  metricName: Scalars['String'];
  recalculationCount: Scalars['Int'];
  siteName?: Maybe<Scalars['String']>;
};

export type ConstantRecalculationEstimate = {
  __typename?: 'ConstantRecalculationEstimate';
  capped: Scalars['Boolean'];
  dayCount: Scalars['Int'];
  effectiveFromDate: Scalars['Date'];
  metrics: Array<ConstantImpactedMetric>;
  recalcFromDate: Scalars['Date'];
  toDate: Scalars['Date'];
  totalRecalculationCount: Scalars['Int'];
};

export type ConstantRecalculationInput = {
  constantDefinitionId: Scalars['Int'];
  fromDate: Scalars['Date'];
  spanToToday?: InputMaybe<Scalars['Boolean']>;
};

export { ConstantScope };

export type ConstantValue = {
  __typename?: 'ConstantValue';
  constantDefinitionId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  effectiveDate: Scalars['Date'];
  id: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  textValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ConstantsForOrganizationInput = {
  asOfDate: Scalars['Date'];
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['Int'];
};

export type ConstantsForSystemInput = {
  asOfDate?: InputMaybe<Scalars['Date']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  systemId: Scalars['Int'];
};

export type CreateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purpose: AddressPurpose;
  recipientName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type CreateApiTokenInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  preset?: InputMaybe<ApiTokenCapabilityPreset>;
};

export type CreateApiTokenPayloadNest = {
  __typename?: 'CreateApiTokenPayloadNest';
  credentials: MintedApiTokenCredentialsNest;
  token: ApiTokenNest;
};

export type CreateCalcClusterDebugInput = {
  clusterId: Scalars['String'];
  enabled: Scalars['Boolean'];
};

export type CreateColumnGroupInput = {
  name: Scalars['String'];
  parentId: Scalars['UUID'];
  reportDefinitionId: Scalars['Int'];
};

export type CreateColumnGroupItemViaTreeViewInput = {
  columnGroupItemId: Scalars['UUID'];
  isTopLevel: Scalars['Boolean'];
  metricId: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId: Scalars['UUID'];
  reportNodeId: Scalars['UUID'];
};

export type CreateColumnGroupItemsInput = {
  calculationType?: InputMaybe<ColumnCalculation>;
  metricIds: Array<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentId: Scalars['UUID'];
  reportDefinitionId: Scalars['Int'];
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  type?: ColumnGroupItemType;
};

export type CreateColumnGroupViaTreeViewInput = {
  columnGroupId: Scalars['UUID'];
  isTopLevel: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId: Scalars['UUID'];
  reportNodeId: Scalars['UUID'];
};

export type CreateColumnGroupsAndItemsInput = {
  columnGroupInputs: Array<CreateColumnGroupViaTreeViewInput>;
  columnGroupItemInputs: Array<CreateColumnGroupItemViaTreeViewInput>;
  reportDefinitionId: Scalars['Int'];
};

export type CreateConstantDefinitionInput = {
  dataType: ConstantDataType;
  description?: InputMaybe<Scalars['String']>;
  keyname: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['Int']>;
  scope: ConstantScope;
  systemId?: InputMaybe<Scalars['Int']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type CreateEnterpriseReportShareLinkInput = {
  expiresAt: Scalars['DateTime'];
  reportSnapshotId: Scalars['UUID'];
};

export type CreateEnterpriseReportShareLinkPayload = {
  __typename?: 'CreateEnterpriseReportShareLinkPayload';
  publicUrl: Scalars['String'];
  shareLink: EnterpriseReportShareLink;
};

export type CreateFlexFormFromSystemInput = {
  emoji?: InputMaybe<Scalars['String']>;
  includeArchived: Scalars['Boolean'];
  isEntry: Scalars['Boolean'];
  matchRequired: Scalars['Boolean'];
  name: Scalars['String'];
  sourceComponentIds: Array<Scalars['Int']>;
  sourceMetricIds: Array<Scalars['Int']>;
  sourceProcessIds: Array<Scalars['Int']>;
  targetSystemId: Scalars['Int'];
};

export type CreateFolderInput = {
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  parentFolderId?: InputMaybe<Scalars['UUID']>;
  siteId: Scalars['Int'];
};

export type CreateIntervalInput = {
  siteId: Scalars['Int'];
  time?: InputMaybe<Scalars['String']>;
};

export type CreateIntervalsInput = {
  createIntervalInputs: Array<CreateIntervalInput>;
};

export type CreateLabImportBatchInput = {
  parserConfig?: InputMaybe<LabImportParserConfigInput>;
  profileVersionId?: InputMaybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
  uploadId: Scalars['UUID'];
};

export type CreateLogBookEntryAttachmentsInput = {
  componentIds?: InputMaybe<Array<Scalars['Int']>>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  processIds?: InputMaybe<Array<Scalars['Int']>>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  uploadIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type CreateLogBookEntryDashboardViewInput = {
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateLogBookEntryInput = {
  attachments: CreateLogBookEntryAttachmentsInput;
  message: Scalars['String'];
  organizationId: Scalars['Int'];
};

export type CreateNotificationInput = {
  appearance: NotificationAppearance;
  dismissable: Scalars['Boolean'];
  displayPosition: NotificationDisplayPosition;
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<SelectableIcons>;
  message: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  systemGroupId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationIntegrationInput = {
  integrationType: OrganizationIntegrationType;
  organizationId: Scalars['Int'];
  token: Scalars['String'];
};

export type CreatePhraseInput = {
  bodyText: Scalars['String'];
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type CreateReportDistributionListInput = {
  description?: InputMaybe<Scalars['String']>;
  members: Array<ReportDistributionListMemberInput>;
  name: Scalars['String'];
  scope: ReportDistributionListScopeInput;
};

export type CreateReportingReportGroupInput = {
  name: Scalars['String'];
  reportDefinitionIds: Array<Scalars['Int']>;
  systemId: Scalars['Int'];
};

export type CreateRoundsShiftNoteInput = {
  actionTaken: Scalars['Boolean'];
  componentId?: InputMaybe<Scalars['Int']>;
  date: Scalars['String'];
  emailStaff: Scalars['Boolean'];
  needsAttention: Scalars['Boolean'];
  note: Scalars['String'];
  noteAction?: InputMaybe<Scalars['String']>;
  notifyEvery?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  requestId: Scalars['UUID'];
  roleIds?: InputMaybe<Array<Scalars['Int']>>;
  sourceRoundsEntityId: Scalars['Int'];
  sourceType: RoundsShiftNoteSourceType;
  systemId: Scalars['Int'];
  time: Scalars['String'];
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type CreateSampleScheduleInput = {
  analyteGroupId?: InputMaybe<Scalars['UUID']>;
  analyteIds: Array<Scalars['UUID']>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  sampleSiteId: Scalars['UUID'];
  sampleType: SampleType;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateScheduleParentInput = {
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type CreateScheduledItemCommentInput = {
  comment: Scalars['String'];
  commentType: ScheduledItemCommentType;
  scheduledItemId: Scalars['UUID'];
};

export type CreateSystemInput = {
  address?: InputMaybe<CreateAddressInput>;
  existingOrganizationId?: InputMaybe<Scalars['Int']>;
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  newOrganizationName?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  parentSystemGroupId?: InputMaybe<Scalars['Int']>;
  publicWaterSystemId?: InputMaybe<Scalars['String']>;
  regulatoryId?: InputMaybe<Scalars['String']>;
  timeZone: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type CreateTagInput = {
  color?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameEs?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  type: TagType;
};

export type CreateUploadInput = {
  blobId: Scalars['String'];
  fileLength: Scalars['Float'];
  fileName: Scalars['String'];
  mimeType: Scalars['MimeType'];
  organizationId?: InputMaybe<Scalars['Int']>;
  uploadToken: Scalars['String'];
};

export type CreateWeatherDataStationInput = {
  latitude: Scalars['Float'];
  locationName: Scalars['String'];
  longitude: Scalars['Float'];
  stateCode?: InputMaybe<Scalars['String']>;
  usgsStationId?: InputMaybe<Scalars['String']>;
};

export type DataEntryCompletion = {
  __typename?: 'DataEntryCompletion';
  appliedAt: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  intervalTime?: Maybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  latestServiceReportSnapshot?: Maybe<ReportSnapshot>;
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserNest>;
  userId?: Maybe<Scalars['Int']>;
};

export enum DataEntryCompletionEmailOption {
  Always = 'Always',
  Never = 'Never',
  Prompt = 'Prompt'
}

export type DataEntryCompletionsByAppliedAt = {
  __typename?: 'DataEntryCompletionsByAppliedAt';
  daily?: Maybe<DataEntryCompletion>;
  intervals?: Maybe<Array<DataEntryCompletion>>;
};

export type DataEntryCompletionsByReportDateInput = {
  reportDate: Scalars['DateTime'];
  siteId: Scalars['Int'];
};

export enum DataPointCommentPolicy {
  None = 'None',
  Optional = 'Optional',
  Required = 'Required'
}

export type DataPointType = {
  id?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type DataPointValueAndInterval = {
  __typename?: 'DataPointValueAndInterval';
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
  waterlyConnect: Scalars['Boolean'];
};

export type DataPointsForDay = {
  __typename?: 'DataPointsForDay';
  dataPoints: Array<DataPointValueAndInterval>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
};

export type DeleteColumnGroupItemInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteComponentInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteFolderInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteIntervalInput = {
  id: Scalars['Int'];
  siteId?: InputMaybe<Scalars['Int']>;
};

export type DeleteLicenseInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteLogBookEntryDashboardViewInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteLogBookEntryInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteMetricInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteMetricRangeInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteNotificationInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteOrganizationIntegrationInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeletePermitInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeletePhoneNumberInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeletePhraseInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteProcessInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteReportDefinitionByIdInput = {
  id: Scalars['Int'];
};

export type DeleteReportNodesInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['UUID']>;
};

export type DeleteSiteInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteSystemFavoriteInput = {
  id: Scalars['Int'];
};

export type DeleteSystemGroupInput = {
  id: Scalars['Int'];
};

export type DeleteSystemInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteTagInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type DeleteTagMappingInput = {
  id: Scalars['Int'];
};

export type DeleteTrendInput = {
  id: Scalars['Int'];
};

export type DeleteUnitInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
};

export type DeleteUserFromSystemInput = {
  systemId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type DiagnosticsResult = {
  __typename?: 'DiagnosticsResult';
  id: Scalars['Int'];
  lastUpdated: Scalars['DateTime'];
  success: Scalars['Boolean'];
};

export type DisableEnterpriseReportShareLinkInput = {
  id: Scalars['UUID'];
};

export enum DurationUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type EdgeDeviceNest = {
  __typename?: 'EdgeDeviceNest';
  createdAt: Scalars['DateTime'];
  deviceName: Scalars['String'];
  deviceType: EdgeDeviceTypeNest;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  integrationMetadata?: Maybe<Scalars['JSONObject']>;
  lastReceivedAt?: Maybe<Scalars['DateTime']>;
  organizationId: Scalars['Int'];
  organizationName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type EdgeDeviceSubmission = {
  __typename?: 'EdgeDeviceSubmission';
  createdAt: Scalars['TimestampType'];
  dataExcerpt: Scalars['String'];
  edgeDevice: EdgeDeviceType;
  edgeDeviceId: Scalars['Int'];
  id: Scalars['Int'];
  remoteIp?: Maybe<Scalars['String']>;
  status: EdgeDeviceSubmissionStatus;
  success: Scalars['Boolean'];
  updatedAt: Scalars['TimestampType'];
};

export type EdgeDeviceSubmissionFindRecentForDeviceIdInput = {
  edgeDeviceId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EdgeDeviceSubmissionOrderByInput>>;
};

export type EdgeDeviceSubmissionOrderByInput = {
  direction: EdgeDeviceSubmissionOrderDirection;
  field: EdgeDeviceSubmissionOrderField;
};

export enum EdgeDeviceSubmissionOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum EdgeDeviceSubmissionOrderField {
  CreatedAt = 'CreatedAt',
  Id = 'Id',
  RemoteIp = 'RemoteIp',
  Success = 'Success',
  UpdatedAt = 'UpdatedAt'
}

export type EdgeDeviceSubmissionSearchOptions = {
  filterEdgeDeviceId?: InputMaybe<Scalars['Int']>;
  filterStatus?: InputMaybe<EdgeDeviceSubmissionStatusFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  submissionDateUTC: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};

export enum EdgeDeviceSubmissionStatus {
  Fail = 'fail',
  Success = 'success'
}

export enum EdgeDeviceSubmissionStatusFilter {
  Both = 'both',
  Fail = 'fail',
  Success = 'success'
}

export type EdgeDeviceSubmissionSummariesWithCount = {
  __typename?: 'EdgeDeviceSubmissionSummariesWithCount';
  count: Scalars['Int'];
  items: Array<EdgeDeviceSubmissionSummary>;
};

export type EdgeDeviceSubmissionSummary = {
  __typename?: 'EdgeDeviceSubmissionSummary';
  createdAt: Scalars['DateTime'];
  edgeDeviceId: Scalars['Int'];
  id: Scalars['Int'];
  remoteIp: Scalars['String'];
  success: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type EdgeDeviceType = {
  __typename?: 'EdgeDeviceType';
  deviceName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  organizationId?: Maybe<Scalars['Int']>;
};

export enum EdgeDeviceTypeNest {
  ApiOrOther = 'APIOrOther',
  Flexy205 = 'Flexy205',
  Ignition = 'Ignition',
  NightOwl = 'NightOwl',
  SimpliScada = 'SimpliSCADA',
  VtScada = 'VTScada',
  Walchem = 'Walchem',
  XiO = 'XiO'
}

export type EligibleManualReportEmailRecipientsInput = {
  reportSnapshotId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
};

export type EnterpriseReport = {
  __typename?: 'EnterpriseReport';
  createdAt: Scalars['DateTime'];
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  inputConfig: Scalars['String'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  reportId: Scalars['UUID'];
  reportSnapshots?: Maybe<Array<ReportSnapshot>>;
  reportTemplate: Scalars['String'];
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  timeZone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EnterpriseReportShareLink = {
  __typename?: 'EnterpriseReportShareLink';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  disabledByUserId?: Maybe<Scalars['Int']>;
  expiresAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  reportSnapshotId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
};

export type EnterpriseReportShareLinkAccessRequestPayload = {
  __typename?: 'EnterpriseReportShareLinkAccessRequestPayload';
  emailRecipient?: Maybe<Scalars['String']>;
  submitted: Scalars['Boolean'];
};

export type EnterpriseReportShareLinkResolution = {
  __typename?: 'EnterpriseReportShareLinkResolution';
  disabledAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  redirectPath?: Maybe<Scalars['String']>;
  reportSnapshotId?: Maybe<Scalars['UUID']>;
  shareLinkId?: Maybe<Scalars['UUID']>;
  state: EnterpriseReportShareLinkResolutionState;
};

export enum EnterpriseReportShareLinkResolutionState {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  NotFound = 'NOT_FOUND',
  Redirect = 'REDIRECT'
}

export type EnterpriseReportsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: EnterpriseReportsWhere;
};

export type EnterpriseReportsWhere = {
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  reportTemplate?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type EntryIntervalCreateInput = {
  date: Scalars['Date'];
  siteId: Scalars['Int'];
  time: Scalars['String'];
};

export type EntryIntervalDateRangeInput = {
  endDate: Scalars['Date'];
  siteId: Scalars['Int'];
  startDate: Scalars['Date'];
};

export type EntrySparklineDataInput = {
  intervalId: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  reportDate: Scalars['String'];
  siteId: Scalars['Int'];
};

export type EntrySparklineDataPointType = {
  __typename?: 'EntrySparklineDataPointType';
  appliedAt: Scalars['DateTime'];
  dataPoint?: Maybe<EntryTsDataPoint>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['String']>;
};

export type EntrySparklineType = {
  __typename?: 'EntrySparklineType';
  dataPoints: Array<EntrySparklineDataPointType>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
  metricType: MetricDataTypeEnum;
};

export type EntryTsDataPoint = {
  __typename?: 'EntryTSDataPoint';
  appliedAt: Scalars['DateTime'];
  booleanValue?: Maybe<Scalars['Boolean']>;
  calculatedNondetectValue?: Maybe<Scalars['Boolean']>;
  calculatedValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  connectValue?: Maybe<Scalars['String']>;
  dateTimeValue?: Maybe<Scalars['String']>;
  dateValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  effectiveNumericValue?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCalculatedResult?: Maybe<Scalars['Boolean']>;
  isInterpolated: Scalars['Boolean'];
  isNondetect: Scalars['Boolean'];
  journalEntryRecordId: Scalars['ID'];
  jsonValue?: Maybe<Scalars['String']>;
  locatorEntityId: Scalars['String'];
  locatorEntityType: Scalars['String'];
  locatorNamespace: Scalars['String'];
  measuredAt: Scalars['DateTime'];
  metaData: EntryTsDataPointMetadata;
  metricId: Scalars['Int'];
  numericValue?: Maybe<Scalars['Float']>;
  reportDate: Scalars['String'];
  storedAt: Scalars['DateTime'];
  textValue?: Maybe<Scalars['String']>;
  timeValue?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  valueType: Scalars['String'];
};

export type EntryTsDataPointMetadata = {
  __typename?: 'EntryTSDataPointMetadata';
  connectValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
};

export type ExternalFacilitiesInput = {
  maxResults?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  searchInput?: InputMaybe<Scalars['String']>;
};

export type ExternalFacility = {
  __typename?: 'ExternalFacility';
  externalId: Scalars['String'];
  externalMetadata: Scalars['JSONObject'];
  name: Scalars['String'];
};

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  externalId: Scalars['String'];
  externalMetadata: Scalars['JSONObject'];
  externalOwner: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  state: Scalars['String'];
};

export type ExternalSystemsInput = {
  externalId?: InputMaybe<Scalars['String']>;
  externalOwner?: InputMaybe<Scalars['String']>;
  maxResults?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['Int'];
  searchInput?: InputMaybe<Scalars['String']>;
};

export type FindUploadsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export enum FlexSiteCloningMethod {
  LinkToClonedRefMetrics = 'LINK_TO_CLONED_REF_METRICS',
  LinkToOriginalRefMetrics = 'LINK_TO_ORIGINAL_REF_METRICS'
}

export type FlexSitesAssociatedWithMetricId = {
  id?: InputMaybe<Scalars['Int']>;
};

export type FolderWithMetricIdsAndOrder = {
  __typename?: 'FolderWithMetricIdsAndOrder';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  default: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  depth: Scalars['Int'];
  id: Scalars['UUID'];
  metricIdsWithOrder: Array<MetricOrderWithMetricId>;
  name: Scalars['String'];
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type GetCalcTreeInput = {
  metricId: Scalars['Int'];
};

export type GroupCount = {
  __typename?: 'GroupCount';
  count: Scalars['Int'];
  id: Scalars['String'];
  status: Scalars['String'];
  userJobCounts: Array<UserJobCount>;
};

export type GroupQueueCounts = {
  __typename?: 'GroupQueueCounts';
  limited: Scalars['Int'];
  maxed: Scalars['Int'];
  paused: Scalars['Int'];
  waiting: Scalars['Int'];
};

/** A Country Abbreviation */
export enum IsoCountryCodesEnum {
  Ca = 'CA',
  Mx = 'MX',
  Us = 'US'
}

export type Interval = {
  __typename?: 'Interval';
  id: Scalars['Int'];
  time: Scalars['LocalTime'];
};

export type IntervalNest = {
  __typename?: 'IntervalNest';
  createdAt: Scalars['DateTime'];
  createdByUser?: Maybe<UserNest>;
  createdByUserId?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  id: Scalars['Int'];
  recentEntryCompletion?: Maybe<DataEntryCompletion>;
  siteFullName?: Maybe<Scalars['String']>;
  siteId: Scalars['Int'];
  time: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type IntervalsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IntervalsWhere>;
};

export type IntervalsWhere = {
  id?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  time?: InputMaybe<Scalars['String']>;
};

export type IntervalsWithCount = {
  __typename?: 'IntervalsWithCount';
  count: Scalars['Int'];
  items: Array<IntervalNest>;
};

export type JobEvent = {
  __typename?: 'JobEvent';
  data: QueuedRecalculation;
  job: JobLite;
  queue: Scalars['String'];
  type: JobEventType;
};

export enum JobEventType {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Progress = 'PROGRESS',
  Removed = 'REMOVED',
  Waiting = 'WAITING'
}

export type JobLite = {
  __typename?: 'JobLite';
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  progress?: Maybe<Scalars['Float']>;
  returnValue?: Maybe<Scalars['String']>;
  state: JobState;
};

export enum JobState {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Delayed = 'DELAYED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Prioritized = 'PRIORITIZED',
  Wait = 'WAIT',
  WaitingChildren = 'WAITING_CHILDREN'
}

export type JobsFilterInput = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  states?: InputMaybe<Array<JobState>>;
};

export type LabImportBatch = {
  __typename?: 'LabImportBatch';
  checksumSha256: Scalars['String'];
  committedAt?: Maybe<Scalars['DateTime']>;
  committedRowCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  errorDetails?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  invalidRowCount: Scalars['Int'];
  organizationId: Scalars['Int'];
  originalFileName: Scalars['String'];
  parserMetadata: LabImportParserConfig;
  profileName?: Maybe<Scalars['String']>;
  profileVersion?: Maybe<LabImportProfileVersion>;
  profileVersionId?: Maybe<Scalars['UUID']>;
  readyMetricCount: Scalars['Int'];
  readySiteCount: Scalars['Int'];
  reconciliationRequiredRowCount: Scalars['Int'];
  skippedRowCount: Scalars['Int'];
  sourceFileSizeBytes: Scalars['Int'];
  sourceMimeType: Scalars['String'];
  sourceUploadId: Scalars['UUID'];
  status: LabImportBatchStatus;
  systemId: Scalars['Int'];
  totalRowCount: Scalars['Int'];
  uploadedByUserId: Scalars['Int'];
  validRowCount: Scalars['Int'];
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type LabImportBatchResume = {
  __typename?: 'LabImportBatchResume';
  batch: LabImportBatch;
  pendingProfile?: Maybe<LabImportPendingProfile>;
};

export enum LabImportBatchStatus {
  Committed = 'Committed',
  Committing = 'Committing',
  Failed = 'Failed',
  Parsed = 'Parsed',
  Parsing = 'Parsing',
  PartiallyCommitted = 'PartiallyCommitted',
  Ready = 'Ready',
  Uploaded = 'Uploaded',
  Validating = 'Validating'
}

export type LabImportBatchSummary = {
  __typename?: 'LabImportBatchSummary';
  committedAt?: Maybe<Scalars['DateTime']>;
  committedRowCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  fileLength?: Maybe<Scalars['Int']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invalidRowCount: Scalars['Int'];
  profileName?: Maybe<Scalars['String']>;
  reconciliationRequiredRowCount: Scalars['Int'];
  skippedRowCount: Scalars['Int'];
  status: LabImportBatchStatus;
  totalRowCount: Scalars['Int'];
  validRowCount: Scalars['Int'];
};

export type LabImportBatchesInput = {
  skip?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};

export type LabImportBatchesPage = {
  __typename?: 'LabImportBatchesPage';
  count: Scalars['Int'];
  items: Array<LabImportBatchSummary>;
};

export type LabImportColumnMapping = {
  __typename?: 'LabImportColumnMapping';
  column: Scalars['String'];
  field: Scalars['String'];
};

export type LabImportColumnMappingInput = {
  column: Scalars['String'];
  field: Scalars['String'];
};

export type LabImportCommitResult = {
  __typename?: 'LabImportCommitResult';
  batch: LabImportBatch;
  committedCount: Scalars['Int'];
  failedCount: Scalars['Int'];
  reconciliationRequiredCount: Scalars['Int'];
};

export enum LabImportDataPointWriteStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Reconciled = 'Reconciled',
  Succeeded = 'Succeeded',
  WorkflowFailed = 'WorkflowFailed'
}

export type LabImportFileDownload = {
  __typename?: 'LabImportFileDownload';
  downloadUrl: Scalars['String'];
  fileName: Scalars['String'];
  mimeType: Scalars['String'];
};

export type LabImportParserConfig = {
  __typename?: 'LabImportParserConfig';
  columns: Array<Scalars['String']>;
  delimiter: Scalars['String'];
  hasHeader: Scalars['Boolean'];
  quote: Scalars['String'];
};

export type LabImportParserConfigInput = {
  columns: Array<Scalars['String']>;
  delimiter: Scalars['String'];
  hasHeader: Scalars['Boolean'];
  quote: Scalars['String'];
};

export type LabImportPendingProfile = {
  __typename?: 'LabImportPendingProfile';
  baseProfileVersionId?: Maybe<Scalars['UUID']>;
  definition: LabImportProfileDefinition;
  name: Scalars['String'];
  profileId?: Maybe<Scalars['UUID']>;
};

export type LabImportProfile = {
  __typename?: 'LabImportProfile';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  systemId: Scalars['Int'];
  versions: Array<LabImportProfileVersion>;
};

export type LabImportProfileDefinition = {
  __typename?: 'LabImportProfileDefinition';
  columnMappings: Array<LabImportColumnMapping>;
  parserConfig: LabImportParserConfig;
  targetMappings: Array<LabImportTargetMapping>;
};

export type LabImportProfileDefinitionInput = {
  baseProfileVersionId?: InputMaybe<Scalars['UUID']>;
  columnMappings: Array<LabImportColumnMappingInput>;
  name: Scalars['String'];
  parserConfig: LabImportParserConfigInput;
  profileId?: InputMaybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
  targetMappings: Array<LabImportTargetMappingInput>;
};

export type LabImportProfileValidation = {
  __typename?: 'LabImportProfileValidation';
  issues: Array<LabImportProfileValidationIssue>;
  valid: Scalars['Boolean'];
};

export type LabImportProfileValidationIssue = {
  __typename?: 'LabImportProfileValidationIssue';
  code: Scalars['String'];
  field: Scalars['String'];
  message: Scalars['String'];
};

export type LabImportProfileVersion = {
  __typename?: 'LabImportProfileVersion';
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  definition: LabImportProfileDefinition;
  id: Scalars['UUID'];
  profileId: Scalars['UUID'];
  version: Scalars['Int'];
};

export type LabImportRow = {
  __typename?: 'LabImportRow';
  batchId: Scalars['UUID'];
  canonicalValues: Scalars['JSONObject'];
  comments?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  importedUnitLabel?: Maybe<Scalars['String']>;
  intervalId?: Maybe<Scalars['Int']>;
  isNondetect?: Maybe<Scalars['Boolean']>;
  metricId?: Maybe<Scalars['Int']>;
  rawValues: Scalars['JSONObject'];
  reportDate?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  resultName?: Maybe<Scalars['String']>;
  resultValue?: Maybe<Scalars['String']>;
  rowNumber: Scalars['Int'];
  sampleDate?: Maybe<Scalars['String']>;
  sampleIdentifier?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  status: LabImportRowStatus;
  systemId?: Maybe<Scalars['Int']>;
  validationResults: Array<LabImportValidationResult>;
  writeErrorDetails?: Maybe<Scalars['JSONObject']>;
  writeStatus?: Maybe<LabImportDataPointWriteStatus>;
  writtenAt?: Maybe<Scalars['DateTime']>;
};

export enum LabImportRowStatus {
  Committed = 'Committed',
  Committing = 'Committing',
  Failed = 'Failed',
  Invalid = 'Invalid',
  Parsed = 'Parsed',
  ReconciliationRequired = 'ReconciliationRequired',
  Skipped = 'Skipped',
  Valid = 'Valid'
}

export type LabImportRowsInput = {
  batchId: Scalars['UUID'];
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  statuses?: InputMaybe<Array<LabImportRowStatus>>;
  take?: InputMaybe<Scalars['Int']>;
};

export type LabImportRowsPage = {
  __typename?: 'LabImportRowsPage';
  count: Scalars['Int'];
  items: Array<LabImportRow>;
};

export type LabImportSourceColumnsInput = {
  analyte: Scalars['String'];
  project: Scalars['String'];
  sampleSite: Scalars['String'];
  unit: Scalars['String'];
};

export type LabImportSourceGroup = {
  __typename?: 'LabImportSourceGroup';
  analyte: Scalars['String'];
  project: Scalars['String'];
  rowCount: Scalars['Int'];
  sampleSite: Scalars['String'];
  unit: Scalars['String'];
};

export type LabImportSourceGroupsInput = {
  batchId: Scalars['UUID'];
  columns: LabImportSourceColumnsInput;
};

export type LabImportTarget = {
  __typename?: 'LabImportTarget';
  metricId: Scalars['Int'];
  metricName: Scalars['String'];
  metricUnitLabel: Scalars['String'];
  siteId: Scalars['Int'];
  siteName: Scalars['String'];
};

export enum LabImportTargetDecision {
  Map = 'Map',
  Skip = 'Skip'
}

export type LabImportTargetMapping = {
  __typename?: 'LabImportTargetMapping';
  decision: LabImportTargetDecision;
  id: Scalars['String'];
  importedUnitLabel?: Maybe<Scalars['String']>;
  metricId?: Maybe<Scalars['Int']>;
  metricUnitLabel?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['Int']>;
  sourceAnalyte: Scalars['String'];
  sourceProject: Scalars['String'];
  sourceSampleSite: Scalars['String'];
  unitDecision?: Maybe<LabImportUnitDecision>;
};

export type LabImportTargetMappingInput = {
  decision: LabImportTargetDecision;
  id: Scalars['String'];
  importedUnitLabel?: InputMaybe<Scalars['String']>;
  metricId?: InputMaybe<Scalars['Int']>;
  metricUnitLabel?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  sourceAnalyte: Scalars['String'];
  sourceProject: Scalars['String'];
  sourceSampleSite: Scalars['String'];
  unitDecision?: InputMaybe<LabImportUnitDecision>;
};

export enum LabImportUnitDecision {
  Accepted = 'Accepted',
  Exact = 'Exact',
  Rejected = 'Rejected'
}

export type LabImportValidationResult = {
  __typename?: 'LabImportValidationResult';
  attempt: Scalars['Int'];
  code: Scalars['String'];
  details?: Maybe<Scalars['JSONObject']>;
  field?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  status: LabImportValidationStatus;
};

export enum LabImportValidationStatus {
  Error = 'Error',
  Passed = 'Passed',
  Warning = 'Warning'
}

export type LatestServiceReportSnapshotBySiteAndReportDateInput = {
  dataEntryCompletionId?: InputMaybe<Scalars['UUID']>;
  reportDateTime: Scalars['DateTime'];
  siteId: Scalars['Int'];
};

/** Current mostly US states, but can be extended to include other regions as needed. */
export enum LicenseAuthoritiesEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  /** Non Us State */
  Itca = 'ITCA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type LicenseNest = {
  __typename?: 'LicenseNest';
  authority: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
  licenseLabel: Scalars['String'];
  licenseNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type LogBookEntriesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<OrderDirectionsNest>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: LogBookEntriesWhere;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type LogBookEntriesWhere = {
  createdAtEndDate?: InputMaybe<Scalars['DateTime']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type LogBookEntriesWithCount = {
  __typename?: 'LogBookEntriesWithCount';
  count: Scalars['Int'];
  items: Array<LogBookEntryNest>;
};

export type LogBookEntryAttachmentsNest = {
  __typename?: 'LogBookEntryAttachmentsNest';
  components: Array<ComponentNest>;
  metrics: Array<MetricNest>;
  processes: Array<ProcessNest>;
  sites: Array<SiteNest>;
  systems: Array<SystemNest>;
  tags: Array<Tag>;
  uploads: Array<Upload>;
};

export type LogBookEntryDashboardViewByUserIdInput = {
  userId: Scalars['Int'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type LogBookEntryDashboardViewNest = {
  __typename?: 'LogBookEntryDashboardViewNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  siteIds?: Maybe<Array<Scalars['Int']>>;
  sortDirection: Scalars['String'];
  sortField: Scalars['String'];
  systemIds?: Maybe<Array<Scalars['Int']>>;
  tagIds?: Maybe<Array<Scalars['UUID']>>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
  userIds?: Maybe<Array<Scalars['Int']>>;
};

export type LogBookEntryNest = {
  __typename?: 'LogBookEntryNest';
  attachments: LogBookEntryAttachmentsNest;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  organizationId: Scalars['Int'];
  pinned: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  user: UserNest;
  userId: Scalars['Int'];
};

export type ManualReportEmailAddressInput = {
  email: Scalars['EmailAddress'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type ManualReportEmailDistributionListInput = {
  distributionListId: Scalars['UUID'];
  recipientKind: ManualReportEmailRecipientKind;
};

export type ManualReportEmailEligibleRecipient = {
  __typename?: 'ManualReportEmailEligibleRecipient';
  displayName: Scalars['String'];
  email: Scalars['String'];
  primaryOrganizationName?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type ManualReportEmailEvent = {
  __typename?: 'ManualReportEmailEvent';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  providerMessageId?: Maybe<Scalars['String']>;
  recipients: Array<ManualReportEmailRecipient>;
  reportSnapshotId: Scalars['UUID'];
  senderEmail: Scalars['String'];
  senderUserId: Scalars['Int'];
  sentAt?: Maybe<Scalars['DateTime']>;
  shareLinkId: Scalars['UUID'];
  status: ManualReportEmailEventStatus;
  subject: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ManualReportEmailEventStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Sent = 'Sent'
}

export type ManualReportEmailRecipient = {
  __typename?: 'ManualReportEmailRecipient';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  normalizedEmail: Scalars['String'];
  recipientKind: ManualReportEmailRecipientKind;
  recipientSource: ManualReportEmailRecipientSource;
  sourceDistributionListId?: Maybe<Scalars['UUID']>;
  sourceDistributionListName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export enum ManualReportEmailRecipientKind {
  Bcc = 'Bcc',
  Cc = 'Cc',
  To = 'To'
}

export enum ManualReportEmailRecipientSource {
  ManualEmail = 'ManualEmail',
  RegisteredUser = 'RegisteredUser'
}

export type ManualReportEmailSharingScope = {
  __typename?: 'ManualReportEmailSharingScope';
  organizationId?: Maybe<Scalars['Int']>;
  organizationName?: Maybe<Scalars['String']>;
  scope: ReportDistributionListScope;
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
};

export type MetricChartDataContainerType = {
  __typename?: 'MetricChartDataContainerType';
  data?: Maybe<Array<Maybe<MetricChartDataType>>>;
  endDate: Scalars['DateType'];
  startDate: Scalars['DateType'];
};

export type MetricChartDataPointType = {
  __typename?: 'MetricChartDataPointType';
  effectiveValue?: Maybe<Scalars['Float']>;
  reportDate: Scalars['DateTime'];
  value?: Maybe<Scalars['Float']>;
};

export type MetricChartDataType = {
  __typename?: 'MetricChartDataType';
  dataPoints: Array<Maybe<MetricChartDataPointType>>;
  metricId: Scalars['Int'];
};

export type MetricCreateInput = {
  belowRlValue?: InputMaybe<Scalars['Float']>;
  calculated?: InputMaybe<Scalars['Boolean']>;
  calculationName?: InputMaybe<Scalars['String']>;
  canBeAveraged?: InputMaybe<CanBeAveraged>;
  canBeMaximized?: InputMaybe<Scalars['Boolean']>;
  canBeMinimized?: InputMaybe<Scalars['Boolean']>;
  canBeTotaled?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  dataPointCommentPolicy?: InputMaybe<DataPointCommentPolicy>;
  dataType: MetricDataTypeEnum;
  detectionLimit?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['String']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  isDecreasing?: InputMaybe<Scalars['Boolean']>;
  isIncreasing?: InputMaybe<Scalars['Boolean']>;
  isLockedByWaterly?: InputMaybe<Scalars['Boolean']>;
  maxValue?: InputMaybe<Scalars['BigInt']>;
  minValue?: InputMaybe<Scalars['BigInt']>;
  name: Scalars['String'];
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  precision?: InputMaybe<Scalars['Int']>;
  processId: Scalars['Int'];
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMin?: InputMaybe<Scalars['Float']>;
  reportingLimit?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  treatBelowRlAsPercent?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type MetricDataPointInput = {
  comment?: InputMaybe<Scalars['String']>;
  effectiveValue?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  intervalId?: InputMaybe<Scalars['Int']>;
  isCalculatedResult?: InputMaybe<Scalars['Boolean']>;
  isInterpolated?: InputMaybe<Scalars['Boolean']>;
  isNondetect?: InputMaybe<Scalars['Boolean']>;
  metricId: Scalars['Int'];
  reportDate: Scalars['String'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

export type MetricDataPointType = DataPointType & {
  __typename?: 'MetricDataPointType';
  appliedAt: Scalars['DateType'];
  calculatedNondetectValue?: Maybe<Scalars['Boolean']>;
  calculatedValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  connectValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  effectiveValue?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  intervalId?: Maybe<Scalars['Int']>;
  isInterpolated?: Maybe<Scalars['Boolean']>;
  isNondetect?: Maybe<Scalars['Boolean']>;
  measuredAt: Scalars['DateType'];
  metricId: Scalars['Int'];
  reportDate: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export { MetricDataTypeEnum };

export type MetricKeyname = {
  __typename?: 'MetricKeyname';
  compliance: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  systemTypes?: Maybe<Array<Scalars['String']>>;
  updatedAt: Scalars['DateTime'];
};

export type MetricKeynameCreateInput = {
  compliance?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  systemTypes?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  unitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type MetricKeynameDeleteInput = {
  hardDelete?: Scalars['Boolean'];
  id: Scalars['String'];
};

export type MetricKeynameInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MetricKeynameWhere>;
};

export type MetricKeynameJoinedWithCount = {
  __typename?: 'MetricKeynameJoinedWithCount';
  count: Scalars['Int'];
  items: Array<MetricKeynameWithUnitsAndTags>;
};

export type MetricKeynameUpdateInput = {
  compliance?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  systemTypes?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  unitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type MetricKeynameWhere = {
  compliance?: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  systemTypes?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  unitIds?: InputMaybe<Array<Scalars['Float']>>;
};

export type MetricKeynameWithUnitsAndTags = {
  __typename?: 'MetricKeynameWithUnitsAndTags';
  compliance: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  metricsCount: Scalars['Int'];
  name: Scalars['String'];
  systemTypes?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Tag>>;
  units?: Maybe<Array<UnitNest>>;
  updatedAt: Scalars['DateTime'];
};

export type MetricNest = {
  __typename?: 'MetricNest';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricNestCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricOrderWithMetricId = {
  __typename?: 'MetricOrderWithMetricId';
  id: Scalars['UUID'];
  metricId: Scalars['Int'];
  order: Scalars['Int'];
};

export type MetricRange = {
  __typename?: 'MetricRange';
  color: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  ideal: Scalars['Boolean'];
  maxTag?: Maybe<Tag>;
  maxTagId?: Maybe<Scalars['UUID']>;
  metricId: Scalars['Int'];
  minTag?: Maybe<Tag>;
  minTagId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMaxInclusive: Scalars['Boolean'];
  rangeMin?: Maybe<Scalars['Float']>;
  rangeMinInclusive: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export enum MetricRangeType {
  Both = 'BOTH',
  Lower = 'LOWER',
  Upper = 'UPPER'
}

export type MetricType = {
  __typename?: 'MetricType';
  belowRlValue?: Maybe<Scalars['Float']>;
  calculated: Scalars['Boolean'];
  calculatedMetrics: Array<MetricType>;
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentType>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  dataPointCommentPolicy?: Maybe<DataPointCommentPolicy>;
  dataType: MetricDataTypeEnum;
  deletedAt?: Maybe<Scalars['TimestampType']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  enabledForReport: Scalars['Boolean'];
  enabledIntervalForMonthlyReport?: Maybe<Interval>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals: Array<Interval>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessType>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  site?: Maybe<SiteType>;
  sourceMetrics: Array<MetricType>;
  system?: Maybe<SystemType>;
  tagMapping?: Maybe<TagMappingType>;
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitType>;
  unitId?: Maybe<Scalars['Int']>;
};


export type MetricTypeEnabledForReportArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type MetricTypeEnabledIntervalForMonthlyReportArgs = {
  reportDefinitionId: Scalars['Int'];
};

export type MetricUpdateInput = {
  belowRlValue?: InputMaybe<Scalars['Float']>;
  calculated?: InputMaybe<Scalars['Boolean']>;
  calculationName?: InputMaybe<Scalars['String']>;
  canBeAveraged?: InputMaybe<CanBeAveraged>;
  canBeCounted?: InputMaybe<Scalars['Boolean']>;
  canBeMaximized?: InputMaybe<Scalars['Boolean']>;
  canBeMinimized?: InputMaybe<Scalars['Boolean']>;
  canBeTotaled?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  copyPreviousValueEnabled?: InputMaybe<Scalars['Boolean']>;
  dataPointCommentPolicy?: InputMaybe<DataPointCommentPolicy>;
  dataType?: InputMaybe<MetricDataTypeEnum>;
  detectionLimit?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['String']>;
  hideFromDataEntry?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  interpolated?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  isDecreasing?: InputMaybe<Scalars['Boolean']>;
  isIncreasing?: InputMaybe<Scalars['Boolean']>;
  isLockedByWaterly?: InputMaybe<Scalars['Boolean']>;
  isReportComments?: InputMaybe<Scalars['Boolean']>;
  keynameId?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['BigInt']>;
  metricRangeType?: InputMaybe<MetricRangeType>;
  metricRanges?: InputMaybe<Array<UpsertMetricRangeInput>>;
  minValue?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMin?: InputMaybe<Scalars['Float']>;
  reportingLimit?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  treatBelowRlAsPercent?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type MetricWithCalculatedMetric = {
  __typename?: 'MetricWithCalculatedMetric';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculatedMetric: CalculatedMetric;
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithCalculatedMetricCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricWithCalculatedMetrics = {
  __typename?: 'MetricWithCalculatedMetrics';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  downstreamCalcCount: Scalars['Int'];
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithCalculatedMetricsCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricWithRelatedMetrics = {
  __typename?: 'MetricWithRelatedMetrics';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculatedMetrics: Array<CalculatedMetric>;
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process?: Maybe<ProcessNest>;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  sourceMetrics: Array<CalculatedMetric>;
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithRelatedMetricsCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricWithReportData = {
  __typename?: 'MetricWithReportData';
  enabledForReport: Scalars['Boolean'];
  enabledIntervalId?: Maybe<Scalars['Int']>;
  metricId: Scalars['Int'];
};

export type MetricWithSpcIntervalsUnit = {
  __typename?: 'MetricWithSPCIntervalsUnit';
  belowRlValue?: Maybe<Scalars['Float']>;
  calcClusterId?: Maybe<Scalars['String']>;
  calculated: Scalars['Boolean'];
  calculationName?: Maybe<Scalars['String']>;
  canBeAveraged: CanBeAveraged;
  canBeCounted: Scalars['Boolean'];
  canBeMaximized: Scalars['Boolean'];
  canBeMinimized: Scalars['Boolean'];
  canBeTotaled: Scalars['Boolean'];
  component?: Maybe<ComponentNest>;
  componentId?: Maybe<Scalars['Int']>;
  copyPreviousValueEnabled: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  dataPointCommentPolicy: DataPointCommentPolicy;
  dataType: MetricDataTypeEnum;
  debug: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  detectionLimit?: Maybe<Scalars['Float']>;
  displayName: Scalars['String'];
  displayNameBreadcrumbs?: Maybe<Array<Breadcrumb>>;
  expression?: Maybe<Scalars['String']>;
  hideFromDataEntry: Scalars['Boolean'];
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  interpolated: Scalars['Boolean'];
  intervals?: Maybe<Array<IntervalNest>>;
  isDecreasing: Scalars['Boolean'];
  isIncreasing: Scalars['Boolean'];
  isLockedByWaterly: Scalars['Boolean'];
  isReportComments: Scalars['Boolean'];
  isWaterlyConnected: Scalars['Boolean'];
  keynameId?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['BigInt']>;
  metricKeyname?: Maybe<MetricKeyname>;
  metricRangeType?: Maybe<MetricRangeType>;
  metricRanges: Array<MetricRange>;
  minValue?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  order: Scalars['Int'];
  precision?: Maybe<Scalars['Int']>;
  process: ProcessNest;
  processId: Scalars['Int'];
  rangeMax?: Maybe<Scalars['Float']>;
  rangeMin?: Maybe<Scalars['Float']>;
  reportingLimit?: Maybe<Scalars['Float']>;
  required: Scalars['Boolean'];
  site: SiteNest;
  treatBelowRlAsPercent: Scalars['Boolean'];
  unit?: Maybe<UnitNest>;
  unitId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatesPriorDay: Scalars['Boolean'];
};


export type MetricWithSpcIntervalsUnitCalcClusterIdArgs = {
  includeCalcClusterId?: InputMaybe<Scalars['Boolean']>;
};

export type MetricsBySystemIdsInput = {
  componentId?: InputMaybe<Scalars['Int']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  nameOrId?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemIds: Array<Scalars['Int']>;
};

export type MetricsInput = {
  includeIntervalMetrics?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: MetricsWhere;
};

export type MetricsUpdateInput = {
  inputs: Array<MetricUpdateInput>;
};

export type MetricsWhere = {
  componentId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
};

export type MetricsWithDownstreamCalcCountsInput = {
  componentId?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
};

export type MigrateSiteDataToTimeSeriesInput = {
  siteId: Scalars['Int'];
};

export type MigrateSiteDataToTimeSeriesResult = {
  __typename?: 'MigrateSiteDataToTimeSeriesResult';
  id: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type MintedApiTokenCredentialsNest = {
  __typename?: 'MintedApiTokenCredentialsNest';
  realm: Scalars['String'];
  secret: Scalars['String'];
  username: Scalars['String'];
};

export enum MoveDirectionEnum {
  Down = 'DOWN',
  Up = 'UP'
}

export type Mutation = {
  __typename?: 'Mutation';
  addActivitySchedule: ActivitySchedule;
  addEdgeDevice: EdgeDeviceNest;
  addLicense: LicenseNest;
  addNewReportDefinition: ReportDefinitionNest;
  addPhoneNumber: PhoneNumberNest;
  addSSOUserToSystemGroup: UserInfoType;
  addSampleSiteUpload: SampleSiteUpload;
  addScheduledItemUpload: ScheduledItemUpload;
  addSite: SiteType;
  addSiteFlexMetricsToFolder: Array<SiteFlexMetric>;
  addSsoUserToSystem: UserInfoType;
  addSystemFavorite: SystemType;
  addSystemGroup: SystemGroupType;
  addTagMapping: TagMappingType;
  addTrend: TrendNest;
  addUserToSystem?: Maybe<UserInfoType>;
  addUserToSystemGroup: UserInfoType;
  archiveBySampleSiteId?: Maybe<SampleSiteUpload>;
  archiveByScheduledItemId?: Maybe<ScheduledItemUpload>;
  archiveConstantDefinition: ConstantDefinition;
  archiveConstantValue: ConstantValue;
  archiveLabImportBatch: Scalars['Boolean'];
  archiveLabImportProfile: Scalars['Boolean'];
  archiveReportDistributionList: ReportDistributionList;
  archiveReportingReportGroup: ReportingReportGroupNest;
  archiveSampleCollectionComment: SuccessResponse;
  archiveSampleSchedule?: Maybe<SampleSchedule>;
  archiveScheduledItemComment: SuccessResponse;
  archiveScheduledItems: Array<ScheduledItem>;
  archiveUpload: Upload;
  archiveWeatherDataStation: WeatherDataStationNest;
  cancelActivitySchedule: ActivitySchedule;
  cancelSampleSchedule: SampleSchedule;
  clearRuntimeLoggerOverride: SuccessResponse;
  clearSSOCache: Scalars['Boolean'];
  cloneComponents: Array<ClonedComponentPayload>;
  cloneMetrics: Array<MetricNest>;
  cloneProcesses: Array<ClonedProcessPayload>;
  cloneSites: Array<SiteNest>;
  cloneSystem: Array<SystemNest>;
  cloneSystemWithSelectedDescendants: Array<SystemNest>;
  cloneToTarget: SuccessResponse;
  commitDirtyDataPoints: Array<Maybe<MetricDataPointType>>;
  commitLabImportBatch: LabImportCommitResult;
  convertToFlexReport: ReportDefinitionNest;
  createAddress: Address;
  createAnalyteGroup: AnalyteGroup;
  createApiToken: CreateApiTokenPayloadNest;
  createCalcClusterDebugByClusterId: CalcClusterDebug;
  createColumnGroup: ColumnGroup;
  createColumnGroupItems: Array<ColumnGroupItem>;
  createColumnGroupsAndItems: SuccessResponse;
  createComponent: ComponentNest;
  createConstantDefinition: ConstantDefinition;
  createEnterpriseReportShareLink: CreateEnterpriseReportShareLinkPayload;
  createEntryIntervals: Array<IntervalNest>;
  createFlexFormFromSystem: SiteNest;
  createFolder: BaseFolder;
  createInterval: IntervalNest;
  createIntervals: Array<IntervalNest>;
  createLabImportBatch: LabImportBatch;
  createLogBookEntry: LogBookEntryNest;
  createLogBookEntryDashboardView: LogBookEntryDashboardViewNest;
  createMetric: MetricNest;
  createMetricKeyname: MetricKeyname;
  createNotification: Notification;
  createOrganizationIntegration: OrganizationIntegrationNest;
  createPermit: Permit;
  createPhrase: Phrase;
  createProcess: ProcessNest;
  createReportDistributionList: ReportDistributionList;
  createReportingReportGroup: ReportingReportGroupNest;
  createRoundsShiftNote: RoundsShiftNoteCreateResult;
  createSampleCollection: SampleCollection;
  createSampleCollectionComment: SampleCollectionComment;
  createSampleCollectionCustody: Array<SampleCollectionCustody>;
  createSampleSchedule: SampleSchedule;
  createSampleSite: SampleSite;
  createScheduledItemComment: ScheduledItemComment;
  createSystem: SystemNest;
  createTag: Tag;
  createUnit: UnitNest;
  createUpload: Upload;
  createWeatherDataStation: WeatherDataStationNest;
  deleteActivitySchedule?: Maybe<ActivitySchedule>;
  deleteColumnGroupItem: SuccessResponse;
  deleteComponent: SuccessResponse;
  deleteFolder: SuccessResponse;
  deleteInterval?: Maybe<Interval>;
  deleteLicense?: Maybe<LicenseNest>;
  deleteLogBookEntry: SuccessResponse;
  deleteLogBookEntryDashboardView: SuccessResponse;
  deleteMetric: SuccessResponse;
  deleteMetricKeyname: SuccessResponse;
  deleteMetricRange: SuccessResponse;
  deleteNotification: SuccessResponse;
  deleteOrganizationIntegration: SuccessResponse;
  deletePermit: SuccessResponse;
  deletePhoneNumber: PhoneNumberNest;
  deletePhrase: SuccessResponse;
  deleteProcess: SuccessResponse;
  deleteReportDefinitionById: Scalars['Boolean'];
  deleteReportNodes: SuccessResponse;
  deleteSite: SuccessResponse;
  deleteSiteFlexMetric: SuccessResponse;
  deleteSystem: SuccessResponse;
  deleteSystemFavorite: SystemType;
  deleteSystemGroup?: Maybe<SystemGroupType>;
  deleteTag: SuccessResponse;
  deleteTagMapping?: Maybe<TagMappingType>;
  deleteTrend: TrendNest;
  deleteUnit: SuccessResponse;
  deleteUserFromSystem: Array<Maybe<UserInfoType>>;
  disableEnterpriseReportShareLink: EnterpriseReportShareLink;
  initSSOUser: UserInfoType;
  migrateSiteDataToTimeSeries: MigrateSiteDataToTimeSeriesResult;
  recalculateMetric: MetricType;
  reconcileLabImportBatch: LabImportCommitResult;
  removeUserFromSystemGroup: UserInfoType;
  replayWaterlyConnectSubmission: EdgeDeviceSubmission;
  requestEnterpriseReportShareLinkAccess: EnterpriseReportShareLinkAccessRequestPayload;
  requestId?: Maybe<Scalars['String']>;
  resolveLabImportReconciliation: LabImportBatch;
  restoreComponent: SuccessResponse;
  restoreConstantDefinition: ConstantDefinition;
  restoreConstantValue: ConstantValue;
  restoreFolder: SuccessResponse;
  restoreMetric: SuccessResponse;
  restoreProcess: SuccessResponse;
  restoreSite: SuccessResponse;
  restoreSiteFlexMetric: SuccessResponse;
  restoreWeatherDataStation: WeatherDataStationNest;
  revokeApiToken: ApiTokenNest;
  sendEmailVerification: UserInfoType;
  sendManualReportEmail: SendManualReportEmailPayload;
  setRuntimeLoggerOverride: RuntimeLoggerOverride;
  snoozeAllOrgRetentionRisks: Array<RetentionRiskNest>;
  snoozeRetentionRisk?: Maybe<RetentionRiskNest>;
  startMirroring: SiteNest;
  stopMirroring: SiteNest;
  submitConstantRecalculation: ConstantRecalculationEstimate;
  submitSiteRecalculation: RecalculatedMetricsResult;
  transferComponent: SuccessResponse;
  transferMetric: SuccessResponse;
  transferMetricToFolder: SuccessResponse;
  transferSystem: SystemNest;
  triggerAnalyticsReportSnapshot: ReportSnapshot;
  triggerMetricRangeEmails: SuccessResponse;
  updateActivitySchedule: ActivitySchedule;
  updateAddress?: Maybe<Address>;
  updateAnalyteGroup: AnalyteGroup;
  updateCalcClusterDebug: CalcClusterDebug;
  updateColumnGroup: ColumnGroup;
  updateColumnGroupItem: ColumnGroupItem;
  updateComponents: Array<ComponentNest>;
  updateConstantDefinition: ConstantDefinition;
  updateEdgeDevice: EdgeDeviceNest;
  updateEnterpriseReportShareLink: UpdateEnterpriseReportShareLinkPayload;
  updateFolder: BaseFolder;
  updateFolders: Array<BaseFolder>;
  updateLicense: LicenseNest;
  updateLogBookEntry: LogBookEntryNest;
  updateLogBookEntryDashboardView: LogBookEntryDashboardViewNest;
  updateMetric: MetricNest;
  updateMetricForReport: ReportDefinition;
  updateMetricKeyname: MetricKeyname;
  updateMetrics: Array<MetricNest>;
  updateNotification: Notification;
  updateOrganization?: Maybe<OrganizationNest>;
  updateOrganizationIntegration: OrganizationIntegrationNest;
  updatePermit: Permit;
  updatePhoneNumber: PhoneNumberNest;
  updatePhrase: Phrase;
  updateProcessForReport: ReportDefinition;
  updateProcesses: Array<ProcessNest>;
  updateReportDefinition: ReportDefinition;
  updateReportDistributionList: ReportDistributionList;
  updateReportNodes: Array<ReportNode>;
  updateReportingReportDefinitionGroups: Scalars['Boolean'];
  updateReportingReportGroup: ReportingReportGroupNest;
  updateSampleCollection: SampleCollection;
  updateSampleCollectionComment: SampleCollectionComment;
  updateSampleSchedule: SampleSchedule;
  updateSampleSite: SampleSite;
  updateScheduleItemsBySourceScheduleId: Array<ScheduledItem>;
  updateScheduledItem: ScheduledItem;
  updateScheduledItemComment: ScheduledItemComment;
  updateSite: SiteNest;
  updateSiteFlexMetric: SiteFlexMetric;
  updateSiteFlexMetrics: Array<SiteFlexMetric>;
  updateSiteStructure: SiteType;
  updateSites: Array<SiteNest>;
  updateSystem: SystemNest;
  updateSystemGroup: SystemGroupType;
  updateTag: Tag;
  updateTrend: TrendNest;
  updateUnit: UnitNest;
  updateUpload: Upload;
  updateUser: UserInfoType;
  updateUserByToken: UserInfoType;
  updateUserRoleForSystem: Array<Maybe<UserInfoType>>;
  updateUserRoleForSystemGroup: UserInfoType;
  updateWeatherDataStation: WeatherDataStationNest;
  updatedRetentionRiskForOrgs: SuccessResponse;
  upsertConstantValue: ConstantValue;
  upsertDataEntryCompletion: DataEntryCompletion;
  upsertMetricRanges: Array<MetricRange>;
  validateLabImportBatch: LabImportBatch;
  validateLabImportProfile: LabImportProfileValidation;
};


export type MutationAddActivityScheduleArgs = {
  input: ActivityScheduleAddInput;
};


export type MutationAddEdgeDeviceArgs = {
  input: AddEdgeDeviceNestInput;
};


export type MutationAddLicenseArgs = {
  input: AddLicenseInput;
};


export type MutationAddNewReportDefinitionArgs = {
  input: ReportDefinitionCreateInput;
};


export type MutationAddPhoneNumberArgs = {
  input: AddPhoneNumberInput;
};


export type MutationAddSsoUserToSystemGroupArgs = {
  input: AddSsoUserToSystemGroupInput;
};


export type MutationAddSampleSiteUploadArgs = {
  input: AddSampleSiteUploadInput;
};


export type MutationAddScheduledItemUploadArgs = {
  input: AddScheduledItemUploadInput;
};


export type MutationAddSiteArgs = {
  input: AddSiteInput;
};


export type MutationAddSiteFlexMetricsToFolderArgs = {
  input: AddSiteFlexMetricsToFolderInput;
};


export type MutationAddSsoUserToSystemArgs = {
  input: AddSsoUserToSystemTypeInput;
};


export type MutationAddSystemFavoriteArgs = {
  input: AddSystemFavoriteInput;
};


export type MutationAddSystemGroupArgs = {
  input: AddSystemGroupInput;
};


export type MutationAddTagMappingArgs = {
  input: AddTagMappingInput;
};


export type MutationAddTrendArgs = {
  input: AddTrendInput;
};


export type MutationAddUserToSystemArgs = {
  input: AddUserToSystemInput;
};


export type MutationAddUserToSystemGroupArgs = {
  input: AddUserToSystemGroupInput;
};


export type MutationArchiveBySampleSiteIdArgs = {
  input: ArchiveSampleSiteUploadInput;
};


export type MutationArchiveByScheduledItemIdArgs = {
  input: ArchiveScheduledItemUploadInput;
};


export type MutationArchiveConstantDefinitionArgs = {
  input: ArchiveConstantDefinitionInput;
};


export type MutationArchiveConstantValueArgs = {
  input: ArchiveConstantValueInput;
};


export type MutationArchiveLabImportBatchArgs = {
  id: Scalars['UUID'];
};


export type MutationArchiveLabImportProfileArgs = {
  id: Scalars['UUID'];
};


export type MutationArchiveReportDistributionListArgs = {
  input: ArchiveReportDistributionListInput;
};


export type MutationArchiveReportingReportGroupArgs = {
  input: ArchiveReportingReportGroupInput;
};


export type MutationArchiveSampleCollectionCommentArgs = {
  input: SampleCollectionCommentArchiveInput;
};


export type MutationArchiveSampleScheduleArgs = {
  input: ArchiveSampleScheduleInput;
};


export type MutationArchiveScheduledItemCommentArgs = {
  input: ArchiveScheduledItemCommentInput;
};


export type MutationArchiveScheduledItemsArgs = {
  input: ArchiveScheduledItemsInput;
};


export type MutationArchiveUploadArgs = {
  input: ArchiveUploadInput;
};


export type MutationArchiveWeatherDataStationArgs = {
  input: WeatherDataStationIdInput;
};


export type MutationCancelActivityScheduleArgs = {
  input: ActivityScheduleCancelInput;
};


export type MutationCancelSampleScheduleArgs = {
  input: CancelSampleScheduleInput;
};


export type MutationClearRuntimeLoggerOverrideArgs = {
  name: Scalars['String'];
};


export type MutationCloneComponentsArgs = {
  input: CloneComponentsInput;
};


export type MutationCloneMetricsArgs = {
  input: CloneMetricsInput;
};


export type MutationCloneProcessesArgs = {
  input: CloneProcessesInput;
};


export type MutationCloneSitesArgs = {
  input: CloneSitesInput;
};


export type MutationCloneSystemArgs = {
  input: CloneSystemInput;
};


export type MutationCloneSystemWithSelectedDescendantsArgs = {
  input: CloneSystemWithSelectedDescendantsInput;
};


export type MutationCloneToTargetArgs = {
  input: CloneToTargetInput;
};


export type MutationCommitDirtyDataPointsArgs = {
  input: CommitDirtyDataPointsInput;
};


export type MutationCommitLabImportBatchArgs = {
  input: CommitLabImportBatchInput;
};


export type MutationConvertToFlexReportArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAnalyteGroupArgs = {
  input: AnalyteGroupCreateInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreateCalcClusterDebugByClusterIdArgs = {
  input: CreateCalcClusterDebugInput;
};


export type MutationCreateColumnGroupArgs = {
  input: CreateColumnGroupInput;
};


export type MutationCreateColumnGroupItemsArgs = {
  input: CreateColumnGroupItemsInput;
};


export type MutationCreateColumnGroupsAndItemsArgs = {
  input: CreateColumnGroupsAndItemsInput;
};


export type MutationCreateComponentArgs = {
  input: ComponentCreateInput;
};


export type MutationCreateConstantDefinitionArgs = {
  input: CreateConstantDefinitionInput;
};


export type MutationCreateEnterpriseReportShareLinkArgs = {
  input: CreateEnterpriseReportShareLinkInput;
};


export type MutationCreateEntryIntervalsArgs = {
  input: Array<EntryIntervalCreateInput>;
};


export type MutationCreateFlexFormFromSystemArgs = {
  input: CreateFlexFormFromSystemInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateIntervalArgs = {
  input: CreateIntervalInput;
};


export type MutationCreateIntervalsArgs = {
  input: CreateIntervalsInput;
};


export type MutationCreateLabImportBatchArgs = {
  input: CreateLabImportBatchInput;
};


export type MutationCreateLogBookEntryArgs = {
  input: CreateLogBookEntryInput;
};


export type MutationCreateLogBookEntryDashboardViewArgs = {
  input: CreateLogBookEntryDashboardViewInput;
};


export type MutationCreateMetricArgs = {
  input: MetricCreateInput;
};


export type MutationCreateMetricKeynameArgs = {
  input: MetricKeynameCreateInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateOrganizationIntegrationArgs = {
  input: CreateOrganizationIntegrationInput;
};


export type MutationCreatePermitArgs = {
  input: PermitCreateInput;
};


export type MutationCreatePhraseArgs = {
  input: CreatePhraseInput;
};


export type MutationCreateProcessArgs = {
  input: ProcessCreateInput;
};


export type MutationCreateReportDistributionListArgs = {
  input: CreateReportDistributionListInput;
};


export type MutationCreateReportingReportGroupArgs = {
  input: CreateReportingReportGroupInput;
};


export type MutationCreateRoundsShiftNoteArgs = {
  input: CreateRoundsShiftNoteInput;
};


export type MutationCreateSampleCollectionArgs = {
  input: SampleCollectionCreateInput;
};


export type MutationCreateSampleCollectionCommentArgs = {
  input: SampleCollectionCommentCreateInput;
};


export type MutationCreateSampleCollectionCustodyArgs = {
  input: SampleCollectionCustodyCreateInput;
};


export type MutationCreateSampleScheduleArgs = {
  input: CreateSampleScheduleInput;
};


export type MutationCreateSampleSiteArgs = {
  input: SampleSiteCreateInput;
};


export type MutationCreateScheduledItemCommentArgs = {
  input: CreateScheduledItemCommentInput;
};


export type MutationCreateSystemArgs = {
  input: CreateSystemInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUnitArgs = {
  input: UnitCreateInput;
};


export type MutationCreateUploadArgs = {
  input: CreateUploadInput;
};


export type MutationCreateWeatherDataStationArgs = {
  input: CreateWeatherDataStationInput;
};


export type MutationDeleteActivityScheduleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteColumnGroupItemArgs = {
  input: DeleteColumnGroupItemInput;
};


export type MutationDeleteComponentArgs = {
  input: DeleteComponentInput;
};


export type MutationDeleteFolderArgs = {
  input: DeleteFolderInput;
};


export type MutationDeleteIntervalArgs = {
  input: DeleteIntervalInput;
};


export type MutationDeleteLicenseArgs = {
  input: DeleteLicenseInput;
};


export type MutationDeleteLogBookEntryArgs = {
  input: DeleteLogBookEntryInput;
};


export type MutationDeleteLogBookEntryDashboardViewArgs = {
  input: DeleteLogBookEntryDashboardViewInput;
};


export type MutationDeleteMetricArgs = {
  input: DeleteMetricInput;
};


export type MutationDeleteMetricKeynameArgs = {
  input: MetricKeynameDeleteInput;
};


export type MutationDeleteMetricRangeArgs = {
  input: DeleteMetricRangeInput;
};


export type MutationDeleteNotificationArgs = {
  input: DeleteNotificationInput;
};


export type MutationDeleteOrganizationIntegrationArgs = {
  input: DeleteOrganizationIntegrationInput;
};


export type MutationDeletePermitArgs = {
  input: DeletePermitInput;
};


export type MutationDeletePhoneNumberArgs = {
  input: DeletePhoneNumberInput;
};


export type MutationDeletePhraseArgs = {
  input: DeletePhraseInput;
};


export type MutationDeleteProcessArgs = {
  input: DeleteProcessInput;
};


export type MutationDeleteReportDefinitionByIdArgs = {
  input: DeleteReportDefinitionByIdInput;
};


export type MutationDeleteReportNodesArgs = {
  input: DeleteReportNodesInput;
};


export type MutationDeleteSiteArgs = {
  input: DeleteSiteInput;
};


export type MutationDeleteSiteFlexMetricArgs = {
  input: SiteFlexMetricDeleteInput;
};


export type MutationDeleteSystemArgs = {
  input: DeleteSystemInput;
};


export type MutationDeleteSystemFavoriteArgs = {
  input: DeleteSystemFavoriteInput;
};


export type MutationDeleteSystemGroupArgs = {
  input: DeleteSystemGroupInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteTagMappingArgs = {
  input: DeleteTagMappingInput;
};


export type MutationDeleteTrendArgs = {
  input: DeleteTrendInput;
};


export type MutationDeleteUnitArgs = {
  input: DeleteUnitInput;
};


export type MutationDeleteUserFromSystemArgs = {
  input: DeleteUserFromSystemInput;
};


export type MutationDisableEnterpriseReportShareLinkArgs = {
  input: DisableEnterpriseReportShareLinkInput;
};


export type MutationMigrateSiteDataToTimeSeriesArgs = {
  input: MigrateSiteDataToTimeSeriesInput;
};


export type MutationRecalculateMetricArgs = {
  input: RecalculateMetricInput;
};


export type MutationReconcileLabImportBatchArgs = {
  input: ReconcileLabImportBatchInput;
};


export type MutationRemoveUserFromSystemGroupArgs = {
  input: RemoveUserFromSystemGroupInput;
};


export type MutationReplayWaterlyConnectSubmissionArgs = {
  submissionId: Scalars['Int'];
};


export type MutationRequestEnterpriseReportShareLinkAccessArgs = {
  input: RequestEnterpriseReportShareLinkAccessInput;
};


export type MutationResolveLabImportReconciliationArgs = {
  input: ResolveLabImportReconciliationInput;
};


export type MutationRestoreComponentArgs = {
  input: RestoreComponentInput;
};


export type MutationRestoreConstantDefinitionArgs = {
  input: RestoreConstantDefinitionInput;
};


export type MutationRestoreConstantValueArgs = {
  input: RestoreConstantValueInput;
};


export type MutationRestoreFolderArgs = {
  input: RestoreFolderInput;
};


export type MutationRestoreMetricArgs = {
  input: RestoreMetricInput;
};


export type MutationRestoreProcessArgs = {
  input: RestoreProcessInput;
};


export type MutationRestoreSiteArgs = {
  input: RestoreSiteInput;
};


export type MutationRestoreSiteFlexMetricArgs = {
  input: SiteFlexMetricRestoreInput;
};


export type MutationRestoreWeatherDataStationArgs = {
  input: WeatherDataStationIdInput;
};


export type MutationRevokeApiTokenArgs = {
  input: RevokeApiTokenInput;
};


export type MutationSendEmailVerificationArgs = {
  userId: Scalars['Int'];
};


export type MutationSendManualReportEmailArgs = {
  input: SendManualReportEmailInput;
};


export type MutationSetRuntimeLoggerOverrideArgs = {
  input: SetRuntimeLoggerOverrideInput;
};


export type MutationSnoozeAllOrgRetentionRisksArgs = {
  input: SnoozeAllOrgRetentionRisksInput;
};


export type MutationSnoozeRetentionRiskArgs = {
  input: SnoozeRetentionRiskInput;
};


export type MutationStartMirroringArgs = {
  input: StartMirroringInput;
};


export type MutationStopMirroringArgs = {
  input: StopMirroringInput;
};


export type MutationSubmitConstantRecalculationArgs = {
  input: ConstantRecalculationInput;
};


export type MutationSubmitSiteRecalculationArgs = {
  input: SubmitSiteRecalculationInput;
};


export type MutationTransferComponentArgs = {
  input: TransferComponentInput;
};


export type MutationTransferMetricArgs = {
  input: TransferMetricInput;
};


export type MutationTransferMetricToFolderArgs = {
  input: TransferMetricToFolderInput;
};


export type MutationTransferSystemArgs = {
  input: TransferSystemInput;
};


export type MutationTriggerAnalyticsReportSnapshotArgs = {
  input: TriggerAnalyticsReportSnapshotInput;
};


export type MutationUpdateActivityScheduleArgs = {
  input: ActivityScheduleUpdateInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAnalyteGroupArgs = {
  input: AnalyteGroupUpdateInput;
};


export type MutationUpdateCalcClusterDebugArgs = {
  input: CalcClusterDebugUpdateInput;
};


export type MutationUpdateColumnGroupArgs = {
  input: UpdateColumnGroupInput;
};


export type MutationUpdateColumnGroupItemArgs = {
  input: UpdateColumnGroupItemInput;
};


export type MutationUpdateComponentsArgs = {
  input: UpdateComponentsInput;
};


export type MutationUpdateConstantDefinitionArgs = {
  input: UpdateConstantDefinitionInput;
};


export type MutationUpdateEdgeDeviceArgs = {
  input: UpdateEdgeDeviceNestInput;
};


export type MutationUpdateEnterpriseReportShareLinkArgs = {
  input: UpdateEnterpriseReportShareLinkInput;
};


export type MutationUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type MutationUpdateFoldersArgs = {
  input: UpdateFoldersInput;
};


export type MutationUpdateLicenseArgs = {
  input: UpdateLicenseInput;
};


export type MutationUpdateLogBookEntryArgs = {
  input: UpdateLogBookEntryInput;
};


export type MutationUpdateLogBookEntryDashboardViewArgs = {
  input: UpdateLogBookEntryDashboardViewInput;
};


export type MutationUpdateMetricArgs = {
  input: MetricUpdateInput;
};


export type MutationUpdateMetricForReportArgs = {
  input: UpdateMetricForReportInput;
};


export type MutationUpdateMetricKeynameArgs = {
  input: MetricKeynameUpdateInput;
};


export type MutationUpdateMetricsArgs = {
  input: MetricsUpdateInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationIntegrationArgs = {
  input: UpdateOrganizationIntegrationInput;
};


export type MutationUpdatePermitArgs = {
  input: PermitUpdateInput;
};


export type MutationUpdatePhoneNumberArgs = {
  input: UpdatePhoneNumberInput;
};


export type MutationUpdatePhraseArgs = {
  input: UpdatePhraseInput;
};


export type MutationUpdateProcessForReportArgs = {
  input: UpdateProcessForReportInput;
  reportDefinitionId: Scalars['Int'];
};


export type MutationUpdateProcessesArgs = {
  input: UpdateProcessesInput;
};


export type MutationUpdateReportDefinitionArgs = {
  input: UpdateReportDefinitionInput;
};


export type MutationUpdateReportDistributionListArgs = {
  input: UpdateReportDistributionListInput;
};


export type MutationUpdateReportNodesArgs = {
  input: UpdateReportNodesInput;
};


export type MutationUpdateReportingReportDefinitionGroupsArgs = {
  input: UpdateReportingReportDefinitionGroupsInput;
};


export type MutationUpdateReportingReportGroupArgs = {
  input: UpdateReportingReportGroupInput;
};


export type MutationUpdateSampleCollectionArgs = {
  input: SampleCollectionUpdateInput;
};


export type MutationUpdateSampleCollectionCommentArgs = {
  input: SampleCollectionCommentUpdateInput;
};


export type MutationUpdateSampleScheduleArgs = {
  input: UpdateSampleScheduleInput;
};


export type MutationUpdateSampleSiteArgs = {
  input: SampleSiteUpdateInput;
};


export type MutationUpdateScheduleItemsBySourceScheduleIdArgs = {
  input: ActivityScheduleUpdateInput;
};


export type MutationUpdateScheduledItemArgs = {
  input: UpdateScheduledItemInput;
};


export type MutationUpdateScheduledItemCommentArgs = {
  input: UpdateScheduledItemCommentInput;
};


export type MutationUpdateSiteArgs = {
  input: SiteUpdateInput;
};


export type MutationUpdateSiteFlexMetricArgs = {
  input: SiteFlexMetricUpdateInput;
};


export type MutationUpdateSiteFlexMetricsArgs = {
  input: SiteFlexMetricsUpdateInput;
};


export type MutationUpdateSiteStructureArgs = {
  input: UpdateSiteStructureInput;
};


export type MutationUpdateSitesArgs = {
  input: UpdateSitesInput;
};


export type MutationUpdateSystemArgs = {
  input: UpdateSystemInput;
};


export type MutationUpdateSystemGroupArgs = {
  input: UpdateSystemGroupInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTrendArgs = {
  input: UpdateTrendInput;
};


export type MutationUpdateUnitArgs = {
  input: UnitUpdateInput;
};


export type MutationUpdateUploadArgs = {
  input: UpdateUploadInput;
};


export type MutationUpdateUserArgs = {
  enableIphoneMetricNumberInput?: InputMaybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationUpdateUserByTokenArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  userToken: Scalars['String'];
  verifyPassword: Scalars['String'];
};


export type MutationUpdateUserRoleForSystemArgs = {
  input: UpdateUserRoleForSystemInput;
};


export type MutationUpdateUserRoleForSystemGroupArgs = {
  input: UpdateUserRoleForSystemGroupInput;
};


export type MutationUpdateWeatherDataStationArgs = {
  input: UpdateWeatherDataStationInput;
};


export type MutationUpsertConstantValueArgs = {
  input: UpsertConstantValueInput;
};


export type MutationUpsertDataEntryCompletionArgs = {
  input: UpsertDataEntryCompletionInput;
};


export type MutationUpsertMetricRangesArgs = {
  input: UpsertMetricRangesInput;
};


export type MutationValidateLabImportBatchArgs = {
  input: ValidateLabImportBatchInput;
};


export type MutationValidateLabImportProfileArgs = {
  input: LabImportProfileDefinitionInput;
};

export enum NavigationDirection {
  Next = 'NEXT',
  Previous = 'PREVIOUS'
}

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Boolean'];
  appearance: NotificationAppearance;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dismissable: Scalars['Boolean'];
  displayPosition: NotificationDisplayPosition;
  endDate?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<SelectableIcons>;
  id: Scalars['UUID'];
  message: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  startDate: Scalars['DateTime'];
  systemGroupId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export enum NotificationAppearance {
  Critical = 'Critical',
  Info = 'Info',
  Neutral = 'Neutral',
  Success = 'Success',
  Warning = 'Warning'
}

export enum NotificationDisplayPosition {
  BottomLeft = 'BottomLeft',
  BottomRight = 'BottomRight',
  Center = 'Center',
  FullBottom = 'FullBottom',
  FullTop = 'FullTop',
  TopLeft = 'TopLeft',
  TopRight = 'TopRight'
}

export type NotificationsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: NotificationsWhere;
};

export type NotificationsWhere = {
  active?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  systemGroupId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type NotificationsWithCount = {
  __typename?: 'NotificationsWithCount';
  count: Scalars['Int'];
  items: Array<Notification>;
};

export enum OrderDirections {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderDirectionsNest {
  Asc = 'ASC',
  Desc = 'DESC'
}

export { OrganizationDateFormat };

export type OrganizationIntegrationNest = {
  __typename?: 'OrganizationIntegrationNest';
  createdAt: Scalars['DateTime'];
  credentialsSecretReference: Scalars['String'];
  id: Scalars['Int'];
  integrationType: OrganizationIntegrationType;
  organizationId: Scalars['Int'];
  tokenExpiresAt?: Maybe<Scalars['DateTime']>;
  tokenId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export enum OrganizationIntegrationType {
  Walchem = 'WALCHEM'
}

export type OrganizationNest = {
  __typename?: 'OrganizationNest';
  addresses: Array<Address>;
  dateFormat: OrganizationDateFormat;
  fiscalYearStartDate: Scalars['Date'];
  id: Scalars['Int'];
  idpKey?: Maybe<Scalars['String']>;
  isExternalSystemSearchEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  selfServiceEnabled: Scalars['Boolean'];
};

export type OrganizationType = {
  __typename?: 'OrganizationType';
  addresses: Array<Address>;
  dateFormat: OrganizationDateFormat;
  fiscalYearStartDate: Scalars['Date'];
  id: Scalars['Int'];
  idpKey?: Maybe<Scalars['String']>;
  isExternalSystemSearchEnabled: Scalars['Boolean'];
  isUserDirectoryEnabled: Scalars['Boolean'];
  name: Scalars['String'];
  selfServiceEnabled: Scalars['Boolean'];
  systemGroups: Array<SystemGroupType>;
  systems: Array<SystemType>;
  users: Array<UserInfoType>;
};

export enum PaperOrientationEnum {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

export enum PaperSizeEnum {
  Legal = 'LEGAL',
  Letter = 'LETTER',
  Tabloid = 'TABLOID'
}

export type Permit = {
  __typename?: 'Permit';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isPublicWaterSystemId: Scalars['Boolean'];
  name: Scalars['String'];
  permitCode: Scalars['String'];
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PermitCreateInput = {
  isPublicWaterSystemId?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  permitCode: Scalars['String'];
  systemId: Scalars['Int'];
};

export type PermitUpdateInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  permitCode?: InputMaybe<Scalars['String']>;
};

export type PermitsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: PermitsWhere;
};

export type PermitsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  permitCode?: InputMaybe<Scalars['String']>;
  systemId: Scalars['Int'];
};

export type PhoneNumberNest = {
  __typename?: 'PhoneNumberNest';
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  phoneNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type Phrase = {
  __typename?: 'Phrase';
  bodyText: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export type PhrasesInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ProcessCreateInput = {
  internalKeyname?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  siteId: Scalars['Int'];
};

export type ProcessNest = {
  __typename?: 'ProcessNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ProcessType = {
  __typename?: 'ProcessType';
  components: Array<ComponentType>;
  deletedAt?: Maybe<Scalars['TimestampType']>;
  enabledForReport?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricType>;
  name: Scalars['String'];
  order: Scalars['Int'];
  site: SiteType;
  siteId: Scalars['Int'];
  system: SystemType;
};


export type ProcessTypeComponentsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ProcessTypeEnabledForReportArgs = {
  reportDefinitionId?: InputMaybe<Scalars['Int']>;
};


export type ProcessTypeMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProcessUpdateInput = {
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type ProcessWithComponentsAndMetrics = {
  __typename?: 'ProcessWithComponentsAndMetrics';
  components: Array<ComponentWithMetrics>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  internalKeyname?: Maybe<Scalars['String']>;
  metrics: Array<MetricWithRelatedMetrics>;
  name: Scalars['String'];
  order: Scalars['Int'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ProcessWithReportData = {
  __typename?: 'ProcessWithReportData';
  enabledForReport: Scalars['Boolean'];
  processId: Scalars['Int'];
};

export type ProcessesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProcessesWhere>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProcessesWhere = {
  id?: InputMaybe<Scalars['Int']>;
  internalKeyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
};

export type PublicWaterSystemIdPermitInput = {
  id?: InputMaybe<Scalars['UUID']>;
  permitCode: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  SampleScheduleAnalytes: SampleScheduleAnalytesWithCount;
  _usersByOrganizationId?: Maybe<UserNest>;
  activeMetricStats: ActiveMetricStats;
  activeUserStats: ActiveUserStats;
  address?: Maybe<Address>;
  adjacentEntryInterval?: Maybe<IntervalNest>;
  adminStats: AdminStats;
  allEdgeDevices: Array<EdgeDeviceType>;
  allSites: Array<SiteNest>;
  analyteGroupById: AnalyteGroup;
  analyteGroups: AnalyteGroupsWithCount;
  analytes: AnalytesWithCount;
  apiTokens: Array<ApiTokenNest>;
  apiTokensByOrganization: Array<ApiTokenNest>;
  auditEventSiteCreated: AuditEventNest;
  auditEvents: Array<AuditEventNest>;
  auditEventsByItemTypeAndItemId: Array<AuditEventNest>;
  auditEventsByMetricId: AuditEventWithCount;
  auditEventsByScheduledItemId: Array<AuditEventNest>;
  bulkMetricEditorFilterOptions: BulkMetricEditorFilterOptions;
  bulkMetricEditorMetrics: BulkMetricEditorMetrics;
  calcClusterDebugByClusterId?: Maybe<CalcClusterDebug>;
  calcClusterDebugLogs: Array<CalcClusterDebugLog>;
  calcClusterDebugs: CalcClusterDebugsWithCount;
  columnGroupById: ColumnGroup;
  columnGroupItemById?: Maybe<ColumnGroupItem>;
  columnGroups: Array<ColumnGroup>;
  columnGroupsWithItems: Array<ColumnGroupWithItems>;
  component: ComponentType;
  componentById: ComponentNest;
  components: Array<ComponentNest>;
  constantDefinitions: Array<ConstantDefinition>;
  constantRecalculationEstimate: ConstantRecalculationEstimate;
  constantsForOrganization: Array<ResolvedConstant>;
  constantsForSystem: Array<ResolvedConstant>;
  dataEntryCompletionsByReportDate: DataEntryCompletionsByAppliedAt;
  diagnostics: DiagnosticsResult;
  edgeDeviceToken: Scalars['String'];
  edgeDevicesByOrganizationId: Array<EdgeDeviceType>;
  edgeDevicesV2: Array<EdgeDeviceNest>;
  eligibleManualReportEmailRecipients: Array<ManualReportEmailEligibleRecipient>;
  enterpriseReportById?: Maybe<EnterpriseReport>;
  enterpriseReportShareLink: EnterpriseReportShareLinkResolution;
  enterpriseReports: Array<EnterpriseReport>;
  entryIntervalsByDateRange: Array<IntervalNest>;
  entryIntervalsBySiteId: Array<IntervalNest>;
  entrySparklineData: Array<EntrySparklineType>;
  estimateSiteRecalculation: RecalculatedMetricsEstimate;
  exportBulkMetricEditorMetricsCsv: BulkMetricEditorMetricsCsvExport;
  exportLogBookEntriesCsv: Scalars['String'];
  exportUserManagerUsersCsv: Scalars['String'];
  externalFacilities: Array<ExternalFacility>;
  externalSystems: Array<ExternalSystem>;
  findAllUploads: UploadsWithCount;
  findEdgeDeviceSubmissions: EdgeDeviceSubmissionSummariesWithCount;
  findRecentEdgeDeviceSubmissions: Array<EdgeDeviceSubmissionSummary>;
  findUploadById: Upload;
  findUserByToken: UserInfoType;
  flexSitesAssociatedWithMetricId: Array<SiteNest>;
  /**
   * After providing a `fileName` and `mimeType`, this endpoint will generate an object with the details
   *        needed to upload a file to storage. The returned object contains an uploadUrl and a set of headers. The client should
   *        use HTTP `PUT` to upload the file to the given URL. The client must include the headers returned as well. **NOTE:** The
   *        returned upload and download URLs expire after 5 minutes (default, but can override via environment variables supplied to
   *        the API server)
   */
  generateUploadParameters: UploadBlobInfo;
  getActivityScheduleById: ActivitySchedule;
  getActivitySchedules: ActivityScheduleWithCount;
  getCalcTree: CalcTree;
  getCalcTreesWithCycles: Array<Scalars['String']>;
  getDataPointsForDay: Array<DataPointsForDay>;
  getEdgeDeviceSubmissionData: Scalars['JSON'];
  getEdgeDeviceV2: EdgeDeviceNest;
  getEmptyBaseSchedule: BaseSchedule;
  getNextNewUnitId: Scalars['Int'];
  getSSOConfigurationByIDP?: Maybe<SsoConfigurationType>;
  getScheduledItemById: ScheduledItem;
  getScheduledItems: ScheduledItemsWithCount;
  hasLinkedServiceReportEnterpriseReport: Scalars['Boolean'];
  intervalById: IntervalNest;
  intervals: Array<IntervalNest>;
  labImportBatch: LabImportBatch;
  labImportBatchResume: LabImportBatchResume;
  labImportBatches: LabImportBatchesPage;
  labImportFileDownload: LabImportFileDownload;
  labImportProfiles: Array<LabImportProfile>;
  labImportRows: LabImportRowsPage;
  labImportSourceGroups: Array<LabImportSourceGroup>;
  labImportTargets: Array<LabImportTarget>;
  latestServiceReportSnapshotBySiteAndReportDate?: Maybe<ReportSnapshot>;
  license?: Maybe<LicenseNest>;
  licenses: Array<LicenseNest>;
  logBookEntries: Array<LogBookEntryNest>;
  logBookEntriesWithCount: LogBookEntriesWithCount;
  logBookEntryById?: Maybe<LogBookEntryNest>;
  logBookEntryDashboardViewByUserId: Array<LogBookEntryDashboardViewNest>;
  manualReportEmailSharingScope: ManualReportEmailSharingScope;
  me: UserInfoType;
  metric: MetricType;
  metricById: MetricNest;
  metricChartData: MetricChartDataContainerType;
  metricKeynamesWithCount: MetricKeynameJoinedWithCount;
  metricRangesByMetricId: Array<MetricRange>;
  metricsBySiteProcessComponent: Array<MetricNest>;
  metricsBySystemIds: Array<MetricWithSpcIntervalsUnit>;
  metricsWithDownstreamCalcCounts: Array<MetricWithCalculatedMetrics>;
  notifications: NotificationsWithCount;
  organization: OrganizationType;
  organizationIntegrations: Array<OrganizationIntegrationNest>;
  organizations: Array<OrganizationType>;
  organizationsWithSystemGroupsAndSystems: Array<OrganizationType>;
  permitById?: Maybe<Permit>;
  permits: Array<Permit>;
  phoneNumbers: Array<PhoneNumberNest>;
  phrases: Array<Phrase>;
  ping: Scalars['Boolean'];
  process: ProcessType;
  processById: ProcessNest;
  processes: Array<ProcessNest>;
  recentEntryIntervalsBySiteId: IntervalsWithCount;
  regulatoryReportDefinitionsForGrouping: Array<RegulatoryReportDefinitionForGroupingNest>;
  reportData: ReportDataFlatTree;
  reportDataForSite: ReportData;
  reportDefinition: ReportDefinition;
  reportDefinitionDiscoveryFilterCounts: ReportDefinitionDiscoveryFilterCounts;
  reportDefinitionsForDiscovery: ReportDefinitionsForDiscoveryWithCount;
  reportDistributionList: ReportDistributionList;
  reportDistributionLists: Array<ReportDistributionList>;
  reportNodesTree: Array<ReportNodeWithRelations>;
  reportSnapshotById: ReportSnapshot;
  reportSnapshotsWithCount: ReportSnapshotItemsWithCount;
  reportTemplates: Array<ReportTemplate>;
  requestId?: Maybe<Scalars['String']>;
  retentionRisks?: Maybe<Array<RetentionRiskResultNest>>;
  retentionRisksByOrganizationId?: Maybe<Array<RetentionRiskNest>>;
  roundsAssetsMappingsByEntities: Array<RoundsAssetsMappingNest>;
  roundsShiftNoteFormContext: RoundsShiftNoteFormContext;
  runtimeLoggers: RuntimeLoggerSnapshot;
  sampleCollectionById: SampleCollection;
  sampleCollectionComments: SampleCollectionComment;
  sampleCollectionCustodies: SampleCollectionCustodiesWithCount;
  sampleCollections: SampleCollectionsWithCount;
  sampleScheduleById: SampleSchedule;
  sampleSchedules: SampleSchedulesWithCount;
  sampleSiteById: SampleSite;
  sampleSites: Array<SampleSite>;
  scheduledItemComments: ScheduledItemComment;
  scheduledItemCount: ScheduledItemCount;
  site: SiteType;
  siteDataEntryCompletionByDate: Array<SiteDataEntryCompletionByDate>;
  siteFlexMetricById: SiteFlexMetric;
  siteFlexMetrics: Array<SiteFlexMetric>;
  siteV2: SiteNest;
  sitesV2: Array<SiteNest>;
  sourceMetricsBySystemId: Array<MetricWithCalculatedMetric>;
  ssoOrgUsersForSystem: Array<SsoDirectoryUser>;
  ssoUsersForOrganization: Array<SsoDirectoryUser>;
  system?: Maybe<SystemType>;
  systemGroup: SystemGroupType;
  systemGroups: Array<SystemGroupType>;
  systemV2: SystemNest;
  systemWithDeepSites: SystemWithSites;
  systems: Array<SystemType>;
  systemsV2: Array<SystemNest>;
  tagMappings: TagMappingsResult;
  tags: TagsWithCount;
  templateSystems: Array<SystemNest>;
  transactionInfoWithCalcClusterDebugLogs: Array<TransactionInfoWithCalcClusterDebugLogs>;
  trends: Array<TrendNest>;
  unitById: UnitNest;
  unitNests: Array<UnitNest>;
  units: Array<UnitType>;
  user?: Maybe<UserNest>;
  userManagerUser?: Maybe<UserManagerUser>;
  userManagerUsers: UserManagerUsersPage;
  users: Array<UserInfoType>;
  waterlyConnectErrorStats: WaterlyConnectErrorStatsByMonth;
  waterlyConnectStats: WaterlyConnectStats;
  waterlyConnectSubmissionHistory: Array<EdgeDeviceSubmission>;
  weatherDataStations: Array<WeatherDataStationNest>;
};


export type QuerySampleScheduleAnalytesArgs = {
  input: SampleScheduleAnalytesInput;
};


export type Query_UsersByOrganizationIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryActiveMetricStatsArgs = {
  input: ActiveMetricStatsInput;
};


export type QueryActiveUserStatsArgs = {
  input: ActiveUserDetailsInput;
};


export type QueryAddressArgs = {
  id: Scalars['UUID'];
};


export type QueryAdjacentEntryIntervalArgs = {
  input: AdjacentEntryIntervalInput;
};


export type QueryAllSitesArgs = {
  input?: InputMaybe<SitesInput>;
};


export type QueryAnalyteGroupByIdArgs = {
  id: Scalars['String'];
};


export type QueryAnalyteGroupsArgs = {
  input: AnalyteGroupsInput;
};


export type QueryAnalytesArgs = {
  input: AnalytesInput;
};


export type QueryApiTokensByOrganizationArgs = {
  input: ApiTokensByOrganizationInput;
};


export type QueryAuditEventSiteCreatedArgs = {
  input: AuditEventFindOneInput;
};


export type QueryAuditEventsArgs = {
  input: AuditEventsInput;
};


export type QueryAuditEventsByItemTypeAndItemIdArgs = {
  input: AuditEventsByItemTypeAndItemId;
};


export type QueryAuditEventsByMetricIdArgs = {
  input: AuditEventsByMetricIdInput;
};


export type QueryAuditEventsByScheduledItemIdArgs = {
  input: AuditEventsByScheduledItemIdInput;
};


export type QueryBulkMetricEditorFilterOptionsArgs = {
  input: BulkMetricEditorMetricsFilterInput;
};


export type QueryBulkMetricEditorMetricsArgs = {
  input: BulkMetricEditorMetricsInput;
};


export type QueryCalcClusterDebugByClusterIdArgs = {
  clusterId: Scalars['String'];
};


export type QueryCalcClusterDebugLogsArgs = {
  input: CalcClusterDebugLogsInput;
};


export type QueryCalcClusterDebugsArgs = {
  input: CalcClusterDebugInputs;
};


export type QueryColumnGroupByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryColumnGroupItemByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryColumnGroupsArgs = {
  input: ColumnGroupsInput;
};


export type QueryColumnGroupsWithItemsArgs = {
  input: ColumnGroupsWithItemsInput;
};


export type QueryComponentArgs = {
  componentId: Scalars['Int'];
};


export type QueryComponentByIdArgs = {
  componentId: Scalars['Int'];
};


export type QueryComponentsArgs = {
  input: ComponentsInput;
};


export type QueryConstantDefinitionsArgs = {
  input: ConstantDefinitionsInput;
};


export type QueryConstantRecalculationEstimateArgs = {
  input: ConstantRecalculationInput;
};


export type QueryConstantsForOrganizationArgs = {
  input: ConstantsForOrganizationInput;
};


export type QueryConstantsForSystemArgs = {
  input: ConstantsForSystemInput;
};


export type QueryDataEntryCompletionsByReportDateArgs = {
  input: DataEntryCompletionsByReportDateInput;
};


export type QueryEdgeDeviceTokenArgs = {
  edgeDeviceId: Scalars['Int'];
};


export type QueryEdgeDevicesByOrganizationIdArgs = {
  organizationId: Scalars['Int'];
};


export type QueryEligibleManualReportEmailRecipientsArgs = {
  input: EligibleManualReportEmailRecipientsInput;
};


export type QueryEnterpriseReportByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryEnterpriseReportShareLinkArgs = {
  id: Scalars['UUID'];
};


export type QueryEnterpriseReportsArgs = {
  input: EnterpriseReportsInput;
};


export type QueryEntryIntervalsByDateRangeArgs = {
  input: EntryIntervalDateRangeInput;
};


export type QueryEntryIntervalsBySiteIdArgs = {
  siteId: Scalars['Int'];
};


export type QueryEntrySparklineDataArgs = {
  input: EntrySparklineDataInput;
};


export type QueryEstimateSiteRecalculationArgs = {
  input: SubmitSiteRecalculationInput;
};


export type QueryExportBulkMetricEditorMetricsCsvArgs = {
  input: BulkMetricEditorMetricsCsvExportInput;
};


export type QueryExportLogBookEntriesCsvArgs = {
  input: LogBookEntriesInput;
};


export type QueryExportUserManagerUsersCsvArgs = {
  input?: InputMaybe<UserManagerUsersCsvExportInput>;
};


export type QueryExternalFacilitiesArgs = {
  input: ExternalFacilitiesInput;
};


export type QueryExternalSystemsArgs = {
  input: ExternalSystemsInput;
};


export type QueryFindAllUploadsArgs = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FindUploadsWhere>;
};


export type QueryFindEdgeDeviceSubmissionsArgs = {
  input: EdgeDeviceSubmissionFindRecentForDeviceIdInput;
};


export type QueryFindRecentEdgeDeviceSubmissionsArgs = {
  input: EdgeDeviceSubmissionFindRecentForDeviceIdInput;
};


export type QueryFindUploadByIdArgs = {
  id: Scalars['String'];
};


export type QueryFindUserByTokenArgs = {
  userToken: Scalars['String'];
};


export type QueryFlexSitesAssociatedWithMetricIdArgs = {
  input: FlexSitesAssociatedWithMetricId;
};


export type QueryGenerateUploadParametersArgs = {
  fileName: Scalars['String'];
  mimeType: Scalars['MimeType'];
  organizationId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetActivityScheduleByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetActivitySchedulesArgs = {
  input: ActivitySchedulesInput;
};


export type QueryGetCalcTreeArgs = {
  input: GetCalcTreeInput;
};


export type QueryGetDataPointsForDayArgs = {
  metricIds: Array<Scalars['Int']>;
  reportDate: Scalars['Date'];
  systemId: Scalars['Int'];
};


export type QueryGetEdgeDeviceSubmissionDataArgs = {
  submissionId: Scalars['Int'];
};


export type QueryGetEdgeDeviceV2Args = {
  edgeDeviceId: Scalars['Int'];
};


export type QueryGetEmptyBaseScheduleArgs = {
  input: CreateScheduleParentInput;
};


export type QueryGetSsoConfigurationByIdpArgs = {
  idpKey: Scalars['String'];
};


export type QueryGetScheduledItemByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetScheduledItemsArgs = {
  input: ScheduledItemsInput;
};


export type QueryHasLinkedServiceReportEnterpriseReportArgs = {
  siteId: Scalars['Int'];
};


export type QueryIntervalByIdArgs = {
  intervalId: Scalars['Int'];
};


export type QueryIntervalsArgs = {
  input: IntervalsInput;
};


export type QueryLabImportBatchArgs = {
  id: Scalars['UUID'];
};


export type QueryLabImportBatchResumeArgs = {
  id: Scalars['UUID'];
};


export type QueryLabImportBatchesArgs = {
  input: LabImportBatchesInput;
};


export type QueryLabImportFileDownloadArgs = {
  batchId: Scalars['UUID'];
};


export type QueryLabImportProfilesArgs = {
  systemId: Scalars['Int'];
};


export type QueryLabImportRowsArgs = {
  input: LabImportRowsInput;
};


export type QueryLabImportSourceGroupsArgs = {
  input: LabImportSourceGroupsInput;
};


export type QueryLabImportTargetsArgs = {
  systemId: Scalars['Int'];
};


export type QueryLatestServiceReportSnapshotBySiteAndReportDateArgs = {
  input: LatestServiceReportSnapshotBySiteAndReportDateInput;
};


export type QueryLicenseArgs = {
  licenseId: Scalars['Int'];
};


export type QueryLicensesArgs = {
  userId: Scalars['Int'];
};


export type QueryLogBookEntriesArgs = {
  input: LogBookEntriesInput;
};


export type QueryLogBookEntriesWithCountArgs = {
  input: LogBookEntriesInput;
};


export type QueryLogBookEntryByIdArgs = {
  id: Scalars['UUID'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLogBookEntryDashboardViewByUserIdArgs = {
  input: LogBookEntryDashboardViewByUserIdInput;
};


export type QueryManualReportEmailSharingScopeArgs = {
  reportSnapshotId: Scalars['UUID'];
};


export type QueryMetricArgs = {
  metricId: Scalars['Int'];
};


export type QueryMetricByIdArgs = {
  metricId: Scalars['Int'];
};


export type QueryMetricChartDataArgs = {
  endDate: Scalars['DateType'];
  metricIds: Array<Scalars['Int']>;
  startDate: Scalars['DateType'];
  systemId: Scalars['Int'];
};


export type QueryMetricKeynamesWithCountArgs = {
  input: MetricKeynameInput;
};


export type QueryMetricRangesByMetricIdArgs = {
  metricId: Scalars['Int'];
};


export type QueryMetricsBySiteProcessComponentArgs = {
  input: MetricsInput;
};


export type QueryMetricsBySystemIdsArgs = {
  input: MetricsBySystemIdsInput;
};


export type QueryMetricsWithDownstreamCalcCountsArgs = {
  input: MetricsWithDownstreamCalcCountsInput;
};


export type QueryNotificationsArgs = {
  input: NotificationsInput;
};


export type QueryOrganizationArgs = {
  organizationId: Scalars['Int'];
};


export type QueryPermitByIdArgs = {
  permitId: Scalars['UUID'];
};


export type QueryPermitsArgs = {
  input: PermitsInput;
};


export type QueryPhoneNumbersArgs = {
  userId: Scalars['Int'];
};


export type QueryPhrasesArgs = {
  input: PhrasesInput;
};


export type QueryProcessArgs = {
  processId: Scalars['Int'];
};


export type QueryProcessByIdArgs = {
  processId: Scalars['Int'];
};


export type QueryProcessesArgs = {
  input: ProcessesInput;
};


export type QueryRecentEntryIntervalsBySiteIdArgs = {
  beforeDate?: InputMaybe<Scalars['Date']>;
  limit?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryRegulatoryReportDefinitionsForGroupingArgs = {
  input: ReportDefinitionsForDiscoveryInput;
};


export type QueryReportDataArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type QueryReportDataForSiteArgs = {
  reportDefinitionId: Scalars['Int'];
};


export type QueryReportDefinitionArgs = {
  input: ReportDefinitionInput;
};


export type QueryReportDefinitionDiscoveryFilterCountsArgs = {
  input: ReportDefinitionsForDiscoveryInput;
};


export type QueryReportDefinitionsForDiscoveryArgs = {
  input: ReportDefinitionsForDiscoveryInput;
};


export type QueryReportDistributionListArgs = {
  id: Scalars['UUID'];
};


export type QueryReportDistributionListsArgs = {
  input: ReportDistributionListsInput;
};


export type QueryReportNodesTreeArgs = {
  input: ReportNodesTreeInput;
};


export type QueryReportSnapshotByIdArgs = {
  id: Scalars['UUID'];
};


export type QueryReportSnapshotsWithCountArgs = {
  input: ReportSnapshotInput;
};


export type QueryReportTemplatesArgs = {
  input: ReportTemplatesWhere;
};


export type QueryRetentionRisksArgs = {
  input: RetentionRisksInput;
};


export type QueryRetentionRisksByOrganizationIdArgs = {
  id: Scalars['Float'];
};


export type QueryRoundsAssetsMappingsByEntitiesArgs = {
  input: RoundsAssetsMappingsByEntitiesInput;
};


export type QueryRoundsShiftNoteFormContextArgs = {
  input: RoundsShiftNoteFormContextInput;
};


export type QuerySampleCollectionByIdArgs = {
  id: Scalars['String'];
};


export type QuerySampleCollectionCommentsArgs = {
  input: SampleCollectionCommentsInput;
};


export type QuerySampleCollectionCustodiesArgs = {
  input: SampleCollectionCustodiesInput;
};


export type QuerySampleCollectionsArgs = {
  input: SampleCollectionsInput;
};


export type QuerySampleScheduleByIdArgs = {
  id: Scalars['String'];
};


export type QuerySampleSchedulesArgs = {
  input: SampleSchedulesInput;
};


export type QuerySampleSiteByIdArgs = {
  id: Scalars['String'];
};


export type QuerySampleSitesArgs = {
  input: SampleSitesInput;
};


export type QueryScheduledItemCommentsArgs = {
  input: ScheduledItemCommentsInput;
};


export type QueryScheduledItemCountArgs = {
  input: ScheduledItemsInput;
};


export type QuerySiteArgs = {
  siteId: Scalars['Int'];
};


export type QuerySiteDataEntryCompletionByDateArgs = {
  input: SiteDataEntryCompletionByDateInput;
};


export type QuerySiteFlexMetricByIdArgs = {
  id: Scalars['String'];
};


export type QuerySiteFlexMetricsArgs = {
  input: SiteFlexMetricsInput;
};


export type QuerySiteV2Args = {
  entryDate?: InputMaybe<Scalars['Date']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['Int'];
};


export type QuerySitesV2Args = {
  input: SitesInput;
};


export type QuerySourceMetricsBySystemIdArgs = {
  systemId: Scalars['Int'];
};


export type QuerySsoOrgUsersForSystemArgs = {
  searchInput: Scalars['String'];
  systemId: Scalars['Int'];
};


export type QuerySsoUsersForOrganizationArgs = {
  input: SsoUsersForOrganizationInput;
};


export type QuerySystemArgs = {
  systemId: Scalars['Int'];
};


export type QuerySystemGroupArgs = {
  input: SystemGroupInput;
};


export type QuerySystemGroupsArgs = {
  input: SystemGroupsInput;
};


export type QuerySystemV2Args = {
  id: Scalars['Int'];
};


export type QuerySystemWithDeepSitesArgs = {
  id: Scalars['Int'];
  withDeleted: Scalars['Boolean'];
};


export type QuerySystemsArgs = {
  input?: InputMaybe<SystemsInput>;
};


export type QueryTagMappingsArgs = {
  input: TagMappingsInput;
};


export type QueryTagsArgs = {
  input: TagsInput;
};


export type QueryTemplateSystemsArgs = {
  organizationId: Scalars['Int'];
};


export type QueryTransactionInfoWithCalcClusterDebugLogsArgs = {
  input: CalcClusterDebugLogsInput;
};


export type QueryTrendsArgs = {
  input: TrendsQueryInput;
};


export type QueryUnitByIdArgs = {
  unitId: Scalars['Int'];
};


export type QueryUnitNestsArgs = {
  input: UnitsInput;
};


export type QueryUserArgs = {
  userId: Scalars['Int'];
};


export type QueryUserManagerUserArgs = {
  input: UserManagerUserDetailsInput;
};


export type QueryUserManagerUsersArgs = {
  input?: InputMaybe<UserManagerUsersInput>;
};


export type QueryUsersArgs = {
  input: UsersInput;
};


export type QueryWaterlyConnectErrorStatsArgs = {
  edgeDeviceId?: InputMaybe<Scalars['Int']>;
  forMonthStartingUTC: Scalars['String'];
};


export type QueryWaterlyConnectSubmissionHistoryArgs = {
  options: EdgeDeviceSubmissionSearchOptions;
};


export type QueryWeatherDataStationsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

export type QueueStats = {
  __typename?: 'QueueStats';
  completedInLastHour: Scalars['Int'];
  completedPerMinute: Array<Scalars['Int']>;
  failedInLastHour: Scalars['Int'];
  failedPerMinute: Array<Scalars['Int']>;
  generatedAt: Scalars['DateTime'];
  groupsCount: Array<Maybe<GroupCount>>;
  groupsCountByStatus: GroupQueueCounts;
  queue: Scalars['String'];
  workersCount: Scalars['Int'];
};

export type QueuedRecalculation = {
  __typename?: 'QueuedRecalculation';
  canRunForwardCalculations: Scalars['Boolean'];
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  intervalId?: Maybe<Scalars['Int']>;
  metricId: Scalars['Int'];
  queuedAt: Scalars['DateTime'];
  reportDate: Scalars['DateTime'];
  senderEmail: Scalars['String'];
  stackDepth: Scalars['Int'];
  subscriptionClientId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type RecalculateMetricInput = {
  intervalId?: InputMaybe<Scalars['Int']>;
  metricId: Scalars['Int'];
  reportDate: Scalars['DateType'];
  siteId?: InputMaybe<Scalars['Int']>;
  subscriptionClientId: Scalars['String'];
};

export type RecalculatedMetricData = {
  __typename?: 'RecalculatedMetricData';
  metricId: Scalars['Int'];
  metricName: Scalars['String'];
  recalculationCount: Scalars['Int'];
};

export type RecalculatedMetricsEstimate = {
  __typename?: 'RecalculatedMetricsEstimate';
  metrics: Array<RecalculatedMetricData>;
  totalRecalculationCount: Scalars['Int'];
};

export type RecalculatedMetricsResult = {
  __typename?: 'RecalculatedMetricsResult';
  recalculationCount: Scalars['Int'];
};

export type ReconcileLabImportBatchInput = {
  batchId: Scalars['UUID'];
  confirmNoActiveWriter: Scalars['Boolean'];
  confirmedNotWrittenRowIds: Array<Scalars['UUID']>;
  confirmedWrittenRowIds: Array<Scalars['UUID']>;
};

export enum RecurrenceType {
  Adhoc = 'ADHOC',
  Recurring = 'RECURRING'
}

export type RegulatoryReportDefinitionForGroupingNest = {
  __typename?: 'RegulatoryReportDefinitionForGroupingNest';
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  outputTypes: Array<ReportOutputType>;
  reportGroup?: Maybe<ReportingReportGroupNest>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportType: ReportDiscoveryReportType;
  site?: Maybe<ReportDiscoverySiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  system?: Maybe<ReportDiscoverySystemNest>;
  systemId: Scalars['Int'];
};

export type RemoveUserFromSystemGroupInput = {
  systemGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type ReportData = {
  __typename?: 'ReportData';
  metricsWithReportData: Array<MetricWithReportData>;
  processesWithReportData: Array<ProcessWithReportData>;
};

export type ReportDataFlatTree = {
  __typename?: 'ReportDataFlatTree';
  reportNodes: Array<ReportNodeWithRelations>;
};

export type ReportDefinition = {
  __typename?: 'ReportDefinition';
  annualPeriod?: Maybe<Scalars['String']>;
  configSchemaId?: Maybe<Scalars['String']>;
  customFooter?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isFlex: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONObject']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  paperOrientation: PaperOrientationEnum;
  paperSize: PaperSizeEnum;
  reportGroup?: Maybe<ReportGroup>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportTemplateId: Scalars['Int'];
  reportType: ReportTypeEnum;
  showDayOfWeek: Scalars['Boolean'];
  site?: Maybe<SiteType>;
  siteId?: Maybe<Scalars['Int']>;
  supplementaryEnabled: Scalars['Boolean'];
  system: SystemType;
  systemId: Scalars['Int'];
  timeFormat: TimeFormatEnum;
};

export type ReportDefinitionCreateInput = {
  isFlex?: InputMaybe<Scalars['Boolean']>;
  reportType?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId: Scalars['Int'];
};

export type ReportDefinitionDiscoveryFilterCounts = {
  __typename?: 'ReportDefinitionDiscoveryFilterCounts';
  frequencies: ReportDefinitionDiscoveryFrequencyCounts;
  scopes: ReportDefinitionDiscoveryScopeCounts;
};

export type ReportDefinitionDiscoveryFrequencyCounts = {
  __typename?: 'ReportDefinitionDiscoveryFrequencyCounts';
  annual: Scalars['Int'];
  daily: Scalars['Int'];
  monthly: Scalars['Int'];
  other: Scalars['Int'];
  quarterly: Scalars['Int'];
};

export type ReportDefinitionDiscoveryScopeCounts = {
  __typename?: 'ReportDefinitionDiscoveryScopeCounts';
  component: Scalars['Int'];
  organization: Scalars['Int'];
  process: Scalars['Int'];
  site: Scalars['Int'];
  system: Scalars['Int'];
};

export type ReportDefinitionFieldChange = {
  metricId: Scalars['Int'];
  reportTemplateFieldId: Scalars['Int'];
};

export type ReportDefinitionInput = {
  reportDefinitionId: Scalars['Int'];
};

export type ReportDefinitionNest = {
  __typename?: 'ReportDefinitionNest';
  annualPeriod?: Maybe<Scalars['String']>;
  bacterialsEnabled: Scalars['Boolean'];
  configSchemaId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customFooter?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isFlex: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  order: Scalars['Int'];
  paperOrientation: Scalars['String'];
  paperSize: Scalars['String'];
  reportGroup?: Maybe<ReportingReportGroupNest>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportId: Scalars['UUID'];
  reportNodes?: Maybe<ReportNode>;
  reportTemplate: ReportTemplate;
  reportTemplateId?: Maybe<Scalars['Int']>;
  reportType: Scalars['String'];
  showDayOfWeek: Scalars['Boolean'];
  site?: Maybe<SiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  supplementaryEnabled: Scalars['Boolean'];
  system?: Maybe<SystemNest>;
  systemId: Scalars['Int'];
  timeFormat: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReportDefinitionsForDiscoveryFilterInput = {
  field: ReportDiscoveryFilterField;
  operator: ReportDiscoveryFilterOperator;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type ReportDefinitionsForDiscoveryInput = {
  filters?: InputMaybe<Array<ReportDefinitionsForDiscoveryFilterInput>>;
  includeFlexReports?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ReportDiscoveryOrderBy>;
  orderDirection?: InputMaybe<ReportDiscoveryOrderDirection>;
  organizationId?: InputMaybe<Scalars['Int']>;
  recentSnapshotsTake?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<ReportScope>>;
  skip?: InputMaybe<Scalars['Int']>;
  sourceType?: InputMaybe<ReportDiscoverySourceType>;
  systemIds: Array<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  timePeriods?: InputMaybe<Array<ReportDiscoveryReportType>>;
};

export type ReportDefinitionsForDiscoveryWithCount = {
  __typename?: 'ReportDefinitionsForDiscoveryWithCount';
  count: Scalars['Int'];
  items: Array<ReportDiscoveryItem>;
};

export enum ReportDiscoveryFilterField {
  Name = 'Name',
  ReportType = 'ReportType',
  Site = 'Site',
  System = 'System'
}

export enum ReportDiscoveryFilterOperator {
  Contains = 'Contains',
  EndsWith = 'EndsWith',
  Equals = 'Equals',
  Is = 'Is',
  IsAnyOf = 'IsAnyOf',
  IsEmpty = 'IsEmpty',
  IsNotEmpty = 'IsNotEmpty',
  StartsWith = 'StartsWith'
}

export type ReportDiscoveryItem = {
  __typename?: 'ReportDiscoveryItem';
  createdAt: Scalars['DateTime'];
  enterpriseReportId?: Maybe<Scalars['UUID']>;
  id: Scalars['String'];
  isFlex: Scalars['Boolean'];
  latestSnapshotReportDateTime?: Maybe<Scalars['DateTime']>;
  latestSnapshotStatus?: Maybe<ReportStatus>;
  latestSnapshotUpdatedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  outputTypes: Array<ReportOutputType>;
  recentSnapshots: Array<ReportDiscoverySnapshot>;
  reportDefinitionId?: Maybe<Scalars['Int']>;
  reportGroup?: Maybe<ReportingReportGroupNest>;
  reportGroupId?: Maybe<Scalars['Int']>;
  reportSnapshotId?: Maybe<Scalars['UUID']>;
  reportType: ReportDiscoveryReportType;
  site?: Maybe<ReportDiscoverySiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  snapshotCount?: Maybe<Scalars['Int']>;
  sourceType: ReportDiscoverySourceType;
  system?: Maybe<ReportDiscoverySystemNest>;
  systemId?: Maybe<Scalars['Int']>;
};

export enum ReportDiscoveryOrderBy {
  CreatedAt = 'CreatedAt',
  Name = 'Name',
  ReportType = 'ReportType',
  Site = 'Site',
  System = 'System'
}

export enum ReportDiscoveryOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum ReportDiscoveryReportType {
  Annual = 'Annual',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Other = 'Other',
  Quarterly = 'Quarterly'
}

export type ReportDiscoverySiteNest = {
  __typename?: 'ReportDiscoverySiteNest';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ReportDiscoverySnapshot = {
  __typename?: 'ReportDiscoverySnapshot';
  enterpriseReportId: Scalars['UUID'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  reportDateTime: Scalars['DateTime'];
  status: ReportStatus;
  updatedAt: Scalars['DateTime'];
};

export enum ReportDiscoverySourceType {
  Enterprise = 'Enterprise',
  Regulatory = 'Regulatory'
}

export type ReportDiscoverySystemNest = {
  __typename?: 'ReportDiscoverySystemNest';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  timeZone: Scalars['String'];
};

export type ReportDistributionList = {
  __typename?: 'ReportDistributionList';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  displaySummary: Scalars['String'];
  id: Scalars['UUID'];
  isArchived: Scalars['Boolean'];
  memberCount: Scalars['Int'];
  members: Array<ReportDistributionListMember>;
  name: Scalars['String'];
  normalizedName: Scalars['String'];
  organizationId?: Maybe<Scalars['Int']>;
  scope: ReportDistributionListScope;
  siteId?: Maybe<Scalars['Int']>;
  systemId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type ReportDistributionListMember = {
  __typename?: 'ReportDistributionListMember';
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  memberType: ReportDistributionListMemberType;
  normalizedEmail: Scalars['String'];
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['Int']>;
};

export type ReportDistributionListMemberInput = {
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  memberType: ReportDistributionListMemberType;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum ReportDistributionListMemberType {
  ManualEmail = 'ManualEmail',
  RegisteredUser = 'RegisteredUser'
}

export enum ReportDistributionListScope {
  Organization = 'ORGANIZATION',
  Site = 'SITE',
  System = 'SYSTEM'
}

export type ReportDistributionListScopeInput = {
  organizationId?: InputMaybe<Scalars['Int']>;
  scope: ReportDistributionListScope;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type ReportDistributionListsInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  scope: ReportDistributionListScopeInput;
  search?: InputMaybe<Scalars['String']>;
};

export enum ReportFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

export type ReportGroup = {
  __typename?: 'ReportGroup';
  createdAt: Scalars['DateType'];
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateType'];
};

export type ReportNest = {
  __typename?: 'ReportNest';
  description: Scalars['String'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  organization?: Maybe<OrganizationNest>;
  organizationId?: Maybe<Scalars['Int']>;
  reportTemplate?: Maybe<Scalars['JSON']>;
  reportType: ReportType;
  site?: Maybe<SiteNest>;
  siteId?: Maybe<Scalars['Int']>;
  system?: Maybe<SystemNest>;
  systemId?: Maybe<Scalars['Int']>;
};

export type ReportNode = {
  __typename?: 'ReportNode';
  columnGroupId?: Maybe<Scalars['UUID']>;
  columnGroupItemId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  metricId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  reportDefinitionId: Scalars['Int'];
  type: ReportNodeType;
  updatedAt: Scalars['DateTime'];
};

export enum ReportNodeType {
  Calculated = 'Calculated',
  Folder = 'Folder',
  Metric = 'Metric',
  PageBreak = 'PageBreak',
  ReportDefinition = 'ReportDefinition'
}

export type ReportNodeWithRelations = {
  __typename?: 'ReportNodeWithRelations';
  columnGroup?: Maybe<ColumnGroup>;
  columnGroupId?: Maybe<Scalars['UUID']>;
  columnGroupItem?: Maybe<ColumnGroupItem>;
  columnGroupItemId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  metric?: Maybe<MetricNest>;
  metricId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  parentId?: Maybe<Scalars['UUID']>;
  reportDefinition?: Maybe<ReportDefinitionNest>;
  reportDefinitionId: Scalars['Int'];
  type: ReportNodeType;
  updatedAt: Scalars['DateTime'];
};

export type ReportNodesTreeInput = {
  nodeId: Scalars['UUID'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Report Output Types */
export enum ReportOutputType {
  Pdf = 'PDF',
  Xml = 'XML'
}

export enum ReportScope {
  Component = 'COMPONENT',
  Organization = 'ORGANIZATION',
  Process = 'PROCESS',
  Site = 'SITE',
  System = 'SYSTEM'
}

export type ReportSnapshot = {
  __typename?: 'ReportSnapshot';
  config?: Maybe<Scalars['JSONObject']>;
  configSchemaVersion: ReportSnapshotConfigSchemaVersion;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONObject']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  enterpriseReportId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  report: ReportNest;
  reportDateTime: Scalars['DateTime'];
  reportDefinition?: Maybe<ReportDefinitionNest>;
  reportDefinitionId?: Maybe<Scalars['Int']>;
  status: ReportStatus;
  system?: Maybe<SystemNest>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export enum ReportSnapshotConfigSchemaVersion {
  EnterpriseReportV1 = 'ENTERPRISE_REPORT_V1',
  ReportDefinitionV1 = 'REPORT_DEFINITION_V1'
}

export type ReportSnapshotInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReportSnapshotsWhereInput>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ReportSnapshotItemsWithCount = {
  __typename?: 'ReportSnapshotItemsWithCount';
  count: Scalars['Int'];
  items: Array<ReportSnapshot>;
};

export type ReportSnapshotsWhereInput = {
  endDate: Scalars['DateTime'];
  enterpriseReportId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  reportDefinitionId?: InputMaybe<Scalars['Int']>;
  reportTypes?: InputMaybe<Array<ReportType>>;
  scopes?: InputMaybe<Array<ReportScope>>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  standardReportTypes?: InputMaybe<Array<ReportFrequency>>;
  startDate: Scalars['DateTime'];
  status?: InputMaybe<ReportStatus>;
  systemIds: Array<Scalars['Int']>;
};

export enum ReportStatus {
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Final = 'FINAL',
  Pending = 'PENDING'
}

export type ReportTemplate = {
  __typename?: 'ReportTemplate';
  agencyName?: Maybe<Scalars['String']>;
  configSchemaId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isEditable: Scalars['Boolean'];
  legalStatement?: Maybe<Scalars['String']>;
  outputTypes: Array<ReportOutputType>;
  stateOrProvince: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  variant: Scalars['String'];
};

export type ReportTemplatesWhere = {
  systemId: Scalars['Int'];
};

export enum ReportType {
  Enterprise = 'ENTERPRISE',
  Inspection = 'INSPECTION',
  Regulatory = 'REGULATORY'
}

/**
 * Report Types
 * *** Be sure to keep these synchronized with the Postgres enums ***
 */
export enum ReportTypeEnum {
  /** An `annual` report contains sub-year (month/quarter) data */
  Annual = 'ANNUAL',
  /** A `daily` report contains sub-day (hourly/interval) data. */
  Daily = 'DAILY',
  /** A `monthly` report contains sub-month (day) data */
  Monthly = 'MONTHLY'
}

export type ReportingReportGroupNest = {
  __typename?: 'ReportingReportGroupNest';
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  systemId: Scalars['Int'];
};

export type RequestEnterpriseReportShareLinkAccessInput = {
  id: Scalars['UUID'];
  requesterEmail: Scalars['EmailAddress'];
};

export type ResolveLabImportReconciliationInput = {
  batchId: Scalars['UUID'];
  confirmDownstreamRepaired: Scalars['Boolean'];
  resolutionNote: Scalars['String'];
  rowId: Scalars['UUID'];
};

export type ResolvedConstant = {
  __typename?: 'ResolvedConstant';
  constantDefinition: ConstantDefinition;
  constantValue?: Maybe<ConstantValue>;
  source: ConstantScope;
};

export type RestoreComponentInput = {
  componentId: Scalars['Int'];
};

export type RestoreConstantDefinitionInput = {
  id: Scalars['Int'];
};

export type RestoreConstantValueInput = {
  id: Scalars['Int'];
};

export type RestoreFolderInput = {
  id: Scalars['UUID'];
};

export type RestoreMetricInput = {
  metricId: Scalars['Int'];
};

export type RestoreProcessInput = {
  processId: Scalars['Int'];
};

export type RestoreSiteInput = {
  siteId: Scalars['Int'];
};

export enum RetentionRiskFlagType {
  OrgLastLogin = 'ORG_LAST_LOGIN',
  SystemLastLogin = 'SYSTEM_LAST_LOGIN',
  SystemLastReportDownload = 'SYSTEM_LAST_REPORT_DOWNLOAD',
  SystemLastSavedDatapoint = 'SYSTEM_LAST_SAVED_DATAPOINT'
}

export enum RetentionRiskItemType {
  Organization = 'ORGANIZATION',
  System = 'SYSTEM'
}

export type RetentionRiskNest = {
  __typename?: 'RetentionRiskNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  flag: Scalars['Boolean'];
  flagType: RetentionRiskFlagType;
  id: Scalars['UUID'];
  itemId: Scalars['String'];
  itemType: RetentionRiskItemType;
  organization: OrganizationNest;
  organizationId: Scalars['Int'];
  score: Scalars['Float'];
  snooze?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['DateTime'];
};

export type RetentionRiskResultNest = {
  __typename?: 'RetentionRiskResultNest';
  organizationId: Scalars['Int'];
  organizationRetentionRisks: Array<RetentionRiskNest>;
  score: Scalars['Float'];
  systemRetentionRisks: Array<RetentionRiskNest>;
};

export type RetentionRisksInput = {
  snooze?: InputMaybe<Scalars['Boolean']>;
};

export type RevokeApiTokenInput = {
  id: Scalars['Int'];
};

export type RoundsAssetsMappingNest = {
  __typename?: 'RoundsAssetsMappingNest';
  assetsEntityId: Scalars['Int'];
  assetsEntityType: AssetsEntityType;
  assetsInstanceId: Scalars['Int'];
  id: Scalars['ID'];
  roundsEntityId: Scalars['Int'];
  roundsEntityType: RoundsEntityType;
  systemId: Scalars['Int'];
};

export type RoundsAssetsMappingsByEntitiesInput = {
  entities: Array<RoundsAssetsMappingsEntityRefInput>;
  systemId: Scalars['Int'];
};

export type RoundsAssetsMappingsEntityRefInput = {
  roundsEntityId: Scalars['Int'];
  roundsEntityType: RoundsEntityType;
};

export enum RoundsEntityType {
  Component = 'Component',
  Process = 'Process',
  Site = 'Site'
}

export type RoundsShiftNoteAssetChoice = {
  __typename?: 'RoundsShiftNoteAssetChoice';
  componentId: Scalars['Int'];
  name: Scalars['String'];
};

export type RoundsShiftNoteAssigneeRole = {
  __typename?: 'RoundsShiftNoteAssigneeRole';
  isUnassignedBucket: Scalars['Boolean'];
  roleId: Scalars['Int'];
  roleName: Scalars['String'];
  users: Array<RoundsShiftNoteAssigneeUser>;
};

export type RoundsShiftNoteAssigneeUser = {
  __typename?: 'RoundsShiftNoteAssigneeUser';
  label: Scalars['String'];
  userId: Scalars['Int'];
};

export type RoundsShiftNoteCreateResult = {
  __typename?: 'RoundsShiftNoteCreateResult';
  noteId: Scalars['String'];
  viewUrl: Scalars['String'];
};

export type RoundsShiftNoteFormContext = {
  __typename?: 'RoundsShiftNoteFormContext';
  asset?: Maybe<RoundsShiftNoteLocationTier>;
  assetChoices: Array<RoundsShiftNoteAssetChoice>;
  assigneeRoles: Array<RoundsShiftNoteAssigneeRole>;
  defaultDate: Scalars['String'];
  defaultTime: Scalars['String'];
  facility: RoundsShiftNoteLocationTier;
  notifyAssignedByDefault: Scalars['Boolean'];
  sourceType: RoundsShiftNoteSourceType;
  system?: Maybe<RoundsShiftNoteLocationTier>;
  systemChoices: Array<RoundsShiftNoteSystemChoice>;
};

export type RoundsShiftNoteFormContextInput = {
  sourceRoundsEntityId: Scalars['Int'];
  sourceType: RoundsShiftNoteSourceType;
  systemId: Scalars['Int'];
};

export type RoundsShiftNoteLocationTier = {
  __typename?: 'RoundsShiftNoteLocationTier';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum RoundsShiftNoteSourceType {
  Component = 'Component',
  Process = 'Process',
  Site = 'Site'
}

export type RoundsShiftNoteSystemChoice = {
  __typename?: 'RoundsShiftNoteSystemChoice';
  assets: Array<RoundsShiftNoteAssetChoice>;
  name: Scalars['String'];
  processId: Scalars['Int'];
};

export enum RuntimeLogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Fatal = 'FATAL',
  Info = 'INFO',
  Trace = 'TRACE',
  Warn = 'WARN'
}

export type RuntimeLogger = {
  __typename?: 'RuntimeLogger';
  defaults: Array<RuntimeLoggerDefault>;
  name: Scalars['String'];
  override?: Maybe<RuntimeLoggerOverride>;
  overrideStatus: Scalars['String'];
  recent: Scalars['Boolean'];
};

export type RuntimeLoggerDefault = {
  __typename?: 'RuntimeLoggerDefault';
  instanceId: Scalars['String'];
  lastSeenAt: Scalars['DateTime'];
  level: RuntimeLogLevel;
  role: Scalars['String'];
};

export type RuntimeLoggerOverride = {
  __typename?: 'RuntimeLoggerOverride';
  expiresAt: Scalars['DateTime'];
  level: RuntimeLogLevel;
  updatedAt: Scalars['DateTime'];
};

export type RuntimeLoggerSnapshot = {
  __typename?: 'RuntimeLoggerSnapshot';
  available: Scalars['Boolean'];
  complete: Scalars['Boolean'];
  loggers: Array<RuntimeLogger>;
  observedAt?: Maybe<Scalars['DateTime']>;
};

export type SsoConfigurationType = {
  __typename?: 'SSOConfigurationType';
  audience?: Maybe<Scalars['String']>;
  authority: Scalars['String'];
  clientId: Scalars['String'];
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  isNameEditable: Scalars['Boolean'];
  logoSvg?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  signoutRedirectUrl: Scalars['String'];
  userDirectoryEnabled: Scalars['Boolean'];
};

export type SsoDirectoryUser = {
  __typename?: 'SSODirectoryUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  metadataJSON?: Maybe<Scalars['String']>;
};

export type SsoUsersForOrganizationInput = {
  organizationId: Scalars['Int'];
  searchInput: Scalars['String'];
};

export enum SspcmLevel {
  Component = 'COMPONENT',
  Metric = 'METRIC',
  Process = 'PROCESS',
  Site = 'SITE',
  System = 'SYSTEM'
}

export type SampleCollection = {
  __typename?: 'SampleCollection';
  createdAt: Scalars['DateTime'];
  currentCustody?: Maybe<SampleCollectionCustody>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleCollectionResults?: Maybe<Array<SampleCollectionResult>>;
  sampleSite?: Maybe<SampleSite>;
  sampleSiteId: Scalars['UUID'];
  scheduledItemId?: Maybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SampleCollectionComment = {
  __typename?: 'SampleCollectionComment';
  comment: Scalars['String'];
  commentType: SampleCollectionCommentType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleCollectionId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  user: UserNest;
  userId: Scalars['Int'];
};

export type SampleCollectionCommentArchiveInput = {
  id: Scalars['UUID'];
};

export type SampleCollectionCommentCreateInput = {
  comment: Scalars['String'];
  commentType: SampleCollectionCommentType;
  sampleCollectionId: Scalars['UUID'];
};

export enum SampleCollectionCommentType {
  General = 'GENERAL'
}

export type SampleCollectionCommentUpdateInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type SampleCollectionCommentsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleCollectionCommentsWhere>;
};

export type SampleCollectionCommentsWhere = {
  commentType?: InputMaybe<SampleCollectionCommentType>;
  id?: InputMaybe<Scalars['UUID']>;
  sampleCollectionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type SampleCollectionCreateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  sampleSiteId: Scalars['UUID'];
  scheduledItemId?: InputMaybe<Scalars['UUID']>;
  systemId: Scalars['Int'];
};

export type SampleCollectionCustodiesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: SampleCollectionCustodiesWhere;
};

export type SampleCollectionCustodiesWhere = {
  createdBy?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
};

export type SampleCollectionCustodiesWithCount = {
  __typename?: 'SampleCollectionCustodiesWithCount';
  count: Scalars['Int'];
  items: Array<SampleCollectionCustody>;
};

export type SampleCollectionCustody = {
  __typename?: 'SampleCollectionCustody';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  previousCustodyId?: Maybe<Scalars['UUID']>;
  relinquishedBy?: Maybe<Scalars['Int']>;
  relinquishedByUser?: Maybe<UserNest>;
  relinquishedTo: Scalars['Int'];
  relinquishedToUser: UserNest;
  sampleCollectionId: Scalars['UUID'];
  systemId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SampleCollectionCustodyCreateInput = {
  comment?: InputMaybe<Scalars['String']>;
  relinquishToUserId: Scalars['Int'];
  sampleCollectionIds: Array<Scalars['UUID']>;
  systemId: Scalars['Int'];
};

export type SampleCollectionResult = {
  __typename?: 'SampleCollectionResult';
  analyte?: Maybe<Analyte>;
  analyteId: Scalars['UUID'];
  booleanValue?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  measuredAt?: Maybe<Scalars['DateTime']>;
  numericValue?: Maybe<Scalars['Float']>;
  sampleCollectionId: Scalars['UUID'];
  textValue?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  valueType: ValueType;
};

export type SampleCollectionUpdateInput = {
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  id: Scalars['UUID'];
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  systemId?: InputMaybe<Scalars['Int']>;
};

export type SampleCollectionsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: SampleCollectionsWhere;
};

export type SampleCollectionsWhere = {
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
};

export type SampleCollectionsWithCount = {
  __typename?: 'SampleCollectionsWithCount';
  count: Scalars['Int'];
  items: Array<SampleCollection>;
};

export type SampleSchedule = {
  __typename?: 'SampleSchedule';
  analyteGroupId?: Maybe<Scalars['UUID']>;
  analytes: Array<Analyte>;
  createdAt: Scalars['DateTime'];
  createdByUserId: Scalars['Int'];
  defaultAssignee?: Maybe<UserNest>;
  defaultAssigneeId?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  exDates?: Maybe<Array<Scalars['DateTime']>>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBeforeUnit?: Maybe<DurationUnit>;
  notBeforeValue?: Maybe<Scalars['Int']>;
  photoRequired: Scalars['Boolean'];
  rDates?: Maybe<Array<Scalars['DateTime']>>;
  recurrenceType: RecurrenceType;
  rrule: Scalars['String'];
  sampleSite?: Maybe<SampleSite>;
  sampleSiteId: Scalars['UUID'];
  sampleType: SampleType;
  siteId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetBeforeUnit?: Maybe<DurationUnit>;
  targetBeforeValue?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SampleScheduleAnalyte = {
  __typename?: 'SampleScheduleAnalyte';
  analyteId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleScheduleId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
};

export type SampleScheduleAnalytesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleScheduleAnalytesWhere>;
};

export type SampleScheduleAnalytesWhere = {
  analyteId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  sampleScheduleId?: InputMaybe<Scalars['UUID']>;
};

export type SampleScheduleAnalytesWithCount = {
  __typename?: 'SampleScheduleAnalytesWithCount';
  count: Scalars['Int'];
  items: Array<SampleScheduleAnalyte>;
};

export type SampleSchedulesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleSchedulesWhere>;
};

export type SampleSchedulesWhere = {
  activityScheduleTypeId?: InputMaybe<Scalars['String']>;
  analyteGroupIds?: InputMaybe<Array<Scalars['UUID']>>;
  defaultAssigneeId?: InputMaybe<Array<Scalars['Int']>>;
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  sampleTypes?: InputMaybe<Array<SampleType>>;
  siteId?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  systemIds: Array<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type SampleSchedulesWithCount = {
  __typename?: 'SampleSchedulesWithCount';
  count: Scalars['Int'];
  items: Array<SampleSchedule>;
};

export type SampleSite = {
  __typename?: 'SampleSite';
  address?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  lastInspectionDate?: Maybe<Scalars['DateTime']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  photoUpload?: Maybe<Upload>;
  samplePointType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type SampleSiteCreateInput = {
  address?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  lastInspectionDate?: InputMaybe<Scalars['DateTime']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  photoId?: InputMaybe<Scalars['UUID']>;
  samplePointType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type SampleSiteUpdateInput = {
  address?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastInspectionDate?: InputMaybe<Scalars['DateTime']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  photoId?: InputMaybe<Scalars['UUID']>;
  samplePointType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type SampleSiteUpload = {
  __typename?: 'SampleSiteUpload';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  sampleSiteId: Scalars['UUID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadId: Scalars['UUID'];
};

export type SampleSitesInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SampleSitesWhere>;
};

export type SampleSitesWhere = {
  createdByUserId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum SampleType {
  Compliance = 'COMPLIANCE',
  Process = 'PROCESS',
  Research = 'RESEARCH'
}

export type ScheduledItem = {
  __typename?: 'ScheduledItem';
  assignee?: Maybe<UserNest>;
  assigneeId?: Maybe<Scalars['Int']>;
  comments: Array<ScheduledItemComment>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStackable: Scalars['Boolean'];
  notBefore?: Maybe<Scalars['DateTime']>;
  photoRequired: Scalars['Boolean'];
  photoUpload?: Maybe<Upload>;
  recurrenceType: RecurrenceType;
  scheduledAt: Scalars['DateTime'];
  sourceScheduleId: Scalars['String'];
  sourceScheduleType: SourceScheduleType;
  status: ScheduledItemStatus;
  system: SystemNest;
  systemId: Scalars['Int'];
  targetDate?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ScheduledItemComment = {
  __typename?: 'ScheduledItemComment';
  comment: Scalars['String'];
  commentType: ScheduledItemCommentType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  scheduledItemId: Scalars['UUID'];
  updatedAt: Scalars['DateTime'];
  user: UserNest;
  userId: Scalars['Int'];
};

export enum ScheduledItemCommentType {
  Complete = 'COMPLETE',
  Defer = 'DEFER',
  General = 'GENERAL',
  Reschedule = 'RESCHEDULE'
}

export type ScheduledItemCommentsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledItemCommentsWhere>;
};

export type ScheduledItemCommentsWhere = {
  commentType?: InputMaybe<ScheduledItemCommentType>;
  id?: InputMaybe<Scalars['UUID']>;
  scheduledItemId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type ScheduledItemCount = {
  __typename?: 'ScheduledItemCount';
  count: Scalars['Int'];
};

export enum ScheduledItemStatus {
  Completed = 'COMPLETED',
  Missed = 'MISSED',
  Pending = 'PENDING'
}

export type ScheduledItemUpload = {
  __typename?: 'ScheduledItemUpload';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  scheduledItemId: Scalars['UUID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  uploadId: Scalars['UUID'];
};

export type ScheduledItemsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScheduledItemsWhere>;
};

export type ScheduledItemsWhere = {
  assigneeIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['DateTime'];
  statuses?: InputMaybe<Array<ScheduledItemStatus>>;
  systemIds: Array<Scalars['Int']>;
  type?: InputMaybe<Array<SourceScheduleType>>;
};

export type ScheduledItemsWithCount = {
  __typename?: 'ScheduledItemsWithCount';
  count: Scalars['Int'];
  items: Array<ScheduledItem>;
};

export enum SelectableIcons {
  Audio = 'Audio',
  AutoAwesome = 'Auto_Awesome',
  Calendar = 'Calendar',
  Chat = 'Chat',
  CleanHands = 'CleanHands',
  Computer = 'Computer',
  Construction = 'Construction',
  Critical = 'Critical',
  Document = 'Document',
  Folder = 'Folder',
  Image = 'Image',
  Info = 'Info',
  Link = 'Link',
  Mail = 'Mail',
  Neutral = 'Neutral',
  None = 'None',
  Notification = 'Notification',
  Phone = 'Phone',
  Restart = 'Restart',
  Success = 'Success',
  SystemUpdate = 'System_Update',
  Video = 'Video',
  Warning = 'Warning'
}

export type SendManualReportEmailInput = {
  attachPdf?: InputMaybe<Scalars['Boolean']>;
  bcc?: InputMaybe<Array<ManualReportEmailAddressInput>>;
  cc?: InputMaybe<Array<ManualReportEmailAddressInput>>;
  comment?: InputMaybe<Scalars['String']>;
  distributionLists?: InputMaybe<Array<ManualReportEmailDistributionListInput>>;
  expiresAt: Scalars['DateTime'];
  reportSnapshotId: Scalars['UUID'];
  subject: Scalars['String'];
  to?: InputMaybe<Array<ManualReportEmailAddressInput>>;
};

export type SendManualReportEmailPayload = {
  __typename?: 'SendManualReportEmailPayload';
  emailEvent: ManualReportEmailEvent;
  publicUrl: Scalars['String'];
  reportSnapshot: ReportSnapshot;
  shareLinkId: Scalars['UUID'];
};

export type SetRuntimeLoggerOverrideInput = {
  durationMinutes: Scalars['Int'];
  level: RuntimeLogLevel;
  name: Scalars['String'];
};

export type SiteDataEntriesCollectionType = {
  __typename?: 'SiteDataEntriesCollectionType';
  current: MetricDataPointType;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
};

export type SiteDataEntriesDayDataPointType = {
  __typename?: 'SiteDataEntriesDayDataPointType';
  appliedAt: Scalars['DateTime'];
  dataPoint?: Maybe<TsDataPoint>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
  time?: Maybe<Scalars['String']>;
};

export type SiteDataEntriesDayType = {
  __typename?: 'SiteDataEntriesDayType';
  dataPoints: Array<SiteDataEntriesDayDataPointType>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
  metricType: MetricDataTypeEnum;
};

export type SiteDataEntriesHistoryCollectionType = {
  __typename?: 'SiteDataEntriesHistoryCollectionType';
  history: Array<MetricDataPointType>;
  id: Scalars['ID'];
  metricId: Scalars['Int'];
};

export type SiteDataEntryChangeType = {
  __typename?: 'SiteDataEntryChangeType';
  dataPoint: MetricDataPointType;
  entryIntervalDate?: Maybe<Scalars['String']>;
  entryIntervalTime?: Maybe<Scalars['String']>;
};

export type SiteDataEntryCompletionByDate = {
  __typename?: 'SiteDataEntryCompletionByDate';
  dailyCompletion: SiteIntervalCompletionStatus;
  intervalCompletions: Array<SiteIntervalCompletionStatus>;
  site: SiteNest;
};

export type SiteDataEntryCompletionByDateInput = {
  reportDate: Scalars['DateTime'];
  siteIds: Array<Scalars['Int']>;
};

export type SiteFlexMetric = {
  __typename?: 'SiteFlexMetric';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  folderViewOrder: Scalars['Int'];
  id: Scalars['UUID'];
  metric?: Maybe<MetricNest>;
  metricId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SiteFlexMetricDeleteInput = {
  hardDelete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
};

export type SiteFlexMetricRestoreInput = {
  id: Scalars['UUID'];
};

export type SiteFlexMetricUpdateInput = {
  folderViewOrder?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
};

export type SiteFlexMetricWithParentSite = {
  __typename?: 'SiteFlexMetricWithParentSite';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  folderViewOrder: Scalars['Int'];
  id: Scalars['UUID'];
  metric?: Maybe<MetricNest>;
  metricId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  parentSite: SiteNest;
  required: Scalars['Boolean'];
  siteId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type SiteFlexMetricsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: SiteFlexMetricsWhere;
};

export type SiteFlexMetricsUpdateInput = {
  inputs: Array<SiteFlexMetricUpdateInput>;
};

export type SiteFlexMetricsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  metricId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  siteId: Scalars['Int'];
};

export type SiteIntervalCompletionStatus = {
  __typename?: 'SiteIntervalCompletionStatus';
  dataEntryCompletion?: Maybe<DataEntryCompletion>;
  hasRequiredMetrics: Scalars['Boolean'];
  interval?: Maybe<IntervalNest>;
};

export type SiteNest = {
  __typename?: 'SiteNest';
  addresses: Array<Address>;
  components: Array<ComponentNest>;
  createdAt: Scalars['DateTime'];
  dataEntryCompletionEmail: DataEntryCompletionEmailOption;
  dataEntryCompletionEnabled: Scalars['Boolean'];
  dataModelSite?: Maybe<SiteNest>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayNameBreadcrumbs: Array<Breadcrumb>;
  emoji?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  flex: Scalars['Boolean'];
  foldersWithMetricIdsAndOrder: Array<FolderWithMetricIdsAndOrder>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  intervals: Array<IntervalNest>;
  isEntry: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  licenseId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Float']>;
  metrics: Array<MetricNest>;
  mirrorSiteId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  npdesPermitNumber?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessNest>;
  siteFlexMetricsWithParentSite?: Maybe<Array<SiteFlexMetricWithParentSite>>;
  siteType: Scalars['String'];
  sourceMetrics: Array<MetricWithCalculatedMetric>;
  systemId: Scalars['Int'];
  /** @deprecated No longer in use */
  timeSeriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type SiteNestComponentsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestFoldersWithMetricIdsAndOrderArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestIntervalsArgs = {
  entryDate?: InputMaybe<Scalars['Date']>;
};


export type SiteNestMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestProcessesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteNestSiteFlexMetricsWithParentSiteArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SiteOutOfIdealRangeMetricType = {
  __typename?: 'SiteOutOfIdealRangeMetricType';
  metric: MetricType;
  outOfIdealRange: Array<TsDataPoint>;
};

export type SiteOutOfRangeMetricType = {
  __typename?: 'SiteOutOfRangeMetricType';
  metric: MetricType;
  outOfRange: Array<TsDataPoint>;
};

export type SiteType = {
  __typename?: 'SiteType';
  addresses: Array<Address>;
  dataEntries: Array<SiteDataEntriesCollectionType>;
  dataEntriesDay: Array<SiteDataEntriesDayType>;
  dataEntriesHistory: Array<SiteDataEntriesHistoryCollectionType>;
  dataEntryCompletionEmail?: Maybe<DataEntryCompletionEmailOption>;
  dataEntryCompletionEnabled?: Maybe<Scalars['Boolean']>;
  emoji?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadataJSON?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  flex?: Maybe<Scalars['Boolean']>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  intervals: Array<Interval>;
  isEntry?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Latitude']>;
  licenseId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Longitude']>;
  metrics: Array<MetricType>;
  name?: Maybe<Scalars['String']>;
  /** NPDES Permit Number - National permists searchable at https://www.epa.gov/npdes-permits */
  npdesPermitNumber?: Maybe<Scalars['String']>;
  operator?: Maybe<UserInfoType>;
  operatorId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  outOfIdealRangeMetrics: Array<SiteOutOfIdealRangeMetricType>;
  outOfRangeMetrics: Array<SiteOutOfRangeMetricType>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessType>;
  siteType?: Maybe<SiteTypeEnum>;
  system: SystemType;
  systemId: Scalars['Int'];
};


export type SiteTypeDataEntriesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  reportDate: Scalars['Date'];
};


export type SiteTypeDataEntriesDayArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds: Array<Scalars['Int']>;
  reportDate: Scalars['Date'];
};


export type SiteTypeDataEntriesHistoryArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  reportDate: Scalars['Date'];
};


export type SiteTypeOutOfIdealRangeMetricsArgs = {
  endDateTime: Scalars['Timestamp'];
  startDateTime: Scalars['Timestamp'];
};


export type SiteTypeOutOfRangeMetricsArgs = {
  endDateTime: Scalars['Timestamp'];
  startDateTime: Scalars['Timestamp'];
};


export type SiteTypeProcessesArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

/** Site Types */
export enum SiteTypeEnum {
  BoosterPumpStation = 'BOOSTER_PUMP_STATION',
  ElevatedStorage = 'ELEVATED_STORAGE',
  Generic = 'GENERIC',
  GraywaterStation = 'GRAYWATER_STATION',
  GroundWaterPlant = 'GROUND_WATER_PLANT',
  Industrial = 'INDUSTRIAL',
  LiftStation = 'LIFT_STATION',
  PressureReducingStation = 'PRESSURE_REDUCING_STATION',
  StormwaterStation = 'STORMWATER_STATION',
  Summary = 'SUMMARY',
  SurfaceWaterPlant = 'SURFACE_WATER_PLANT',
  SystemInterconnect = 'SYSTEM_INTERCONNECT',
  WastewaterMeteringStation = 'WASTEWATER_METERING_STATION',
  WastewaterMultipleTypes = 'WASTEWATER_MULTIPLE_TYPES',
  WastewaterTreatmentPlant = 'WASTEWATER_TREATMENT_PLANT',
  WaterMonitoringStation = 'WATER_MONITORING_STATION',
  WaterMultipleTypes = 'WATER_MULTIPLE_TYPES',
  Well = 'WELL'
}

export type SiteUpdateInput = {
  dataEntryCompletionEmail?: InputMaybe<DataEntryCompletionEmailOption>;
  dataEntryCompletionEnabled?: InputMaybe<Scalars['Boolean']>;
  emoji?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  isEntry?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Latitude']>;
  licenseId?: InputMaybe<Scalars['Int']>;
  longitude?: InputMaybe<Scalars['Longitude']>;
  name?: InputMaybe<Scalars['String']>;
  npdesPermitNumber?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  phoneNumberId?: InputMaybe<Scalars['Int']>;
  siteType?: InputMaybe<Scalars['String']>;
};

export type SiteWithProcesses = {
  __typename?: 'SiteWithProcesses';
  addresses: Array<Address>;
  components: Array<ComponentNest>;
  createdAt: Scalars['DateTime'];
  dataEntryCompletionEmail: DataEntryCompletionEmailOption;
  dataEntryCompletionEnabled: Scalars['Boolean'];
  dataModelSite?: Maybe<SiteNest>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  displayNameBreadcrumbs: Array<Breadcrumb>;
  emoji?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  flex: Scalars['Boolean'];
  foldersWithMetricIdsAndOrder: Array<FolderWithMetricIdsAndOrder>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  intervals: Array<IntervalNest>;
  isEntry: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  licenseId?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['Float']>;
  metrics: Array<MetricNest>;
  mirrorSiteId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  npdesPermitNumber?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessWithComponentsAndMetrics>;
  siteFlexMetricsWithParentSite?: Maybe<Array<SiteFlexMetricWithParentSite>>;
  siteType: Scalars['String'];
  sourceMetrics: Array<MetricWithCalculatedMetric>;
  systemId: Scalars['Int'];
  /** @deprecated No longer in use */
  timeSeriesEnabled: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};


export type SiteWithProcessesComponentsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteWithProcessesFoldersWithMetricIdsAndOrderArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type SiteWithProcessesIntervalsArgs = {
  entryDate?: InputMaybe<Scalars['Date']>;
};


export type SiteWithProcessesMetricsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
};


export type SiteWithProcessesSiteFlexMetricsWithParentSiteArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SitesInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SitesWhere>;
};

export type SitesWhere = {
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['Int']>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type SnoozeAllOrgRetentionRisksInput = {
  date: Scalars['DateTime'];
  orgId: Scalars['Int'];
};

export type SnoozeRetentionRiskInput = {
  date: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export enum SourceScheduleType {
  Activity = 'ACTIVITY',
  ChemicalReceiving = 'CHEMICAL_RECEIVING',
  Samples = 'SAMPLES'
}

export type SsoConfigurationNest = {
  __typename?: 'SsoConfigurationNest';
  audience?: Maybe<Scalars['String']>;
  authority: Scalars['String'];
  clientId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  facilitySearchUrl?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  isNameEditable: Scalars['Boolean'];
  issuer?: Maybe<Scalars['String']>;
  logoSvg?: Maybe<Scalars['String']>;
  provisioner?: Maybe<Scalars['String']>;
  scope: Scalars['String'];
  signoutRedirectUrl: Scalars['String'];
  systemSearchUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userDirectoryAuthVaultEntry?: Maybe<Scalars['String']>;
  userDirectoryEnabled: Scalars['Boolean'];
  userDirectorySearchUrl?: Maybe<Scalars['String']>;
};

export type StartMirroringInput = {
  siteId: Scalars['Int'];
  sourceSiteId: Scalars['Int'];
};

export type StopMirroringInput = {
  siteId: Scalars['Int'];
};

export type SubmitSiteRecalculationInput = {
  allMetrics?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  endDate: Scalars['Date'];
  includeInterpolatedMetrics?: InputMaybe<Scalars['Boolean']>;
  processId?: InputMaybe<Scalars['Int']>;
  siteId: Scalars['Int'];
  startDate: Scalars['Date'];
};

export type Subscription = {
  __typename?: 'Subscription';
  onAuditEventPublished: AuditEventNest;
  onCalcQueueJobsPublished: JobEvent;
  onCalcQueueStatsPublished: QueueStats;
  onDataEntryCompletionPublished: DataEntryCompletion;
  onLogBookEntryPublished: LogBookEntryNest;
  onNotificationPublished?: Maybe<Notification>;
  onScheduledItemPublished: ScheduledItem;
  onSiteDataEntryChanged: SiteDataEntryChangeType;
};


export type SubscriptionOnAuditEventPublishedArgs = {
  accessToken: Scalars['String'];
  input: AuditEventSubscriptionInput;
};


export type SubscriptionOnCalcQueueJobsPublishedArgs = {
  filter?: InputMaybe<JobsFilterInput>;
};


export type SubscriptionOnCalcQueueStatsPublishedArgs = {
  accessToken: Scalars['String'];
};


export type SubscriptionOnDataEntryCompletionPublishedArgs = {
  accessToken: Scalars['String'];
  siteId: Scalars['Float'];
};


export type SubscriptionOnLogBookEntryPublishedArgs = {
  accessToken: Scalars['String'];
  siteId: Scalars['Float'];
};


export type SubscriptionOnScheduledItemPublishedArgs = {
  accessToken: Scalars['String'];
};


export type SubscriptionOnSiteDataEntryChangedArgs = {
  accessToken: Scalars['String'];
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  reportDate: Scalars['DateType'];
  siteId: Scalars['Int'];
  subscriptionClientId: Scalars['String'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SystemGroupInput = {
  systemGroupId: Scalars['Int'];
};

export enum SystemGroupRoleEnum {
  Admin = 'Admin',
  Editor = 'Editor',
  NoAccess = 'NoAccess',
  ReadOnly = 'ReadOnly',
  Supervisor = 'Supervisor'
}

export type SystemGroupType = {
  __typename?: 'SystemGroupType';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organization: OrganizationType;
  organizationId: Scalars['Int'];
  parentSystemGroup?: Maybe<SystemGroupType>;
  parentSystemGroupId?: Maybe<Scalars['Int']>;
  systemGroups: Array<SystemGroupType>;
  systems: Array<SystemType>;
  users: Array<UserInfoType>;
};

export type SystemGroupsInput = {
  where: SystemGroupsWhere;
};

export type SystemGroupsWhere = {
  organizationId: Scalars['Int'];
};

export type SystemNest = {
  __typename?: 'SystemNest';
  addresses: Array<Address>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  hideDataSites: Scalars['Boolean'];
  id: Scalars['Int'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isTemplate: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  myRole: SystemGroupRoleEnum;
  name: Scalars['String'];
  operator?: Maybe<UserNest>;
  operatorId?: Maybe<Scalars['Int']>;
  organization: OrganizationNest;
  organizationId: Scalars['Int'];
  parentSystemGroupId: Scalars['Int'];
  permits: Array<Permit>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  regulatoryId?: Maybe<Scalars['String']>;
  timeZone: Scalars['String'];
  type: Scalars['String'];
  userDirectoryEnabled: Scalars['Boolean'];
  users: Array<UserNest>;
};


export type SystemNestUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The Role of a User
 * TODO: When we move from schema-first sdl to the code-first nestJS method,
 * we can register the `SystemRole` enum from waterly/utils and remove this one to prevent duplication.
 */
export enum SystemRoleType {
  /** Never should be set, NoAccess is a default response when no role is set in the db. */
  NoAccess = 'NoAccess',
  Operator = 'Operator',
  ReadOnly = 'ReadOnly',
  Supervisor = 'Supervisor',
  Unknown = 'Unknown'
}

export type SystemType = {
  __typename?: 'SystemType';
  addresses: Array<Address>;
  components: Array<ComponentType>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadataJSON?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  hasSitesWithIntervals: Scalars['Boolean'];
  hideDataSites: Scalars['Boolean'];
  id: Scalars['Int'];
  isFavorite: Scalars['Boolean'];
  isTemplate: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  metrics: Array<MetricType>;
  /**
   * Role for the current user, as it applies to this system.
   * Users with the `superadmin` flag always return as Supervisor
   */
  myRole: SystemGroupRoleEnum;
  name: Scalars['String'];
  operator?: Maybe<UserInfoType>;
  operatorId?: Maybe<Scalars['Int']>;
  organization: OrganizationType;
  organizationId: Scalars['Int'];
  parentSystemGroup?: Maybe<SystemGroupType>;
  parentSystemGroupId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  processes: Array<ProcessType>;
  regulatoryId?: Maybe<Scalars['String']>;
  sites: Array<SiteType>;
  timeZone: Scalars['TimeZone'];
  type?: Maybe<SystemTypeEnum>;
  userDirectoryEnabled: Scalars['Boolean'];
  users: Array<UserInfoType>;
};


export type SystemTypeUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export { SystemTypeEnum };

export type SystemWithSites = {
  __typename?: 'SystemWithSites';
  addresses: Array<Address>;
  externalId?: Maybe<Scalars['String']>;
  externalMetadata?: Maybe<Scalars['JSON']>;
  externalOwner?: Maybe<Scalars['String']>;
  hideDataSites: Scalars['Boolean'];
  id: Scalars['Int'];
  isFavorite?: Maybe<Scalars['Boolean']>;
  isTemplate: Scalars['Boolean'];
  licenseId?: Maybe<Scalars['Int']>;
  myRole: SystemGroupRoleEnum;
  name: Scalars['String'];
  operator?: Maybe<UserNest>;
  operatorId?: Maybe<Scalars['Int']>;
  organization: OrganizationNest;
  organizationId: Scalars['Int'];
  parentSystemGroupId: Scalars['Int'];
  permits: Array<Permit>;
  phoneNumber?: Maybe<PhoneNumberNest>;
  phoneNumberId?: Maybe<Scalars['Int']>;
  regulatoryId?: Maybe<Scalars['String']>;
  sites: Array<SiteWithProcesses>;
  timeZone: Scalars['String'];
  type: Scalars['String'];
  userDirectoryEnabled: Scalars['Boolean'];
  users: Array<UserNest>;
};


export type SystemWithSitesUsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type SystemsInput = {
  where?: InputMaybe<SystemsWhere>;
};

export type SystemsWhere = {
  minRoleRequired?: InputMaybe<SystemRoleType>;
  organizationId?: InputMaybe<Scalars['Int']>;
};

export type TsDataPoint = {
  __typename?: 'TSDataPoint';
  appliedAt: Scalars['DateTime'];
  booleanValue?: Maybe<Scalars['Boolean']>;
  calculatedNondetectValue?: Maybe<Scalars['Boolean']>;
  calculatedValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  connectValue?: Maybe<Scalars['String']>;
  dateTimeValue?: Maybe<Scalars['String']>;
  dateValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  effectiveNumericValue?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  isArchived?: Maybe<Scalars['Boolean']>;
  isCalculatedResult?: Maybe<Scalars['Boolean']>;
  isInterpolated: Scalars['Boolean'];
  isNondetect: Scalars['Boolean'];
  journalEntryRecordId: Scalars['ID'];
  jsonValue?: Maybe<Scalars['String']>;
  locatorEntityId: Scalars['String'];
  locatorEntityType: Scalars['String'];
  locatorNamespace: Scalars['String'];
  measuredAt: Scalars['DateTime'];
  metaData: TsDataPointMetadata;
  metricId: Scalars['Int'];
  numericValue?: Maybe<Scalars['Float']>;
  reportDate: Scalars['String'];
  storedAt: Scalars['DateTime'];
  textValue?: Maybe<Scalars['String']>;
  timeValue?: Maybe<Scalars['String']>;
  type: MetricDataTypeEnum;
  value?: Maybe<Scalars['String']>;
  valueType: TSDataPointValueType;
};

export type TsDataPointMetadata = {
  __typename?: 'TSDataPointMetadata';
  connectValue?: Maybe<Scalars['String']>;
  edgeDeviceSubmissionId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  intervalId?: Maybe<Scalars['Int']>;
  reportDate: Scalars['String'];
};

export { TSDataPointValueType };

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  keynameTagCount: Scalars['Int'];
  logBookEntryTagCount: Scalars['Int'];
  name: Scalars['String'];
  nameEs?: Maybe<Scalars['String']>;
  organization?: Maybe<OrganizationNest>;
  organizationId?: Maybe<Scalars['Int']>;
  reportTagCount: Scalars['Int'];
  type: TagType;
  updatedAt: Scalars['DateTime'];
};

export type TagMappingType = {
  __typename?: 'TagMappingType';
  edgeDevice?: Maybe<EdgeDeviceNest>;
  edgeDeviceId: Scalars['Int'];
  id: Scalars['Int'];
  metric: MetricNest;
  metricId: Scalars['Int'];
  site: SiteNest;
  system: SystemNest;
  tagName: Scalars['String'];
};

export type TagMappingsInput = {
  order: TagMappingsOrder;
  where: TagMappingsWhere;
};

export type TagMappingsOrder = {
  direction?: InputMaybe<Scalars['String']>;
  skip: Scalars['Int'];
  take?: InputMaybe<Scalars['Int']>;
};

export type TagMappingsResult = {
  __typename?: 'TagMappingsResult';
  data: Array<TagMappingType>;
  id: Scalars['ID'];
  total: Scalars['Int'];
};

export type TagMappingsWhere = {
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export enum TagType {
  All = 'ALL',
  Keyname = 'KEYNAME',
  LogBook = 'LOG_BOOK',
  MetricRange = 'METRIC_RANGE',
  Report = 'REPORT'
}

export type TagsInput = {
  includeGlobal?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where: TagsWhere;
};

export type TagsWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds: Array<Scalars['Int']>;
  types?: InputMaybe<Array<TagType>>;
};

export type TagsWithCount = {
  __typename?: 'TagsWithCount';
  count: Scalars['Int'];
  items: Array<Tag>;
};

export enum TimeFormatEnum {
  Military = 'MILITARY',
  Standard = 'STANDARD',
  TrueMilitary = 'TRUE_MILITARY'
}

export type TransactionInfoWithCalcClusterDebugLogs = {
  __typename?: 'TransactionInfoWithCalcClusterDebugLogs';
  id: Scalars['UUID'];
  logs: Array<CalcClusterDebugLog>;
  originTimestamp: Scalars['DateTime'];
  transactionId: Scalars['UUID'];
};

export type TransferComponentInput = {
  componentId: Scalars['Int'];
  processId: Scalars['Int'];
};

export type TransferMetricInput = {
  metricId: Scalars['Int'];
  targetComponentId?: InputMaybe<Scalars['Int']>;
  targetProcessId: Scalars['Int'];
  targetSiteId: Scalars['Int'];
};

export type TransferMetricToFolderInput = {
  destinationFolderId: Scalars['UUID'];
  metricId: Scalars['Int'];
  oldFolderId: Scalars['UUID'];
  siteId: Scalars['Int'];
};

export type TransferSystemInput = {
  systemId: Scalars['Int'];
  targetOrganizationId: Scalars['Int'];
  targetSystemGroupId?: InputMaybe<Scalars['Int']>;
};

export type TrendNest = {
  __typename?: 'TrendNest';
  id: Scalars['Int'];
  isGlobal: Scalars['Boolean'];
  keynameFilters: Array<Scalars['String']>;
  name: Scalars['String'];
  owner: UserNest;
  ownerId: Scalars['Int'];
  resolvedMetricIds: Array<Scalars['Int']>;
  system?: Maybe<SystemNest>;
  systemId?: Maybe<Scalars['Int']>;
  systemType: SystemTypeEnum;
};


export type TrendNestResolvedMetricIdsArgs = {
  systemId: Scalars['Int'];
};

export type TrendsQueryInput = {
  systemId: Scalars['Int'];
};

export type TriggerAnalyticsReportSnapshotInput = {
  bindings?: InputMaybe<Scalars['JSONObject']>;
  configFileName?: InputMaybe<Scalars['String']>;
  enterpriseReportId: Scalars['UUID'];
  mode?: AnalyticsReportRunMode;
  reportDateTime?: InputMaybe<Scalars['DateTime']>;
  snapshotConfig?: InputMaybe<Scalars['JSONObject']>;
  snapshotId?: InputMaybe<Scalars['UUID']>;
  successStatus?: InputMaybe<ReportStatus>;
};

/** A US State */
export enum UsStateEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type UnitCreateInput = {
  isInterpolatable?: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UnitNest = {
  __typename?: 'UnitNest';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  isInterpolatable: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UnitType = {
  __typename?: 'UnitType';
  id: Scalars['Int'];
  isInterpolatable: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UnitTypeInput = {
  id?: InputMaybe<Scalars['Int']>;
  isInterpolatable: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UnitUpdateInput = {
  id: Scalars['Int'];
  isInterpolatable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UnitsInput = {
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitsWhere>;
};

export type UnitsWhere = {
  id?: InputMaybe<Scalars['Int']>;
  isInterpolatable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  label?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<AddressPurpose>;
  recipientName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type UpdateColumnGroupInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateColumnGroupItemInput = {
  aggregation?: InputMaybe<ColumnAggregation>;
  calculationType?: InputMaybe<ColumnCalculation>;
  id: Scalars['UUID'];
  intervalId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpdateComponentsInput = {
  components: Array<ComponentUpdateInput>;
};

export type UpdateConstantDefinitionInput = {
  dataType?: InputMaybe<ConstantDataType>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  keyname?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  precision?: InputMaybe<Scalars['Int']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type UpdateEdgeDeviceNestInput = {
  deviceName?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<EdgeDeviceTypeNest>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  organizationId?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type UpdateEnterpriseReportShareLinkInput = {
  expiresAt: Scalars['DateTime'];
  id: Scalars['UUID'];
};

export type UpdateEnterpriseReportShareLinkPayload = {
  __typename?: 'UpdateEnterpriseReportShareLinkPayload';
  publicUrl: Scalars['String'];
  shareLink: EnterpriseReportShareLink;
};

export type UpdateFolderInput = {
  color?: InputMaybe<Scalars['String']>;
  folderId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type UpdateFoldersInput = {
  folders: Array<UpdateFolderInput>;
};

export type UpdateLicenseInput = {
  authority?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  licenseLabel?: InputMaybe<Scalars['String']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateLogBookEntryDashboardViewInput = {
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['Int']>;
  siteIds?: InputMaybe<Array<Scalars['Int']>>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
  userIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type UpdateLogBookEntryInput = {
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateMetricForReportInput = {
  enabled: Scalars['Boolean'];
  intervalId?: InputMaybe<Scalars['Int']>;
  metricId: Scalars['Int'];
  reportDefinitionId: Scalars['Int'];
};

export type UpdateMetricInput = {
  belowRlValue?: InputMaybe<Scalars['Float']>;
  calculated?: InputMaybe<Scalars['Boolean']>;
  calculationName?: InputMaybe<Scalars['String']>;
  canBeAveraged?: InputMaybe<CanBeAveraged>;
  canBeCounted?: InputMaybe<Scalars['Boolean']>;
  canBeMaximized?: InputMaybe<Scalars['Boolean']>;
  canBeMinimized?: InputMaybe<Scalars['Boolean']>;
  canBeTotaled?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['Int']>;
  copyPreviousValueEnabled?: InputMaybe<Scalars['Boolean']>;
  dataPointCommentPolicy?: InputMaybe<DataPointCommentPolicy>;
  dataType?: InputMaybe<MetricDataTypeEnum>;
  detectionLimit?: InputMaybe<Scalars['Float']>;
  expression?: InputMaybe<Scalars['String']>;
  hideFromDataEntry?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  internalKeyname?: InputMaybe<Scalars['String']>;
  interpolated?: InputMaybe<Scalars['Boolean']>;
  intervalIds?: InputMaybe<Array<Scalars['Int']>>;
  isDecreasing?: InputMaybe<Scalars['Boolean']>;
  isIncreasing?: InputMaybe<Scalars['Boolean']>;
  isLockedByWaterly?: InputMaybe<Scalars['Boolean']>;
  isReportComments?: InputMaybe<Scalars['Boolean']>;
  keynameId?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['BigInt']>;
  minValue?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  notificationEnabled?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  precision?: InputMaybe<Scalars['Int']>;
  processId?: InputMaybe<Scalars['Int']>;
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMin?: InputMaybe<Scalars['Float']>;
  reportingLimit?: InputMaybe<Scalars['Float']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sourceMetricIds?: InputMaybe<Array<Scalars['Int']>>;
  treatBelowRlAsPercent?: InputMaybe<Scalars['Boolean']>;
  unitId?: InputMaybe<Scalars['Int']>;
};

export type UpdateMetricsInput = {
  inputs: Array<UpdateMetricInput>;
};

export type UpdateNotificationInput = {
  appearance: NotificationAppearance;
  dismissable?: InputMaybe<Scalars['Boolean']>;
  displayPosition: NotificationDisplayPosition;
  endDate?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<SelectableIcons>;
  message: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  notificationId: Scalars['UUID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  systemGroupId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationInput = {
  dateFormat?: InputMaybe<OrganizationDateFormat>;
  fiscalYearStartDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  selfServiceEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationIntegrationInput = {
  id: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
};

export type UpdatePhoneNumberInput = {
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdatePhraseInput = {
  bodyText?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProcessForReportInput = {
  enabled: Scalars['Boolean'];
  processId: Scalars['Int'];
};

export type UpdateProcessesInput = {
  processes: Array<ProcessUpdateInput>;
};

export type UpdateReportDefinitionInput = {
  annualPeriod?: InputMaybe<Scalars['String']>;
  configSchemaId?: InputMaybe<Scalars['String']>;
  customFooter?: InputMaybe<Scalars['String']>;
  fields?: InputMaybe<Array<ReportDefinitionFieldChange>>;
  id: Scalars['Int'];
  metadata?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  paperOrientation?: InputMaybe<PaperOrientationEnum>;
  paperSize?: InputMaybe<PaperSizeEnum>;
  reportGroupId?: InputMaybe<Scalars['Int']>;
  reportTemplateId?: InputMaybe<Scalars['Int']>;
  showDayOfWeek?: InputMaybe<Scalars['Boolean']>;
  supplementaryEnabled?: InputMaybe<Scalars['Boolean']>;
  timeFormat?: InputMaybe<TimeFormatEnum>;
};

export type UpdateReportDistributionListInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  members?: InputMaybe<Array<ReportDistributionListMemberInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateReportNodeInput = {
  id: Scalars['UUID'];
  order?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateReportNodesInput = {
  updateReportNodeInputs: Array<UpdateReportNodeInput>;
};

export type UpdateReportingReportDefinitionGroupAssignmentInput = {
  id: Scalars['Int'];
  order: Scalars['Int'];
  reportGroupId?: InputMaybe<Scalars['Int']>;
};

export type UpdateReportingReportDefinitionGroupsInput = {
  inputs: Array<UpdateReportingReportDefinitionGroupAssignmentInput>;
};

export type UpdateReportingReportGroupInput = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type UpdateSampleScheduleInput = {
  analyteGroupId?: InputMaybe<Scalars['UUID']>;
  analyteIds?: InputMaybe<Array<Scalars['UUID']>>;
  defaultAssigneeId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isStackable?: InputMaybe<Scalars['Boolean']>;
  notBeforeUnit?: InputMaybe<DurationUnit>;
  notBeforeValue?: InputMaybe<Scalars['Int']>;
  photoRequired?: InputMaybe<Scalars['Boolean']>;
  recurrenceType?: InputMaybe<RecurrenceType>;
  rrule?: InputMaybe<Scalars['String']>;
  sampleSiteId?: InputMaybe<Scalars['UUID']>;
  sampleType?: InputMaybe<SampleType>;
  siteId?: InputMaybe<Scalars['Int']>;
  systemId?: InputMaybe<Scalars['Int']>;
  targetBeforeUnit?: InputMaybe<DurationUnit>;
  targetBeforeValue?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateScheduledItemCommentInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateScheduledItemInput = {
  assigneeId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  commentType?: InputMaybe<ScheduledItemCommentType>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  notBefore?: InputMaybe<Scalars['DateTime']>;
  photoId?: InputMaybe<Scalars['UUID']>;
  photoRequired?: InputMaybe<Scalars['Boolean']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<ScheduledItemStatus>;
  systemId?: InputMaybe<Scalars['Int']>;
  targetDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteComponentInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  metrics?: InputMaybe<Array<UpdateSiteMetricInput>>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateSiteMetricInput = {
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateSiteProcessInput = {
  components?: InputMaybe<Array<UpdateSiteComponentInput>>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  metrics?: InputMaybe<Array<UpdateSiteMetricInput>>;
  name: Scalars['String'];
  order: Scalars['Int'];
};

export type UpdateSiteStructureInput = {
  id: Scalars['Int'];
  processes: Array<UpdateSiteProcessInput>;
};

export type UpdateSitesInput = {
  sites: Array<SiteUpdateInput>;
};

export type UpdateSystemGroupInput = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  parentSystemGroupId?: InputMaybe<Scalars['Int']>;
};

export type UpdateSystemInput = {
  address?: InputMaybe<UpsertAddressInput>;
  externalId?: InputMaybe<Scalars['String']>;
  externalOwner?: InputMaybe<Scalars['String']>;
  hideDataSites?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isTemplate?: InputMaybe<Scalars['Boolean']>;
  licenseId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operatorId?: InputMaybe<Scalars['Int']>;
  parentSystemGroupId?: InputMaybe<Scalars['Int']>;
  phoneNumberId?: InputMaybe<Scalars['Int']>;
  publicWaterSystemIdPermit?: InputMaybe<PublicWaterSystemIdPermitInput>;
  regulatoryId?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['TimeZone']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateTagInput = {
  color?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  nameEs?: InputMaybe<Scalars['String']>;
  tagId: Scalars['UUID'];
  type?: InputMaybe<TagType>;
};

export type UpdateTrendInput = {
  id: Scalars['Int'];
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  keynameFilters?: InputMaybe<Array<Scalars['String']>>;
  metricIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  systemType?: InputMaybe<SystemTypeEnum>;
};

export type UpdateUploadInput = {
  description?: InputMaybe<Scalars['String']>;
  fileLength?: InputMaybe<Scalars['Float']>;
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  mimeType?: InputMaybe<Scalars['MimeType']>;
};

export type UpdateUserRoleForSystemGroupInput = {
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UpdateUserRoleForSystemInput = {
  role: SystemRoleType;
  systemId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UpdateWeatherDataStationInput = {
  id: Scalars['UUID'];
  latitude: Scalars['Float'];
  locationName: Scalars['String'];
  longitude: Scalars['Float'];
  stateCode?: InputMaybe<Scalars['String']>;
  usgsStationId?: InputMaybe<Scalars['String']>;
};

export type Upload = {
  __typename?: 'Upload';
  blobId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  fileLength: Scalars['Int'];
  fileName: Scalars['String'];
  id: Scalars['UUID'];
  mimeType: Scalars['MimeType'];
  organizationId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

/** Information used by a client to upload a file to storage */
export type UploadBlobInfo = {
  __typename?: 'UploadBlobInfo';
  blobId: Scalars['String'];
  downloadUrl: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['MimeType']>;
  uploadHeadersJSON: Scalars['String'];
  uploadToken: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type UploadsWithCount = {
  __typename?: 'UploadsWithCount';
  count: Scalars['Int'];
  items: Array<Upload>;
};

export type UpsertAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  label?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  purpose?: InputMaybe<AddressPurpose>;
  recipientName?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type UpsertConstantValueInput = {
  constantDefinitionId: Scalars['Int'];
  effectiveDate: Scalars['Date'];
  note?: InputMaybe<Scalars['String']>;
  numericValue?: InputMaybe<Scalars['Float']>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type UpsertDataEntryCompletionInput = {
  intervalTime?: InputMaybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  reportDate: Scalars['DateTime'];
  sendEmail?: InputMaybe<Scalars['Boolean']>;
  siteId: Scalars['Int'];
};

export type UpsertMetricRangeInput = {
  color: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  ideal: Scalars['Boolean'];
  maxTagId?: InputMaybe<Scalars['UUID']>;
  minTagId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  notificationEnabled: Scalars['Boolean'];
  rangeMax?: InputMaybe<Scalars['Float']>;
  rangeMaxInclusive: Scalars['Boolean'];
  rangeMin?: InputMaybe<Scalars['Float']>;
  rangeMinInclusive: Scalars['Boolean'];
};

export type UpsertMetricRangesInput = {
  metricId: Scalars['Int'];
  ranges: Array<UpsertMetricRangeInput>;
};

export type UserInfoType = {
  __typename?: 'UserInfoType';
  email: Scalars['String'];
  enableIphoneMetricNumberInput: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  externalMetadataJSON?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  licenses: Array<LicenseNest>;
  pending: Scalars['Boolean'];
  permissions: Array<UserOrganizationPermission>;
  phoneNumbers: Array<PhoneNumberNest>;
  primaryOrganization: OrganizationType;
  primaryOrganizationDateFormat: OrganizationDateFormat;
  primaryOrganizationId: Scalars['Int'];
  readonlySuperadmin: Scalars['Boolean'];
  roleForSystem: SystemRoleType;
  roleForSystemGroup: SystemGroupRoleEnum;
  ssoConfig: SsoConfigurationType;
  subject: Scalars['String'];
  superadmin: Scalars['Boolean'];
};


export type UserInfoTypeRoleForSystemArgs = {
  systemId: Scalars['Int'];
};


export type UserInfoTypeRoleForSystemGroupArgs = {
  systemGroupId: Scalars['Int'];
};

export type UserJobCount = {
  __typename?: 'UserJobCount';
  count: Scalars['Int'];
  senderEmail: Scalars['String'];
};

export enum UserManagerOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export enum UserManagerOrderField {
  CreatedAt = 'CreatedAt',
  DeletedAt = 'DeletedAt',
  Email = 'Email',
  FirstName = 'FirstName',
  Id = 'Id',
  IdpKey = 'IdpKey',
  LastLoginAt = 'LastLoginAt',
  LastName = 'LastName',
  Pending = 'Pending',
  PrimaryOrganizationName = 'PrimaryOrganizationName',
  ReadonlySuperadmin = 'ReadonlySuperadmin',
  Superadmin = 'Superadmin'
}

export type UserManagerUser = {
  __typename?: 'UserManagerUser';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['Int'];
  idpKey: Scalars['String'];
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  pending: Scalars['Boolean'];
  primaryOrganizationName?: Maybe<Scalars['String']>;
  readonlySuperadmin: Scalars['Boolean'];
  superadmin: Scalars['Boolean'];
};

export type UserManagerUserDetailsInput = {
  showArchived?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
};

export type UserManagerUsersCsvExportInput = {
  filter?: InputMaybe<UserManagerUsersFilterInput>;
  orderBy?: InputMaybe<Array<UserManagerUsersOrderByInput>>;
};

export type UserManagerUsersFilterInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  idpKeys?: InputMaybe<Array<Scalars['String']>>;
  organizationIds?: InputMaybe<Array<Scalars['Int']>>;
  pending?: InputMaybe<Scalars['Boolean']>;
  readonlySuperadmin?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  showArchived?: InputMaybe<Scalars['Boolean']>;
  showDisabled?: InputMaybe<Scalars['Boolean']>;
  superadmin?: InputMaybe<Scalars['Boolean']>;
};

export type UserManagerUsersInput = {
  filter?: InputMaybe<UserManagerUsersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserManagerUsersOrderByInput>>;
};

export type UserManagerUsersOrderByInput = {
  direction: UserManagerOrderDirection;
  field: UserManagerOrderField;
};

export type UserManagerUsersPage = {
  __typename?: 'UserManagerUsersPage';
  count: Scalars['Int'];
  items: Array<UserManagerUser>;
};

export type UserNest = {
  __typename?: 'UserNest';
  displayName: Scalars['String'];
  email: Scalars['EmailAddress'];
  enableIphoneMetricNumberInput: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  externalOwner?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  fullNameOrEmail: Scalars['String'];
  id: Scalars['Int'];
  idpKey?: Maybe<Scalars['String']>;
  lastLoginAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  licenses: Array<LicenseNest>;
  pending?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Array<UserOrganizationPermissionNest>>;
  phoneNumbers?: Maybe<Array<PhoneNumberNest>>;
  primaryOrganizationId: Scalars['Int'];
  readonlySuperadmin?: Maybe<Scalars['Boolean']>;
  roleForSystem: Scalars['String'];
  ssoConfig?: Maybe<SsoConfigurationNest>;
  subject: Scalars['String'];
  superadmin: Scalars['Boolean'];
};


export type UserNestRoleForSystemArgs = {
  systemId: Scalars['Int'];
};

export type UserOrganizationPermission = {
  __typename?: 'UserOrganizationPermission';
  /** The organization id */
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  organizationRole: SystemGroupRoleEnum;
  selfServiceEnabled: Scalars['Boolean'];
  systemGroupPermissions: Array<UserSystemGroupPermission>;
  systemPermissions: Array<UserSystemPermission>;
};

export type UserOrganizationPermissionNest = {
  __typename?: 'UserOrganizationPermissionNest';
  id: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  organizationRole: SystemGroupRoleEnum;
  selfServiceEnabled: Scalars['Boolean'];
  systemGroupPermissions: Array<UserSystemGroupPermissionNest>;
  systemPermissions: Array<UserSystemPermissionNest>;
};

export type UserStats = {
  __typename?: 'UserStats';
  activityCount: Scalars['Int'];
  user: UserNest;
};

export type UserSystemGroupPermission = {
  __typename?: 'UserSystemGroupPermission';
  id: Scalars['ID'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
};

export type UserSystemGroupPermissionNest = {
  __typename?: 'UserSystemGroupPermissionNest';
  id: Scalars['String'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemGroupId: Scalars['Int'];
};

export type UserSystemPermission = {
  __typename?: 'UserSystemPermission';
  id: Scalars['ID'];
  inheritedFromSystemGroupId?: Maybe<Scalars['Int']>;
  isTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemId: Scalars['Int'];
};

export type UserSystemPermissionNest = {
  __typename?: 'UserSystemPermissionNest';
  id: Scalars['String'];
  inheritedFromSystemGroupId?: Maybe<Scalars['Int']>;
  isTemplate: Scalars['Boolean'];
  name: Scalars['String'];
  role: SystemGroupRoleEnum;
  systemId: Scalars['Int'];
};

export type UsersInput = {
  organizationId: Scalars['Int'];
  where?: InputMaybe<UsersWhere>;
};

export type UsersWhere = {
  systemGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  systemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type ValidateLabImportBatchInput = {
  batchId: Scalars['UUID'];
  profileDefinition?: InputMaybe<LabImportProfileDefinitionInput>;
  profileVersionId?: InputMaybe<Scalars['UUID']>;
};

export enum ValueType {
  Boolean = 'BOOLEAN',
  Numeric = 'NUMERIC',
  Text = 'TEXT'
}

/** Version Types */
export enum VersionEnum {
  V1 = 'v1',
  V2 = 'v2'
}

export type WaterlyConnectErrorStatsByMonth = {
  __typename?: 'WaterlyConnectErrorStatsByMonth';
  /** This is a zero-based view of the month described in the id.  The first day of the month will be the 0th element of the list */
  errorCountByDay: Array<Scalars['Int']>;
  /** This ID is the ISO-formatted, UTC representation fo the first day of a month. For instance, 2022-08-01T00:00:00.000Z */
  id: Scalars['ID'];
};

export type WaterlyConnectQueueJobCountByEdgeDevice = {
  __typename?: 'WaterlyConnectQueueJobCountByEdgeDevice';
  activeCount: Scalars['Int'];
  edgeDeviceId: Scalars['Int'];
  edgeDeviceName: Scalars['String'];
  waitingCount: Scalars['Int'];
};

export type WaterlyConnectStats = {
  __typename?: 'WaterlyConnectStats';
  activeQueueJobCount: Scalars['Int'];
  countLast24HourSubmissions: Scalars['Int'];
  countLast24HourSubmissionsFailed: Scalars['Int'];
  countLast24HourSubmissionsSuccessful: Scalars['Int'];
  id: Scalars['Int'];
  queueJobCountsByEdgeDevice: Array<WaterlyConnectQueueJobCountByEdgeDevice>;
  waitingQueueJobCount: Scalars['Int'];
};

export type WeatherDataStationIdInput = {
  id: Scalars['UUID'];
};

export type WeatherDataStationNest = {
  __typename?: 'WeatherDataStationNest';
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  latitude: Scalars['Float'];
  locationName: Scalars['String'];
  longitude: Scalars['Float'];
  stateCode?: Maybe<Scalars['String']>;
  usgsStationId?: Maybe<Scalars['String']>;
};
